// import { useNavigate, useSearchParams } from "react-router-dom";
// import styles from "./ProductionSale.module.css";
// import React, {
//   useCallback,
//   useEffect,
//   useMemo,
//   useRef,
//   useState,
// } from "react";
// import fetchData from "../../APIsControll/apiControll";
// import { useAuth } from "../../components/context/Auth";
// import InputTag from "../../components/updatedComponents/FormComponents/InputTag";
// import Skeleton from "../../components/updatedComponents/Skeleton/Skeleton";
// import SearchDealer from "../../components/updatedComponents/OrderManager/SearchDealer";
// import DealerAddressModal from "../../components/updatedComponents/OrderManager/DealerAddressModal";
// import AdduserModel from "../../components/updatedComponents/models/AdduserModel";
// import ModalWrapper from "../../components/updatedComponents/layoutWrapper/ModalWrapper";
// import {
//   CancelIcon2,
//   DividerIcon,
//   EditManagerIcon,
//   InfoRounded,
//   NewEyeIcon,
//   RemoveIcon,
//   SaveIcon,
//   ShareIcon,
//   TestTopAddDealerIcon,
// } from "../../components/icons/Icon";
// import ItemList from "../../components/updatedComponents/OrderManager/ItemList";
// import ManagerModal from "../../components/updatedComponents/Manager/ManagerModal";
// import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
// import OrderSuccessModal from "../../components/updatedComponents/OrderManager/OrderSuccessModal";
// import ShareLinkModal from "../../components/updatedComponents/OrderManager/ShareLinkModal";
// import AddReceiptModal from "../../components/updatedComponents/OrderManager/AddReceiptModal";
// import { handleFileData } from "../../APIsControll/apiControl2";
// import Button from "../../components/updatedComponents/Dealers/Button";
// import RequestForCancelModal from "../../components/updatedComponents/OrderManager/RequestForCancelModal";
// import Spinner from "../../components/updatedComponents/FormComponents/Spinner";
// import ConfirmOrder from "../../components/updatedComponents/OrderManager/ConfirmOrder";
// import Warning from "../../components/updatedComponents/Receipts/Warning";
// import ShippingTypeModal from "../../components/updatedComponents/OrderManager/ShippingTypeModal";
// import Selection from "../../components/updatedComponents/OrderManager/Selection";
// // import ShippingChargesInfoModal from "../../components/updatedComponents/OrderManager/ShippingChargesInfoModal";
// // import ShippingChargesModal2 from "../../components/updatedComponents/OrderManager/ShippingChargesModal2";
// import { useDispatch } from "react-redux";
// import { setFilter } from "../../store/slices/order/OrderSlice";
// import SelectDM from "../../components/updatedComponents/OrderManager/SelectDM";
// import { getStatusColor } from "../../Utils/Utils";
// import SelectWarehouse from "../../components/updatedComponents/OrderManager/SelectWarehouse";
// import MoreDropdown from "../dispatchmanager/MoreDropdown";
// import { useReactToPrint } from "react-to-print";
// import NewSummarySlip from "../dispatchmanager/NewSummarySlip";
// import AdvanceAmountModalInfo from "../../components/updatedComponents/OrderManager/AdvanceAmountModalInfo";
// import ProductionSaleNewItemList from "../../components/updatedComponents/OrderManager/ProductionSaleNewItemList";
// import SlidingFilter from "../../components/updatedComponents/Dealers/SlidingFilter";
// import { versions, VesionsList } from "../hrm/HrmData";
// import ProSaleShippingChargesModal from "../../components/updatedComponents/OrderManager/ProSaleShippingChangesModal";
// import ProSaleShippingChargesModal2 from "../../components/updatedComponents/OrderManager/ProSaleShippingChangesModal2";
// import DataItemListProAndSale from "../../components/updatedComponents/OrderManager/DataItemListProAndSale";

// // ─── UID generator (frontend-only, never sent to API) ───────────────────────
// let _uidCounter = 0;
// const genUid = () => `item-${++_uidCounter}-${Date.now()}`;

// // Who/when for a version tab — uses the last change entry in that version
// const getVersionMeta = (versionEntry) => {
//   const last = versionEntry?.items?.[versionEntry.items.length - 1];
//   return {
//     updatedBy: last?.updatedBy || "",
//     updateTime: last?.updateTime || "",
//     action: last?.action || "",
//   };
// };

// const ProductionSale = ({ onOrderData }) => {
//   const { managerId, mode, designation } = useAuth();

//   const dispatch = useDispatch();

//   const { show } = useToast();
//   const navigate = useNavigate();
//   const [searchParams] = useSearchParams();
//   const orderId = searchParams.get("orderId")
//     ? searchParams.get("orderId")
//     : "";

//   const dealerInpRef = useRef(null);
//   const locationRef = useRef(null);
//   const scroll_wrapper_ref = useRef(null);
//   const itemInpRefs = useRef([]);
//   const qtyInputRefs = useRef([]);
//   const shippingRef = useRef(null);
//   const checkboxRef = useRef(null);
//   const dispatchManagersRef = useRef();
//   const summarySlipRef = useRef(null);

//   const initialItemDetails = useMemo(
//     () => ({
//       _uid: genUid(), // frontend-only, stripped before API calls
//       amount: 0,
//       collection_name: "",
//       desc: "",
//       descKey: "",
//       dp: 0,
//       itemNo: "",
//       price: 0,
//       product_name: "",
//       qty: 0,
//       thumbnail: "",
//       totalQty: "",
//       unit: "",
//       vm: 0,
//       warehouse: "",
//       weight: 0,
//     }),
//     [],
//   );

//   const initialReceiptData = useMemo(
//     () => ({
//       paymentMethod: "Cash",
//       transactionScreenshot: "",
//       paymentAmount: "",
//       transactionId: "",
//       accountNumber: "",
//       totalAmount: "",
//       receiptId: "",
//       paymentType: "Cash",
//       warehousename: "",
//       warehouseId: "",
//     }),
//     [],
//   );

//   const [generalInfo, setGeneralInfo] = useState({
//     warehouses: [],
//     selectedDMs: [],
//   });
//   const [itemDetails, setItemDetails] = useState([initialItemDetails]);

//   // ── Version History state ─────────────────────────────────────────────

//   const [selectedVersion, setSelectedVersion] = useState(null);
//   const [versionsData, setVersionsData] = useState([]);
//   // ────────────────────────────────────────────────────────────────────────

//   const flag = useMemo(() => {
//     if (!orderId) {
//       return "create";
//     }
//     if (orderId && generalInfo.status === "Payment Pending") {
//       return "edit";
//     }
//     if (orderId && generalInfo.status !== "Payment Pending") {
//       return "view";
//     }
//     return "";
//   }, [orderId, generalInfo.status]);

//   const [loading, setLoading] = useState(false);
//   const [showSave, setShowSave] = useState(false);
//   const [loadingBtn, setLoadingBtn] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);

//   const [receipts, setReceiptsInfo] = useState([]);

//   const [accounts, setAccounts] = useState([]);
//   const [warehouses, setWarehouses] = useState([]);
//   const [dispatchManagers, setDispatchManagers] = useState([]);
//   const [methodPartners, setMethodPartners] = useState([]);

//   const [showDealerSearch, setShowDealerSearch] = useState(
//     flag === "create" ? true : false,
//   );
//   const [searchDealer, setSearchDealer] = useState("");
//   const [dealerLoading, setDealerLoading] = useState(false);
//   const [dealerResults, setDealerResults] = useState([]);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [updatedAddress, setUpdatedAddress] = useState(null);
//   const [useFallback, setUseFallback] = useState(true);

//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [modalContent, setModalContent] = useState(null);

//   const [focusedItemIndex, setFocusedItemIndex] = useState(0);
//   const [showItemSearch, setShowItemSearch] = useState(false);

//   const [receiptData, setReceiptData] = useState(initialReceiptData);
//   const [paymentLink, setPaymentLink] = useState("");

//   const [skipped, setSkipped] = useState(false);
//   const [isNoCase, setIsNoCase] = useState(false);

//   const [shouldFocus, setShouldFocus] = useState(true);
//   const [showDescriptionInput, setShowDescriptionInput] = useState(false);

//   const [isManagerAssigned, setIsManagerAssigned] = useState(true);
//   const [isShippingBlocked, setIsShippingBlocked] = useState(false);
//   const [isPodBlocked, setIsPodBlocked] = useState(false);
//   const [orderManagers, setOrderManagers] = useState([]);
//   const [shippingType, setShippingType] = useState("Combined");
//   const [dispatchWarehouse, setDispatchWarehouse] = useState();

//   const [shippingAddress, setShippingAddress] = useState({});
//   const [allOrdersData, setAllOrdersData] = useState([{}]);

//   const initialShippingDetails = {
//     methodId: "",
//     shippingCharge: 0,
//     courierName: "Pick Up",
//     methodName: "Self",
//     partnerName: "Self",
//     warehousename: "",
//     warehouseId: "",
//     isDispatchWarehouse: false,
//     delInstruction: "",
//   };

//   const [shippingInfo, setShippingInfo] = useState([initialShippingDetails]);
//   const [instructions, setInstructions] = useState({});
//   const [uniqueWarehouses, setUniqueWarehouses] = useState([]);
//   const [receiptTotalAmount, setReceiptTotalAmount] = useState();

//   const shippingInfoRef = useRef(shippingInfo);

//   useEffect(() => {
//     shippingInfoRef.current = shippingInfo;
//   }, [shippingInfo]);

//   useEffect(() => {
//     dispatchManagersRef.current = dispatchManagers;
//   }, [dispatchManagers]);

//   useEffect(() => {
//     if (shouldFocus) {
//       dealerInpRef.current?.focus();
//     } else {
//       dealerInpRef.current?.blur();
//     }
//   }, [shouldFocus]);

//   useEffect(() => {
//     if (flag === "create") {
//       setGeneralInfo((prevState) =>
//         Object.keys(prevState).reduce((acc, key) => {
//           acc[key] = 0;
//           return acc;
//         }, {}),
//       );
//       setReceiptData(initialReceiptData);
//       setItemDetails([{ ...initialItemDetails, _uid: genUid() }]);
//       setDispatchManagers([]);
//       setShowDescriptionInput(false);
//       itemInpRefs.current = [];
//       qtyInputRefs.current = [];
//       setFocusedItemIndex(null);
//       setDealerResults([]);
//       setMethodPartners([]);
//       setIsNoCase(false);
//       setShouldFocus(true);
//       setSearchDealer("");
//       setShowItemSearch(false);
//       setIsEditMode(false);
//       setReceiptsInfo([]);
//       setAccounts([]);
//       setWarehouses([]);
//       setPaymentLink("");
//       setIsModalOpen(false);
//       setModalContent(null);
//       setSkipped(false);
//       setShowSave(false);
//       setLoading(false);
//       setLoadingBtn(false);
//       setIsManagerAssigned(true);
//       setIsShippingBlocked(false);
//       setIsPodBlocked(false);
//       setOrderManagers([]);
//       dispatch(setFilter({ selectedOption: "" }));
//       setShippingAddress({});
//       setShippingInfo([]);
//       setReceiptTotalAmount();
//       // ── reset version history state for a fresh "create" form ──────────
//       setVersionsData([]);
//       setSelectedVersion(null);
//       // ─────────────────────────────────────────────────────────────────
//     }
//   }, [dispatch, flag, initialItemDetails, initialReceiptData]);

//   const fetchOrder = useCallback(async () => {
//     setLoading(true);
//     try {
//       const apiData = {
//         managerId: managerId,
//         voucherId: orderId,
//         // warehousename: "",
//       };
//       const result = await fetchData("order/prodAndSalesVoucher", apiData);

//       if (result.status === "success") {
//         setLoading(false);
//         setAllOrdersData(result?.data);
//         if (result?.data?.voucher) {
//           setGeneralInfo((prevState) => ({
//             ...prevState,
//             dealerId: result?.data?.voucher?.dealerId,
//             storeName: result?.data?.voucher?.storeName,
//             dealerName: result?.data?.voucher?.name,
//             createdBy: result?.data?.voucher?.createdBy,
//             billingAddress: result?.data?.voucher?.billingAddress,
//             shippingCharge: result?.data?.voucher?.totalShippingCharge,
//             totalAmount: result?.data?.voucher?.totalAmount,
//             subtotal: result?.data?.voucher?.subtotal,
//             courierName: result?.data?.voucher?.courierName,
//             mobile: result?.data?.voucher?.shippingAddress?.mobile
//               ? result?.data?.voucher?.shippingAddress?.mobile
//               : result?.data?.voucher?.DealerInfo?.whatsapp,
//             whatsapp: result?.data?.voucher?.DealerInfo?.whatsapp
//               ? result?.data?.voucher?.DealerInfo?.whatsapp
//               : result?.data?.voucher?.shippingAddress?.mobile,
//             email: result?.data?.voucher?.DealerInfo?.email
//               ? result?.data?.voucher?.DealerInfo?.email
//               : "",
//             orderManagerName: result?.data?.voucher?.orderManagerName,
//             dmId: result?.data?.voucher?.dmId,
//             dmName: result?.data?.voucher?.dmName,
//             orderDate: result?.data?.voucher?.voucherDate,
//             orderId: result?.data?.voucher?.voucherId,
//             status: result?.data?.voucher?.status,
//             orderType: result?.data?.voucher?.voucherType,
//             toPay: result?.data?.voucher?.shippingInfo?.toPay,
//             dispatchStatus: result?.data?.voucher?.dispatchStatus,
//             reqType: result?.data?.voucher?.reqType,
//             // deliveryPartners: result?.data?.voucher?.shippingInfo?.map((d) => ({
//             //   label: d.methodName,
//             //   value: d.methodName,
//             // })),

//             deliveryPartners: {
//               label: result?.data?.voucher?.shippingInfo?.methodName,
//               value: result?.data?.voucher?.shippingInfo?.methodName,
//             },
//           }));
//           // setUniqueWarehouses(
//           //   result?.data?.voucher?.shippingInfo?.map((d) => ({
//           //     label: d.warehousename,
//           //     value: d.warehouseId,
//           //   })),
//           // );
//           // setDispatchManagers(
//           //   result.data.dispatchmanagers.map((d) => ({
//           //     label: d.name,
//           //     value: d.managerId,
//           //     warehousename: d.warehousename,
//           //     warehouseId: d.warehouseId,
//           //   })),
//           // );
//           // setDispatchWarehouse(() => {
//           //   if (shippingType !== "Separate") {
//           //     const dispatchWarehouse = result?.data?.voucher?.shippingInfo?.find(
//           //       (d) => d.isDispatchWarehouse === true,
//           //     );
//           //     return dispatchWarehouse
//           //       ? {
//           //           label: dispatchWarehouse.warehousename || "",
//           //           value: dispatchWarehouse.warehouseId || "",
//           //         }
//           //       : { label: "", value: "" };
//           //   }

//           //   return { label: "", value: "" };
//           // });
//           // setReceiptData((prev) => {
//           //   const warehouse =
//           //     shippingType !== "Separate"
//           //       ? result?.data?.voucher?.shippingInfo?.find(
//           //           (d) => d.isDispatchWarehouse === true,
//           //         ) || ""
//           //       : "";

//           //   return {
//           //     ...prev,
//           //     warehousename: warehouse.warehouseId,
//           //     warehouseId: warehouse.warehouseId,
//           //   };
//           // });
//           setShippingInfo(result.data.voucher.shippingInfo);
//           setShippingAddress(result?.data?.voucher?.shippingAddress);

//           // ── Stamp each item with a frontend-only _uid ──────────────────
//           const stampedItems = result?.data?.voucher?.items.map((item) => ({
//             ...item,
//             _uid: genUid(),
//           }));
//           setItemDetails(stampedItems);
//           // ───────────────────────────────────────────────────────────────

//           // ── Version History ────────────────────────────────────────────
//           if (result?.data?.voucher?.itemsHistory) {
//             setVersionsData(result.data.voucher.itemsHistory);
//           } else {
//             setVersionsData([]);
//           }
//           setSelectedVersion(null);
//           // ────────────────────────────────────────────────────────────────

//           setReceiptsInfo(result?.data?.receipts);
//           setIsPodBlocked(
//             result?.data?.voucher?.DealerInfo?.podBlock ? true : false,
//           );
//           setIsShippingBlocked(
//             result?.data?.voucher?.DealerInfo?.shippingBlock ? true : false,
//           );
//           setShippingType(result.data.voucher.shippingType);
//         }
//         if (result.data.accounts) {
//           setAccounts(result.data.accounts);
//         }
//       }
//     } catch {
//     } finally {
//       setLoading(false);
//     }
//   }, [managerId, orderId, shippingType]);

//   const fetchOrderRef = useRef(fetchOrder);
//   fetchOrderRef.current = fetchOrder;

//   useEffect(() => {
//     if (managerId && (flag === "edit" || flag === "view")) {
//       fetchOrder();
//     }
//   }, [fetchOrder, flag, managerId, orderId, shippingType]);

//   const fetchDMs = useCallback(
//     async (warehouse, oID) => {
//       try {
//         const apiData = {
//           managerId: managerId,
//           orderId: orderId || oID,
//           wareHouse: warehouse,
//         };

//         const result = await fetchData("order/order", apiData);

//         if (result.status === "success") {
//           if (result.data.warehouses) {
//             setWarehouses(result.data.warehouses);
//           }

//           if (warehouse === "") {
//             if (result.data.accounts) {
//               setAccounts(result.data.accounts);
//               return result.data.accounts;
//             } else {
//               setAccounts([]);
//               return [];
//             }
//           } else {
//             if (result.data.dispatchmanagers?.length > 0) {
//               setDispatchManagers(
//                 result.data.dispatchmanagers.map((d) => ({
//                   label: d.name,
//                   value: d.managerId,
//                   warehousename: d.warehousename,
//                   warehouseId: d.warehouseId,
//                 })),
//               );
//             }
//           }
//         }
//       } catch (error) {}
//     },
//     [managerId, orderId],
//   );

//   const fetchDealer = useCallback(async () => {
//     try {
//       setDealerLoading(true);
//       const apiData = {
//         managerId: managerId,
//         keyword: searchDealer,
//       };

//       const result = await fetchData("order/finddealer", apiData);

//       if (result.status === "success") {
//         setDealerResults(result.data);
//       }
//       setDealerLoading(false);
//     } catch (error) {
//       setDealerLoading(false);
//     }
//   }, [managerId, searchDealer]);

//   useEffect(() => {
//     if (searchDealer) {
//       const delayDebounceFn = setTimeout(() => {
//         fetchDealer();
//       }, 700);

//       return () => clearTimeout(delayDebounceFn);
//     }
//   }, [searchDealer, fetchDealer]);

//   const handleDealerKeyDown = (e) => {
//     if (showDealerSearch) {
//       if (e.key === "ArrowDown") {
//         setCurrentIndex((prevIndex) =>
//           prevIndex < dealerResults?.length - 1 ? prevIndex + 1 : prevIndex,
//         );
//         e.preventDefault();
//       }

//       if (e.key === "ArrowUp") {
//         setCurrentIndex((prevIndex) =>
//           prevIndex > 0 ? prevIndex - 1 : prevIndex,
//         );
//         e.preventDefault();
//       }

//       if ((e.altKey || e.metaKey) && e.key.toLowerCase() === "c") {
//         setSearchDealer("");
//         setTimeout(() => {
//           openAddDealerModal();
//         }, 100);
//       }

//       if (!dealerLoading) {
//         if (e.key === "Enter") {
//           e.preventDefault();
//           handleSelectDealer(dealerResults && dealerResults[currentIndex]);
//         }
//       }
//     }
//   };

//   const openAddDealerModal = () => {
//     handleOpenModal(
//       <AdduserModel
//         focus={true}
//         close={() => handleCloseModal()}
//         onDealerAdd={(newDealer) => handleSelectDealer(newDealer)}
//       />,
//     );
//   };

//   const editBtnClick = useCallback(
//     (d) => {
//       setIsEditMode(true);
//       handleOpenModal(
//         <DealerAddressModal
//           name={"dealer_address_modal"}
//           shippingAddress={
//             shippingAddress.street ||
//             shippingAddress.city ||
//             shippingAddress.district ||
//             shippingAddress.state ||
//             shippingAddress.pincode
//               ? [
//                   shippingAddress.street,
//                   shippingAddress.city,
//                   shippingAddress.district,
//                   shippingAddress.state,
//                   shippingAddress.pincode,
//                 ]
//                   .filter(Boolean)
//                   .join(" ")
//               : undefined
//           }
//           ref={locationRef}
//           handleCloseModal={() => handleCloseModal()}
//           onAddressUpdate={(data) => {
//             if (!isModalOpen) {
//               setTimeout(() => {
//                 updateShippingAddress(d, data);
//                 itemInpRefs?.current[0]?.focus();
//               }, 0);
//             }
//           }}
//           mode={mode}
//           onKeyPress={() => {
//             if (!isModalOpen) {
//               setTimeout(() => {
//                 itemInpRefs?.current[0]?.focus();
//               }, 0);
//             }
//           }}
//         />,
//       );
//     },
//     [
//       isModalOpen,
//       mode,
//       shippingAddress.city,
//       shippingAddress.district,
//       shippingAddress.pincode,
//       shippingAddress.state,
//       shippingAddress.street,
//     ],
//   );

//   const handleSelectDealer = (d) => {
//     let doesHaveAddress = false;

//     if (!d) {
//       console.error("Dealer data is undefined!");
//       return;
//     }

//     if (
//       d.street === "" ||
//       d.city === "" ||
//       d.district === "" ||
//       d.state === "" ||
//       d.pincode === ""
//     ) {
//       doesHaveAddress = true;
//     }

//     if (d.assignedManagerId === "") {
//       setIsManagerAssigned(false);
//     }

//     if (d.shippingBlock === true) {
//       setIsShippingBlocked(true);
//     }

//     if (d.podBlock === true) {
//       setIsPodBlocked(true);
//     }

//     setSearchDealer(
//       d.name && d.storeName
//         ? `${d.storeName} / ${d.name}`
//         : d.name || d.storeName || "",
//     );

//     if ("refcode" in d) {
//       updateGeneralInfo(d);
//       updateShippingAddress(d);
//     } else {
//       handleOpenModal(
//         <DealerAddressModal
//           name={"dealer_address_modal"}
//           shippingAddress={
//             d.street || d.city || d.district || d.state || d.pincode
//               ? [d.street, d.city, d.district, d.state, d.pincode]
//                   .filter(Boolean)
//                   .join(" ")
//               : undefined
//           }
//           form={doesHaveAddress}
//           ref={locationRef}
//           handleCloseModal={() => handleCloseModal()}
//           onAddressUpdate={(data) => {
//             setUpdatedAddress(data);
//             updateGeneralInfo(d);
//             updateShippingAddress(d, data);
//           }}
//           mode={mode}
//           onKeyPress={(e) => {
//             e.preventDefault();
//             e.stopPropagation();
//             updateGeneralInfo(d);
//             updateShippingAddress(d, updatedAddress);
//           }}
//           focus={true}
//         />,
//       );
//     }
//   };

//   const updateGeneralInfo = (d) => {
//     if (d?.name === "Cash") {
//       setGeneralInfo((prevState) => ({
//         ...prevState,
//         dealerId: d?.dealerId,
//         dealerName: d?.name,
//         storeName: d?.storeName,
//         mobile: d?.mobile,
//         whatsapp: d?.whatsapp,
//         email: d?.email,
//         gstuin: d?.gstuin ? d?.gstuin : "",
//         assignedManagerId: d?.assignedManagerId || d?.refcode,
//         shippingType: "Standard",
//         courierName: "Pick Up",
//         partnerName: "Self",
//       }));
//     } else {
//       setGeneralInfo((prevState) => ({
//         ...prevState,
//         dealerId: d?.dealerId,
//         dealerName: d?.name,
//         storeName: d?.storeName,
//         mobile: d?.mobile,
//         whatsapp: d?.whatsapp,
//         email: d?.email,
//         gstuin: d?.gstuin,
//         assignedManagerId: d?.assignedManagerId || d?.refcode,
//         billingAddress:
//           (d?.street || d?.city || d?.district || d?.state || d?.pincode) &&
//           [d?.street, d?.city, d?.district, d?.state, d?.pincode]
//             .filter(Boolean)
//             .join(" "),
//       }));
//     }
//     itemInpRefs.current[0]?.focus();
//   };

//   const updateShippingAddress = (dealer, address) => {
//     setShippingAddress((prevState) => ({
//       ...prevState,
//       mobile: dealer?.mobile,
//       name: dealer?.name,
//       storeName: dealer?.storeName,
//       pincode: address?.pinCode || dealer?.pincode,
//       street: address?.streetAddress || dealer?.street,
//       city: address?.city || dealer?.city,
//       district: address?.district || dealer?.district,
//       state: address?.state || dealer?.state,
//     }));
//   };

//   const handleFocusNextItem = () => {
//     setShouldFocus(false);
//     setShowDescriptionInput(false);
//     setTimeout(() => {
//       const lastItemIndex = itemDetails?.length - 1;

//       if (itemInpRefs?.current?.length) {
//         const nextItemIndex = lastItemIndex + 1;

//         if (nextItemIndex < itemInpRefs?.current?.length) {
//           const nextItemRef = itemInpRefs?.current[nextItemIndex];
//           nextItemRef?.focus();
//           setFocusedItemIndex(nextItemIndex);
//         }
//       }
//     }, 0);
//     if (flag === "create") {
//       setShowItemSearch(true);
//     }
//   };

//   const handleItemInputFocus = (index) => {
//     setFocusedItemIndex(index);
//   };

//   const handleItemInputBlur = () => {
//     setTimeout(() => {
//       setShowItemSearch(false);
//       setFocusedItemIndex(null);
//     }, 200);
//   };

//   const handleItemChange = async (index, field, value) => {
//     setItemDetails((prevItems) => {
//       const updatedItems = [...prevItems];
//       const previousItem = { ...updatedItems[index] };

//       updatedItems[index] = { ...updatedItems[index], [field]: value };

//       if (field === "warehouseId") {
//         const oldWarehouseId = previousItem.warehouseId;
//         const newWarehouseId = value;
//         const newWarehouseName = updatedItems[index].warehouse;

//         setGeneralInfo((prevState) => {
//           const currentList = prevState.warehouses || [];

//           const isOldWarehouseStillUsed = updatedItems.some(
//             (item, i) => i !== index && item.warehouseId === oldWarehouseId,
//           );

//           let updatedList = [...currentList];

//           if (newWarehouseId && !updatedList.includes(newWarehouseId)) {
//             updatedList.push(newWarehouseId);
//           }

//           if (oldWarehouseId && !isOldWarehouseStillUsed) {
//             updatedList = updatedList.filter((wh) => wh !== oldWarehouseId);
//           }

//           return {
//             ...prevState,
//             warehouses: updatedList,
//           };
//         });

//         setShippingInfo((prevShipping) => {
//           let updatedShipping = [...prevShipping];

//           const isOldWarehouseStillUsed = updatedItems.some(
//             (item, i) => i !== index && item.warehouseId === oldWarehouseId,
//           );

//           if (oldWarehouseId && !isOldWarehouseStillUsed) {
//             updatedShipping = updatedShipping.filter(
//               (item) => item.warehouseId !== oldWarehouseId,
//             );
//           }

//           const newWarehouseExists = updatedShipping.some(
//             (item) => item.warehouseId === newWarehouseId,
//           );

//           if (!newWarehouseExists && newWarehouseId && newWarehouseName) {
//             updatedShipping.push({
//               ...initialShippingDetails,
//               warehouseId: newWarehouseId,
//               warehousename: newWarehouseName,
//             });
//           }

//           return updatedShipping;
//         });
//       }

//       return updatedItems;
//     });
//   };

//   const removeItem = (index) => {
//     setItemDetails((prevItems) => {
//       const itemToRemove = prevItems[index];
//       const updatedItems = prevItems.filter((_, i) => i !== index);

//       if (itemToRemove?.warehouseId) {
//         const isWarehouseStillUsed = updatedItems.some(
//           (item) => item.warehouseId === itemToRemove.warehouseId,
//         );

//         if (!isWarehouseStillUsed) {
//           setShippingInfo((prevShipping) =>
//             prevShipping.filter(
//               (item) => item.warehouseId !== itemToRemove.warehouseId,
//             ),
//           );
//         }
//       }

//       return updatedItems;
//     });
//   };

//   const handleAddNewItem = () => {
//     const errors = [];

//     if (!itemDetails || itemDetails.length === 0) {
//       errors.push("No items to validate");
//     } else {
//       itemDetails.forEach((item, index) => {
//         if (item.outsourcedItem === "Disable") {
//           if (!item.itemNo)
//             errors.push(`Item ${index + 1}: Item Number cannot be empty`);
//           if (!item.qty)
//             errors.push(`Item ${index + 1}: Quantity cannot be empty`);
//           if (item.qty > item.totalQty) {
//             errors.push(
//               `Item ${index + 1}: Quantity exceeds available stock (${
//                 item.totalQty
//               })`,
//             );
//           }
//         } else if (item.outsourcedItem === "Active") {
//           if (!item.itemNo)
//             errors.push(`Item ${index + 1}: Item Number cannot be empty`);
//           if (!item.qty)
//             errors.push(`Item ${index + 1}: Quantity cannot be empty`);
//           if (item.qty > item.outSourceItemlimit) {
//             errors.push(
//               `Item ${index + 1}: Quantity exceeds limit (${
//                 item.outSourceItemlimit
//               })`,
//             );
//           }
//         }
//       });
//     }

//     if (errors.length > 0) {
//       show(errors.join("\n"), "warning");
//     } else {
//       // ── New item gets a fresh UID ──────────────────────────────────────
//       setItemDetails((prev) => [
//         ...prev,
//         { ...initialItemDetails, _uid: genUid() },
//       ]);
//       // ──────────────────────────────────────────────────────────────────
//       handleFocusNextItem();

//       setTimeout(() => {
//         scroll_wrapper_ref.current?.scrollBy({
//           top: 100,
//           behavior: "smooth",
//         });
//       }, 100);
//     }
//   };

//   const handleOpenModal = (content) => {
//     setShouldFocus(false);
//     setIsModalOpen(true);
//     setModalContent(content);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setModalContent(null);
//   };

//   const handleAddReceipt = useCallback(
//     async (updatedData, newOrderId, receiptId) => {
//       const formData = new FormData();
//       formData.append(
//         "transactionScreenshot",
//         updatedData.transactionScreenshot
//           ? updatedData.transactionScreenshot
//           : "",
//       );
//       formData.append(
//         "paymentMethod",
//         updatedData.paymentMethod ? updatedData.paymentMethod : "",
//       );
//       formData.append(
//         "paymentType",
//         updatedData.paymentType ? updatedData.paymentType : "",
//       );
//       formData.append(
//         "paymentAmount",
//         updatedData.paymentAmount
//           ? parseFloat(updatedData.paymentAmount).toFixed(2)
//           : "",
//       );
//       formData.append(
//         "transactionId",
//         updatedData.transactionId ? updatedData.transactionId : "",
//       );
//       formData.append(
//         "accountNumber",
//         updatedData.accountNumber ? updatedData.accountNumber : "",
//       );
//       formData.append(
//         "warehousename",
//         updatedData.warehousename ? updatedData.warehousename : "",
//       );
//       formData.append(
//         "totalAmount",
//         generalInfo.totalAmount ? generalInfo.totalAmount.toFixed(2) : "",
//       );

//       const orderIdentifier = newOrderId || orderId;

//       try {
//         const result = await handleFileData(
//           `receipt/offlinePay/${managerId}/${orderIdentifier}?receiptId=${
//             receiptId && receiptId
//           }`,
//           formData,
//         );
//         if (result.status === "success") {
//           show(result.msg, "success");
//           handleCloseModal();
//           setTimeout(async () => {
//             await fetchOrderRef.current();
//           }, 0);
//         }
//         if (result.status === "warning") {
//           setModalContent(
//             <Warning
//               message={result?.msg}
//               items={result?.items}
//               orderdItems={result?.orderdItems}
//               mode={mode}
//               handleCloseModal={handleCloseModal}
//             />,
//           );
//         }
//         if (result.status === "warn") {
//           show(result.msg, "error");
//         }
//         if (result.status === "failed") {
//           show(result.msg, "error");
//         }
//       } catch (error) {}
//     },
//     [generalInfo.totalAmount, managerId, mode, orderId, show],
//   );

//   const updateReceiptData = useCallback(
//     (updatedData, newOrderId, receiptId) => {
//       setReceiptData(updatedData);
//       setTimeout(async () => {
//         handleAddReceipt(updatedData, newOrderId, receiptId);
//       }, 0);
//     },
//     [handleAddReceipt],
//   );

//   const isSelf = shippingInfo?.methodName === "Self";

//   const orderSuccessKeyPress = useCallback(
//     (action, link, oID, acc) => {
//       const whatsappNo = generalInfo?.whatsapp || "Not Provided";
//       const mobileNo = generalInfo?.mobile || "Not Provided";
//       const email = generalInfo?.email || "Not Provided";
//       const generatedLink = link || paymentLink || "No Link Available";
//       const newOrderId = orderId || oID || "No Order Id Available";
//       const accounts2 = acc || accounts;

//       if (action === "shareLink") {
//         setTimeout(() => {
//           handleOpenModal(
//             <ShareLinkModal
//               mode={mode}
//               managerId={managerId}
//               handleCloseModal={handleCloseModal}
//               generatedLink={generatedLink}
//               whatsappNo={whatsappNo}
//               mobileNo={mobileNo}
//               email={email}
//               isModalOpen={true}
//             />,
//           );
//         }, 0);
//       } else if (action === "addReceipt") {
//         setTimeout(() => {
//           handleOpenModal(
//             <AddReceiptModal
//               handleCloseModal={handleCloseModal}
//               mode={mode}
//               totalAmount={generalInfo.totalAmount}
//               accounts={accounts2}
//               receiptData={receiptData && receiptData}
//               updateReceiptData={async (updatedData) =>
//                 updateReceiptData(updatedData, newOrderId)
//               }
//               type={"create"}
//               isPodBlocked={isPodBlocked}
//               uniqueWarehouses={uniqueWarehouses}
//               shippingType={shippingType}
//               dispatchWarehouse={dispatchWarehouse}
//               setReceiptData={setReceiptData}
//               isModalOpen={isModalOpen}
//               receiptTotalAmount={receiptTotalAmount}
//               isSelf={isSelf}
//             />,
//           );
//         }, 0);
//       }
//     },
//     [
//       generalInfo?.whatsapp,
//       generalInfo?.mobile,
//       generalInfo?.email,
//       generalInfo.totalAmount,
//       paymentLink,
//       orderId,
//       accounts,
//       mode,
//       managerId,
//       receiptData,
//       isPodBlocked,
//       uniqueWarehouses,
//       shippingType,
//       dispatchWarehouse,
//       isModalOpen,
//       receiptTotalAmount,
//       isSelf,
//       updateReceiptData,
//     ],
//   );

//   const generatePaymentLink = useCallback(
//     async (oId) => {
//       setPaymentLink("");
//       const currentOrderId = oId || orderId;
//       if (!currentOrderId) {
//         return;
//       }
//       try {
//         const apiData = { orderId: currentOrderId };
//         const result = await fetchData("receipt/generatePaymentLink", apiData);
//         if (result.status === "success" && result.shortUrl) {
//           const link = `${result.shortUrl}`;
//           setPaymentLink(link);
//           return link;
//         } else {
//         }
//       } catch (error) {}
//     },
//     [orderId],
//   );

//   // ── Strip _uid before sending to API ──────────────────────────────────────
//   const getValidSaleItems = (items) => {
//     return items
//       ?.filter((item) =>
//         Object.values(item).some(
//           (value) => value !== "" && value !== null && value !== undefined,
//         ),
//       )
//       .map(({ _uid, ...rest }) => rest); // _uid never reaches the API
//   };
//   // ──────────────────────────────────────────────────────────────────────────

//   const handleSaleOrder = useCallback(
//     async (status, id, s) => {
//       if (
//         generalInfo.partnerName === "" &&
//         generalInfo.methodName === "" &&
//         generalInfo.courierName === ""
//       ) {
//         show("Delivery details are required!", "error");
//         return;
//       }
//       const assignedManagerId = isManagerAssigned
//         ? generalInfo.assignedManagerId
//         : id;

//       try {
//         setLoading(true);

//         const shippingCharge =
//           generalInfo.deliveryPartner === "Self"
//             ? 0
//             : generalInfo.shippingCharge;

//         const apiData = {
//           managerId: managerId,
//           orderId: orderId,
//           gstuin: generalInfo.gstuin,
//           assignedManagerId: assignedManagerId,
//           dealerId: generalInfo.dealerId,
//           shippingType: shippingType,
//           name: shippingAddress.name,
//           street: shippingAddress.street,
//           mobile: shippingAddress.mobile,
//           pincode: shippingAddress.pincode,
//           city: shippingAddress.city,
//           district: shippingAddress.district,
//           state: shippingAddress.state,
//           shippingCharge: shippingCharge,
//           toPay: generalInfo.toPay || false,
//           saleItems: getValidSaleItems(itemDetails),
//           role: designation,
//           status: status,
//           shippingInfo: s,
//         };

//         const result = await fetchData("order/saleOrder", apiData);

//         if (result.status === "success") {
//           setLoading(false);

//           if (status === "success") {
//             if (!orderId) {
//               navigate(
//                 `/orders/order/productionAndSale?orderId=${result.data.orderId}`,
//               );
//             }
//             setShowSave(false);
//             setIsEditMode(false);
//             dispatch(setFilter({ selectedOption: "" }));
//             setShowItemSearch(false);

//             const oID = result.data.orderId;

//             setTimeout(async () => {
//               const link = await generatePaymentLink(oID);
//               const acc = await fetchDMs("", result.data.orderId);
//               setTimeout(() => {
//                 handleOpenModal(
//                   <OrderSuccessModal
//                     mode={mode}
//                     handleCloseModal={handleCloseModal}
//                     orderSuccessKeyPress={(action) =>
//                       orderSuccessKeyPress(action, link, oID, acc)
//                     }
//                   />,
//                 );
//               }, 100);
//             }, 100);
//           } else if (status === "draft") {
//             navigate("/orders");
//           }
//         } else if (result.status === "assignManager") {
//           setLoading(false);
//           dispatch(setFilter({ selectedOption: "" }));
//           setOrderManagers(result.orderManagers);
//         } else {
//           show(result.msg, "warning");
//           setLoading(false);
//         }
//       } catch (error) {
//         setLoading(false);
//       }
//     },
//     [
//       generalInfo.partnerName,
//       generalInfo.methodName,
//       generalInfo.courierName,
//       generalInfo.assignedManagerId,
//       generalInfo.deliveryPartner,
//       generalInfo.shippingCharge,
//       generalInfo.gstuin,
//       generalInfo.dealerId,
//       generalInfo.toPay,
//       isManagerAssigned,
//       show,
//       managerId,
//       orderId,
//       shippingType,
//       shippingAddress.name,
//       shippingAddress.street,
//       shippingAddress.mobile,
//       shippingAddress.pincode,
//       shippingAddress.city,
//       shippingAddress.district,
//       shippingAddress.state,
//       itemDetails,
//       designation,
//       dispatch,
//       navigate,
//       generatePaymentLink,
//       fetchDMs,
//       mode,
//       orderSuccessKeyPress,
//     ],
//   );

//   const handleInstructionChange = useCallback((warehouseId, instruction) => {
//     setShippingInfo((prev) => {
//       const updated = prev.map((s) =>
//         s.warehouseId === warehouseId
//           ? { ...s, delInstruction: instruction }
//           : s,
//       );
//       return updated;
//     });
//   }, []);

//   const handleSubmit = useCallback(() => {
//     handleOpenModal(
//       <ConfirmOrder
//         heading={"Confirm Order"}
//         centerHeading={"Are you sure want to place this Order?"}
//         targetWord={"order"}
//         handleCloseModal={() => handleCloseModal()}
//         handleSubmit={async (status, id) => {
//           await handleSaleOrder(status, id, shippingInfoRef.current);
//         }}
//         isManagerAssigned={isManagerAssigned}
//         orderManagers={orderManagers}
//         handleOpenModal={handleOpenModal}
//         shippingType={shippingType}
//         itemDetails={itemDetails}
//         setShippingInfo={setShippingInfo}
//         handleInstructionChange={handleInstructionChange}
//         instructions={instructions}
//         setInstructions={setInstructions}
//       />,
//     );
//   }, [
//     handleInstructionChange,
//     handleSaleOrder,
//     instructions,
//     isManagerAssigned,
//     itemDetails,
//     orderManagers,
//     shippingType,
//   ]);

//   const handleSkipShippingCharges = useCallback(
//     (dw) => {
//       if (shippingType === "Combined") {
//         setShippingInfo((prev) =>
//           prev.map((item) => ({
//             ...item,
//             isDispatchWarehouse: item.warehouseId === dw.value,
//           })),
//         );
//       } else {
//         setShippingInfo((prev) =>
//           prev.map((item) => ({
//             ...item,
//             isDispatchWarehouse: true,
//           })),
//         );
//       }
//       setGeneralInfo((prevState) => ({
//         ...prevState,
//         courierName: "Pick Up",
//         toPay: false,
//         deliveryPartners: prevState.deliveryPartners
//           ? [...prevState.deliveryPartners, { label: "Self", value: "Self" }]
//           : [{ label: "Self", value: "Self" }],
//       }));
//       setSkipped(true);
//     },
//     [shippingType],
//   );

//   if (skipped) {
//     setTimeout(() => {
//       handleSubmit();
//     }, 700);
//     setSkipped(false);
//   }

//   const openShippingChargesInfoModal = useCallback(
//     (s, dw, tempShippingInfo, uw) => {
//       setUniqueWarehouses(uw);
//       handleOpenModal(
//         <ProSaleShippingChargesModal
//           mode={mode}
//           handleCloseModal={handleCloseModal}
//           shippingType={s}
//           itemDetails={itemDetails}
//           shippingInfo={tempShippingInfo}
//           setShippingInfo={setShippingInfo}
//           dw={dw}
//           ref={checkboxRef}
//         />,
//       );
//     },
//     [itemDetails, mode],
//   );

//   const openSelectDMModal = useCallback(
//     (s, dw, tempShippingInfo, uw) => {
//       handleOpenModal(
//         <SelectDM
//           mode={mode}
//           handleCloseModal={handleCloseModal}
//           uniqueWarehouses={uw}
//           dispatchManagers={dispatchManagersRef.current}
//           setShippingInfo={setShippingInfo}
//           openShippingChargesInfoModal={() =>
//             openShippingChargesInfoModal(s, dw, tempShippingInfo, uw)
//           }
//         />,
//       );
//     },
//     [mode, openShippingChargesInfoModal],
//   );

//   const selectDispatchWarehouse = useCallback(
//     (value) => {
//       setDispatchWarehouse(value);
//       setReceiptData((prev) => ({
//         ...prev,
//         warehousename: value.label,
//         warehouseId: value.value,
//       }));
//       setShippingInfo((prev) => {
//         const updatedShippingInfo = prev.map((item) => ({
//           ...item,
//           isDispatchWarehouse:
//             item.warehouseId === value?.value ||
//             item.warehousename === value.label,
//         }));
//         return updatedShippingInfo;
//       });

//       setTimeout(() => {
//         setShippingInfo((prev) => {
//           fetchDMs(
//             prev.map(({ warehouseId, isDispatchWarehouse }) => ({
//               warehouseId,
//               isDispatchWarehouse,
//             })),
//             "",
//           );
//           return prev;
//         });
//       }, 0);
//     },
//     [fetchDMs],
//   );

//   const openShippingModal2 = useCallback(
//     (shippingType, type2) => {
//       handleOpenModal(
//         <ProSaleShippingChargesModal2
//           mode={mode}
//           orderId={orderId}
//           close={() => handleCloseModal()}
//           skipShippingCharges={(dw) => handleSkipShippingCharges(dw)}
//           itemsdetails={getValidSaleItems(itemDetails)}
//           isShippingBlocked={isShippingBlocked}
//           shippingType={shippingType}
//           pincode={shippingAddress.pincode}
//           shippingInfo={shippingInfo}
//           setShippingInfo={setShippingInfo}
//           openSelectDMModal={openSelectDMModal}
//           setGeneralInfo={setGeneralInfo}
//           type2={type2}
//           fetchDMs={(a, b) => fetchDMs(a, b)}
//           setDispatchWarehouse={setDispatchWarehouse}
//           selectDispatchWarehouse={selectDispatchWarehouse}
//         />,
//       );
//     },
//     [
//       mode,
//       orderId,
//       itemDetails,
//       isShippingBlocked,
//       shippingAddress.pincode,
//       shippingInfo,
//       openSelectDMModal,
//       selectDispatchWarehouse,
//       handleSkipShippingCharges,
//       fetchDMs,
//     ],
//   );

//   useEffect(() => {
//     if (isModalOpen && modalContent?.type === ConfirmOrder) {
//       handleSubmit();
//     }
//   }, [handleSubmit, isModalOpen, modalContent?.type]);

//   useEffect(() => {
//     if (flag === "edit" || flag === "view") {
//       generatePaymentLink(orderId);
//     }
//   }, [flag, generatePaymentLink, orderId]);

//   const handleCancelOrder = async () => {
//     const apiData = {
//       managerId: managerId,
//       orderId: orderId,
//     };
//     try {
//       const result = await fetchData("order/cancelOrder", apiData);
//       if (result.status === "success") {
//         show("Order cancelled successfully", "success");
//         navigate("/orders");
//       }
//     } catch (error) {
//       show(error, "error");
//     }
//   };

//   const handleRequestForCancel = async (reason, warehouseId) => {
//     const apiData = {
//       managerId: managerId,
//       orderId: orderId,
//       reqType: "Request For Cancel",
//       reqIssue: reason,
//       warehouseId: warehouseId,
//     };
//     try {
//       const result = await fetchData("order/orderhelp", apiData);
//       if (result.status === "success") {
//         show(result.msg, "success");
//         navigate("/orders");
//       } else {
//         show(result.msg, "warning");
//       }
//     } catch (error) {
//       show(error, "error");
//     }
//   };

//   const openCancelOrderModal = () => {
//     handleOpenModal(
//       <ManagerModal
//         heading={"Cancel Order"}
//         centerHeading={"Are you sure want to cancel this Order?"}
//         subHeading={"To confirm! type cancel in the text field."}
//         targetWord={"cancel"}
//         handleCloseModal={() => handleCloseModal()}
//         handleSubmit={() => handleCancelOrder()}
//         focus={true}
//       />,
//     );
//   };

//   const openRequestForCancelModal = () => {
//     handleOpenModal(
//       <RequestForCancelModal
//         mode={mode}
//         handleCloseModal={() => handleCloseModal()}
//         handleSubmit={(reason, warehouseId) =>
//           handleRequestForCancel(reason, warehouseId)
//         }
//         type="order"
//         uniqueWarehouses={uniqueWarehouses}
//       />,
//     );
//   };

//   const openShippingTypeModal = () => {
//     handleOpenModal(
//       <ShippingTypeModal
//         mode={mode}
//         handleCloseModal={() => handleCloseModal()}
//         setShippingType={setShippingType}
//         openShippingModal2={(shippingType) => openShippingModal2(shippingType)}
//       />,
//     );
//   };

//   const dispatchDetailsClick = () => {
//     if (shippingInfo.length === 1) {
//       navigate(
//         "/dispatch/details/" + orderId + "/" + shippingInfo[0].warehouseId,
//       );
//     } else {
//       handleOpenModal(
//         <SelectWarehouse
//           mode={mode}
//           handleCloseModal={() => handleCloseModal()}
//           orderId={orderId}
//           shippingInfo={shippingInfo}
//         />,
//       );
//     }
//   };

//   useEffect(() => {
//     itemInpRefs.current = Array(itemDetails.length)
//       .fill()
//       .map((_, i) => itemInpRefs.current[i] || null);
//   }, [itemDetails.length]);

//   useEffect(() => {
//     const handleKeyDown = (event) => {
//       if (event.key === "Tab") {
//         event.preventDefault();
//       }

//       if (loadingBtn) {
//         event.preventDefault();
//         event.stopPropagation();
//       }

//       if (flag === "edit" && !isModalOpen) {
//         const isInputFocused = ["INPUT", "TEXTAREA", "SELECT"].includes(
//           document.activeElement.tagName,
//         );
//         if (
//           !isInputFocused &&
//           generalInfo.orderType !== "online" &&
//           event.key.toLowerCase() === "e"
//         ) {
//           event.preventDefault();
//           editBtnClick();
//         }
//       }
//     };

//     window.addEventListener("keydown", handleKeyDown, true);

//     return () => {
//       window.removeEventListener("keydown", handleKeyDown, true);
//     };
//   }, [editBtnClick, flag, isModalOpen, loadingBtn, generalInfo.orderType]);

//   useEffect(() => {
//     if (!itemDetails || itemDetails.length === 0) return;

//     const amount = itemDetails.reduce((sum, item) => {
//       if (item.amount && !isNaN(item.amount)) {
//         return sum + parseFloat(item.amount);
//       }
//       return sum;
//     }, 0);

//     const cartPriceSum = itemDetails.reduce((sum, currentItem) => {
//       return (
//         sum +
//         parseFloat(currentItem.price ?? 0) * parseFloat(currentItem.qty ?? 0)
//       );
//     }, 0);

//     const cartTotal = itemDetails
//       .map((x) =>
//         !x.accessories
//           ? 0
//           : x.accessories
//               .map((y) => (y.accessoriesQty ?? 0) * (y.accessoriesPrice ?? 0))
//               .reduce((a, b) => a + b, 0),
//       )
//       .reduce((a, b) => a + b, 0);

//     const subtotal = (cartPriceSum ?? 0) + (cartTotal ?? 0);

//     const gettotalAmount =
//       subtotal +
//       parseFloat(
//         generalInfo.toPay
//           ? 0
//           : generalInfo.deliveryPartner === "Self"
//             ? 0
//             : (generalInfo.shippingCharge ?? 0),
//       );

//     const totalAmount = Math.round(gettotalAmount);

//     setGeneralInfo((prev) => ({
//       ...prev,
//       amount,
//       cartPriceSum,
//       cartTotal,
//       subtotal,
//       totalAmount,
//     }));
//   }, [
//     itemDetails,
//     generalInfo.toPay,
//     generalInfo.deliveryPartner,
//     generalInfo.shippingCharge,
//   ]);

//   useEffect(() => {
//     const { totalAmount } = receipts.reduce(
//       (acc, receipt) => {
//         if (receipt.status === "Received") {
//           acc.totalAmount += receipt.paymentAmount;
//         }
//         if (receipt.status === "Cancelled") {
//           acc.cancelledAmount += receipt.paymentAmount;
//         }
//         return acc;
//       },
//       { totalAmount: 0, cancelledAmount: 0 },
//     );

//     setReceiptTotalAmount(totalAmount);
//   }, [receipts]);

//   const allReceived = receipts.every(
//     (receipt) => receipt.status === "Received",
//   );

//   const hasPod = receipts.some((receipt) => receipt.status === "POD Pending");

//   const shouldShowRequestForCancel =
//     orderId &&
//     ["Packing In Progress", "Packed", "Dispatched"].includes(
//       generalInfo.status,
//     ) &&
//     generalInfo.status !== "Cancelled" &&
//     generalInfo.reqType !== "Request For Cancel";

//   const shouldShowCancelOrder =
//     orderId &&
//     ["Payment Pending", "Payment Under Verification"].includes(
//       generalInfo.status,
//     ) &&
//     generalInfo.status !== "Cancelled" &&
//     generalInfo.reqType !== "Request For Cancel";

//   // const hasDispatchedOrCompleted = shippingInfo.some(
//   //   (item) =>
//   //     item.dispatchStatus === "Completed" ||
//   //     item.dispatchStatus === "Dispatched",
//   // );

//   const hasDispatchedOrCompleted =
//     allOrdersData?.voucher?.dispatchStatus === "Completed" ||
//     allOrdersData?.voucher?.dispatchStatus === "Dispatched";

//   useEffect(() => {
//     onOrderData({
//       loading,
//       orderId,
//       type: generalInfo.orderType,
//       status: generalInfo.status,
//       orderManagerName: generalInfo.orderManagerName,
//       createdBy: generalInfo.createdBy,
//       orderDate: generalInfo.orderDate,
//     });
//   }, [
//     generalInfo.createdBy,
//     generalInfo.orderDate,
//     generalInfo.orderManagerName,
//     generalInfo.orderType,
//     generalInfo.status,
//     loading,
//     onOrderData,
//     orderId,
//   ]);

//   const verifyEntries = () => {
//     const warnings = [];
//     if (
//       itemDetails.every(
//         (item) =>
//           item.amount === "" &&
//           item.price === "" &&
//           item.unit === "" &&
//           item.qty === "" &&
//           item.itemNo === "",
//       ) ||
//       itemDetails.some((item) =>
//         Object.values(item).every((value) => value === ""),
//       )
//     ) {
//       warnings.push("Item Details are required");
//     }
//     if (warnings?.length === 0) {
//       return true;
//     } else {
//       show(warnings.join(" "), "warning");
//       return false;
//     }
//   };

//   // const totalShippingCharges = shippingInfo?.reduce(
//   //   (sum, item) => sum + (Number(item?.shippingCharge) || 0),
//   //   0,
//   // );

//   const totalShippingCharges = shippingInfo?.shippingCharge;

//   useEffect(() => {
//     setGeneralInfo((prev) => ({
//       ...prev,
//       shippingCharge: totalShippingCharges,
//     }));
//   }, [totalShippingCharges]);

//   // const headerData = [
//   //   "S.No",
//   //   "Item No",
//   //   "Product",
//   //   "Collection",
//   //   // "Warehouse",
//   //   "Quantity",
//   //   "Unit",
//   //   "Rate",
//   //   "Amount",
//   // ];

//   const isLiveEditingItems =
//     flag === "create" || (flag === "edit" && isEditMode);
//   const headerData = useMemo(() => {
//     const base = [
//       "S.No",
//       "Item No",
//       "Product",
//       "Collection",
//       "Quantity",
//       "Unit",
//       "Rate",
//       "Amount",
//     ];
//     const action = !isLiveEditingItems && selectedVersion ? ["Action"] : [];
//     return [...base, ...action];
//   }, [isLiveEditingItems, selectedVersion]);

//   const printSummarySlip = useReactToPrint({
//     content: () => summarySlipRef.current,
//   });

//   const handlePrintSummary = async () => {
//     await fetchOrder();
//     setTimeout(() => {
//       printSummarySlip();
//     }, 300);
//   };

//   const openAdvancePaymentInfoModal = (data) => {
//     handleOpenModal(<AdvanceAmountModalInfo mode={mode} data={data} />);
//   };

//   const displayedItems = useMemo(() => {
//     if (isLiveEditingItems) return itemDetails;
//     if (selectedVersion) {
//       const entry = versionsData.find((v) => v.version === selectedVersion);
//       return (entry?.items || []).map((change) => ({
//         _uid: change.itemId + "-" + change.version,
//         itemId: change.itemId,
//         action: change.action,
//         updatedBy: change.updatedBy,
//         updateTime: change.updateTime,
//         changes: change.changes || [], // ← this was missing
//         ...change.data,
//       }));
//     }
//     return itemDetails;
//   }, [isLiveEditingItems, selectedVersion, versionsData, itemDetails]);

//   const hasVersionHistory = versionsData?.length > 0;

//   // ────────────────────────────────────────────────────────────────────────

//   return (
//     <>
//       <ModalWrapper isOpen={isModalOpen} onClose={handleCloseModal} noBtn>
//         {modalContent}
//       </ModalWrapper>

//       <div className={styles.so_scroll_wrapper} ref={scroll_wrapper_ref}>
//         <form className={styles.so_form}>
//           <div className={styles.so_form_1}>
//             {loading && (flag === "edit" || flag === "view") ? (
//               <div>
//                 <Skeleton
//                   lines={1}
//                   thickness={4.5}
//                   additionalStyles={{
//                     marginBottom: "0px",
//                     marginTop: "20px",
//                   }}
//                 />
//               </div>
//             ) : (
//               <div style={{ position: "relative" }}>
//                 <InputTag
//                   ref={dealerInpRef}
//                   labelText={"Company or Dealer's Name / ID"}
//                   placeholderText={"Search Dealer"}
//                   padding={"8px"}
//                   fontSize={"12px"}
//                   value={
//                     useFallback && !searchDealer
//                       ? generalInfo.storeName && generalInfo.dealerName
//                         ? `${generalInfo.storeName} / ${generalInfo.dealerName}`
//                         : generalInfo.storeName || generalInfo.dealerName || ""
//                       : searchDealer
//                   }
//                   onChange={(e) => {
//                     setSearchDealer(e.target.value);
//                     setUseFallback(false);
//                   }}
//                   onFocus={() => {
//                     if (flag === "create") {
//                       setShowDealerSearch(true);
//                     }
//                   }}
//                   onBlur={() => {
//                     setShowDealerSearch(false);
//                     if (searchDealer === "") {
//                       setUseFallback(true);
//                     }
//                   }}
//                   onKeyDown={(e) => handleDealerKeyDown(e)}
//                   maxLength={100}
//                   required
//                   enterKeyHint={"enter"}
//                   readOnly={flag === "view"}
//                 />

//                 {showDealerSearch && (
//                   <SearchDealer
//                     mode={mode}
//                     results={dealerResults}
//                     loading={dealerLoading}
//                     currentIndex={currentIndex}
//                     onDealerSelect={handleSelectDealer}
//                     openAddDealerModal={openAddDealerModal}
//                   />
//                 )}
//               </div>
//             )}

//             {loading && (flag === "edit" || flag === "view") ? (
//               <div>
//                 <Skeleton
//                   lines={1}
//                   thickness={4.5}
//                   additionalStyles={{
//                     marginBottom: "0px",
//                     marginTop: "20px",
//                   }}
//                 />
//               </div>
//             ) : (
//               <div>
//                 <InputTag
//                   labelText={"Shipping Address"}
//                   placeholderText={"Enter Dealer Address"}
//                   value={
//                     [
//                       shippingAddress.street,
//                       shippingAddress.city,
//                       shippingAddress.district,
//                       shippingAddress.state,
//                       shippingAddress.pincode,
//                     ]
//                       .filter(Boolean)
//                       .join(" ") || ""
//                   }
//                   padding={"8px"}
//                   fontSize={"12px"}
//                   required
//                 />
//               </div>
//             )}
//           </div>

//           <div className={styles.so_form_1}>
//             <div>
//               {loading && (flag === "edit" || flag === "view") ? (
//                 <div style={{ width: "100%" }}>
//                   <Skeleton
//                     lines={1}
//                     thickness={4.5}
//                     additionalStyles={{
//                       marginBottom: "0px",
//                       marginTop: "20px",
//                     }}
//                   />
//                 </div>
//               ) : (
//                 <div className={styles.warehouse_selectors}>
//                   <div
//                     style={{
//                       width: "100%",
//                       position: "relative",
//                     }}
//                   >
//                     {flag !== "create" && (
//                       <div className={styles.voucher_det}>
//                         <p style={{ color: mode && "#FFFFFF" }}>
//                           {shippingType}
//                         </p>
//                       </div>
//                     )}

//                     <div>
//                       <InputTag
//                         labelText={"Warehouse"}
//                         placeholderText={"Warehouse"}
//                         padding={"8px"}
//                         fontSize={"12px"}
//                         value={allOrdersData?.voucher?.warehousename}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>

//             {loading && (flag === "edit" || flag === "view") ? (
//               <div>
//                 <Skeleton
//                   lines={1}
//                   thickness={4.5}
//                   additionalStyles={{
//                     marginBottom: "0px",
//                     marginTop: "20px",
//                   }}
//                 />
//               </div>
//             ) : (
//               <div>
//                 <div style={{ width: "100%", position: "relative" }}>
//                   <div className={styles.voucher_det}>
//                     <p style={{ color: mode && "#FFFFFF" }}>
//                       {shippingInfo?.courierName}
//                     </p>
//                   </div>

//                   <div>
//                     <InputTag
//                       labelText={"Delivery Method"}
//                       placeholderText={"Delivery Method"}
//                       padding={"8px"}
//                       fontSize={"12px"}
//                       value={
//                         shippingInfo?.methodName || shippingInfo?.partnerName
//                       }
//                     />
//                   </div>

//                   {isEditMode && (
//                     <div className={styles.change_ship}>
//                       <span
//                         style={{ color: !mode && "#4164E3" }}
//                         onClick={() => openShippingModal2(shippingType, "")}
//                       >
//                         Update
//                       </span>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             )}
//           </div>
//         </form>

//         {/* ------------------------- Version History -------------------------- */}

//         {!isLiveEditingItems && hasVersionHistory && (
//           <div
//             style={{
//               flex: 1,
//               display: "flex",
//               flexDirection: "row",
//               marginTop: "10px",
//               alignItems: "center",
//               gap: "6px",
//             }}
//           >
//             <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//               <span
//                 style={{ fontSize: 14, color: mode ? "#ffffff" : "#000000" }}
//               >
//                 Version History
//               </span>

//               <SlidingFilter
//                 itemList={[
//                   "Current",
//                   ...[...versionsData]
//                     .sort((a, b) => b.version - a.version)
//                     .map((v) => `Version ${v.version}`),
//                 ]}
//                 activeFilter={
//                   selectedVersion ? `Version ${selectedVersion}` : "Current"
//                 }
//                 setFilter={(label) =>
//                   setSelectedVersion(
//                     label === "Current"
//                       ? null
//                       : Number(label.replace("Version ", "")),
//                   )
//                 }
//               />
//             </div>

//             {selectedVersion &&
//               (() => {
//                 const entry = versionsData.find(
//                   (v) => v.version === selectedVersion,
//                 );
//                 if (!entry) return null;
//                 const { updatedBy, updateTime } = getVersionMeta(entry);
//                 return (
//                   <div
//                     style={{
//                       fontSize: 12,
//                       color: "#4164E3",
//                       fontWeight: 600,
//                     }}
//                   >
//                     {updatedBy}
//                     {updateTime
//                       ? ` • ${new Date(updateTime).toLocaleString()}`
//                       : ""}
//                   </div>
//                 );
//               })()}
//           </div>
//         )}
//         {/* ----------------------------------------------------------------------- */}

//         <ul className={styles.p_table}>
//           <div
//             className={styles.p_table_header_con}
//             style={{
//               visibility: loading && "hidden",
//             }}
//           >
//             <li
//               className={`${styles.p_table_header} ${
//                 mode ? styles.p_table_header_dark : ""
//               }`}
//             >
//               {headerData?.map((h, index) => (
//                 <div className={styles.entry_2} key={`${h}-${index}`}>
//                   {h}
//                 </div>
//               ))}
//             </li>
//             {(flag === "create" || isEditMode) && itemDetails?.length > 1 && (
//               <div
//                 style={{
//                   visibility: "hidden",
//                   display: flag === "view" && "none",
//                 }}
//               >
//                 <RemoveIcon />
//               </div>
//             )}
//           </div>

//           <div className={styles.p_table_list}>
//             <>
//               {displayedItems?.map((item, index) => (
//                 // ── Use _uid as key so removing an item never shifts
//                 //    React component instances or their local state ──────
//                 <React.Fragment key={item._uid ?? `${item.itemNo}-${index}`}>
//                   {isLiveEditingItems ? (
//                     <ProductionSaleNewItemList
//                       mode={mode}
//                       index={index}
//                       item={item}
//                       itemInpRefs={(el) => {
//                         if (el) itemInpRefs.current[index] = el;
//                       }}
//                       quantityRefs={qtyInputRefs}
//                       onItemChange={(field, value) =>
//                         handleItemChange(index, field, value)
//                       }
//                       onRemove={() => removeItem(index)}
//                       onAddNewItem={handleAddNewItem}
//                       itemDetailsLength={itemDetails.length}
//                       itemFocus={handleItemInputFocus}
//                       itemBlur={handleItemInputBlur}
//                       focusedItemIndex={focusedItemIndex}
//                       showItemSearch={showItemSearch}
//                       setShowItemSearch={setShowItemSearch}
//                       onShowDesc={(value) => setShowDescriptionInput(value)}
//                       onCompletion={() => {
//                         if (shippingInfo.length === 1) {
//                           openShippingModal2("Combined", "normal");
//                         } else {
//                           openShippingTypeModal();
//                         }
//                       }}
//                       flag={flag}
//                       allItems={displayedItems}
//                     />
//                   ) : (
//                     <>
//                       {loading ? (
//                         <div>
//                           <Skeleton
//                             lines={
//                               displayedItems?.length === 1
//                                 ? 1
//                                 : displayedItems?.length / 2
//                             }
//                             thickness={5}
//                             additionalStyles={{
//                               marginBottom: "0px",
//                               marginTop: "0px",
//                             }}
//                           />
//                         </div>
//                       ) : (
//                         <DataItemListProAndSale
//                           d={item}
//                           index={index}
//                           mode={mode}
//                           voucherType={"Production & Sale"}
//                           selectedVersion={selectedVersion}
//                           isLiveEditingItems={isLiveEditingItems}
//                         />
//                       )}
//                     </>
//                   )}
//                 </React.Fragment>
//               ))}
//             </>
//           </div>

//           {(flag === "create" || isEditMode) && (
//             <div
//               className={styles.cricle_btn}
//               onClick={() => {
//                 handleAddNewItem();
//               }}
//             >
//               <TestTopAddDealerIcon color="#4164E3" />
//             </div>
//           )}

//           {showDescriptionInput && (flag === "create" || flag === "edit") && (
//             <div className={styles.so_instc}>
//               <p>Press Enter to Add Item</p>
//               <DividerIcon />
//               <p>Double Enter for Next Option</p>
//               <DividerIcon />
//               <p>Ctrl + Backspace for Remove Item</p>
//             </div>
//           )}
//         </ul>
//       </div>

//       {loading ? (
//         <div
//           style={{ padding: "0", boxShadow: "none" }}
//           className={`${styles.so_footer} ${mode ? styles.so_footer_dark : ""}`}
//         >
//           <Skeleton
//             lines={1}
//             thickness={5}
//             additionalStyles={{
//               marginBottom: "0px",
//               marginTop: "0px",
//               borderRadius: "15px 15px 0 0",
//             }}
//           />
//         </div>
//       ) : (
//         <div
//           className={`${styles.so_footer} ${mode ? styles.so_footer_dark : ""}`}
//         >
//           {(flag === "edit" || flag === "view") && (
//             <div className={styles.so_footer_left}>
//               <div
//                 className={`${styles.so_receipt_data} ${
//                   mode ? styles.so_receipt_data_dark : ""
//                 }`}
//               >
//                 <div
//                   className={`${styles.so_receipt_data_header} ${
//                     mode ? styles.so_receipt_data_header_dark : ""
//                   }`}
//                   style={{ cursor: "auto" }}
//                 >
//                   <div className="col">Receipt ID</div>
//                   <div className="col">Method</div>
//                   <div className="col">Amount</div>
//                   <div className="col">Status</div>
//                 </div>
//                 <div
//                   className={styles.scroll_con}
//                   style={{ display: receipts?.length === 0 && "none" }}
//                 >
//                   {receipts?.length !== 0 &&
//                     receipts?.map((r, index) => (
//                       <div
//                         className={`${styles.so_receipt_data_entry} ${
//                           mode ? styles.so_receipt_data_entry_dark : ""
//                         }`}
//                         key={index}
//                         onClick={() => {
//                           handleOpenModal(
//                             <AddReceiptModal
//                               handleCloseModal={handleCloseModal}
//                               mode={mode}
//                               totalAmount={generalInfo.totalAmount}
//                               accounts={accounts}
//                               receiptData={r}
//                               updateReceiptData={async (updatedData) =>
//                                 updateReceiptData(
//                                   updatedData,
//                                   orderId,
//                                   r.receiptId,
//                                 )
//                               }
//                               type={"create"}
//                               flag={"notupdateamount"}
//                               uniqueWarehouses={uniqueWarehouses}
//                               shippingType={shippingType}
//                               dispatchWarehouse={dispatchWarehouse}
//                               setReceiptData={setReceiptData}
//                               isModalOpen={isModalOpen}
//                               receiptTotalAmount={receiptTotalAmount}
//                               isSelf={isSelf}
//                             />,
//                           );
//                         }}
//                       >
//                         <div className="col" key={index + r.receiptId}>
//                           {r.receiptId}
//                         </div>
//                         <div className="col" key={index + r.paymentMethod}>
//                           {r.paymentMethod}
//                         </div>
//                         <div className="col" key={index + r.paymentAmount}>
//                           {r.paymentAmount}
//                         </div>
//                         <div
//                           className="col"
//                           key={index + r.status}
//                           style={{ color: getStatusColor(r.status) }}
//                         >
//                           {r.status}
//                         </div>
//                       </div>
//                     ))}
//                 </div>
//               </div>

//               {(receiptTotalAmount < generalInfo.totalAmount ||
//                 hasPod ||
//                 !allReceived) && (
//                 <div
//                   className={styles.add_receipt_btn}
//                   onClick={async () => {
//                     await fetchDMs();
//                     orderSuccessKeyPress("addReceipt");
//                   }}
//                 >
//                   <TestTopAddDealerIcon />
//                 </div>
//               )}

//               {allOrdersData?.order?.paymentStatus && (
//                 <div>
//                   <p
//                     style={{
//                       color:
//                         allOrdersData?.order?.paymentStatus === "Received"
//                           ? "#297038"
//                           : "#f11717",
//                     }}
//                   >
//                     {allOrdersData?.order?.paymentStatus}
//                   </p>
//                 </div>
//               )}
//             </div>
//           )}

//           <div className={styles.so_footer_right}>
//             <div className={styles.right_btns}>
//               {(flag === "edit" || flag === "view") && (
//                 <MoreDropdown
//                   mode={mode}
//                   onSummaryClick={handlePrintSummary}
//                   onSlipClick={() => {
//                     show("Coming soon...");
//                   }}
//                 />
//               )}

//               {shouldShowRequestForCancel && (
//                 <Button
//                   buttonIcon={<CancelIcon2 />}
//                   buttonText={"Request for Cancel"}
//                   buttonBgColor={"#000000"}
//                   buttonTextColor={"#ffffff"}
//                   buttonBorder={"none"}
//                   buttonClick={openRequestForCancelModal}
//                 />
//               )}

//               {shouldShowCancelOrder && (
//                 <Button
//                   buttonIcon={<CancelIcon2 />}
//                   buttonText={"Cancel Order"}
//                   buttonBgColor={"#000000"}
//                   buttonTextColor={"#ffffff"}
//                   buttonBorder={"none"}
//                   buttonClick={openCancelOrderModal}
//                 />
//               )}

//               {(flag === "edit" || flag === "view") && (
//                 <Button
//                   buttonIcon={<NewEyeIcon />}
//                   buttonText={"Invoice"}
//                   buttonBgColor={"#000000"}
//                   buttonTextColor={"#ffffff"}
//                   buttonBorder={"none"}
//                   buttonClick={() =>
//                     navigate("/orders/saleinvoice?orderId=" + orderId)
//                   }
//                 />
//               )}

//               {hasDispatchedOrCompleted && (
//                 <Button
//                   buttonIcon={<NewEyeIcon />}
//                   buttonText={"Dispatch Details"}
//                   buttonBgColor={"#000000"}
//                   buttonTextColor={"#ffffff"}
//                   buttonBorder={"none"}
//                   buttonClick={dispatchDetailsClick}
//                 />
//               )}

//               {(flag === "edit" || flag === "view") &&
//                 generalInfo.status !== "Cancelled" &&
//                 generalInfo.reqType !== "Request For Cancel" && (
//                   <Button
//                     buttonIcon={<ShareIcon />}
//                     buttonText={"Share"}
//                     buttonBgColor={"#4164E3"}
//                     buttonTextColor={"#ffffff"}
//                     buttonBorder={"none"}
//                     buttonClick={() => orderSuccessKeyPress("shareLink")}
//                   />
//                 )}
//             </div>

//             <div
//               className={`${styles.so_amount_info} ${
//                 mode ? styles.so_amount_info_dark : ""
//               }`}
//             >
//               <div>
//                 <p>Sub Total:</p>
//                 <p>₹ {generalInfo.subtotal}</p>
//               </div>

//               <div className={styles.so_shipping}>
//                 <p>Shipping Charges:</p>{" "}
//                 <div className={styles.info_btn_con}>
//                   <span
//                     className={styles.info_btn}
//                     onClick={() =>
//                       openShippingChargesInfoModal(
//                         shippingType,
//                         dispatchWarehouse,
//                         shippingInfo,
//                       )
//                     }
//                   >
//                     <InfoRounded color={mode ? "#FFFFFF" : "#1C274C"} />
//                   </span>
//                 </div>
//                 <input
//                   type="number"
//                   value={
//                     (generalInfo.deliveryPartner === "Self"
//                       ? 0
//                       : generalInfo.shippingCharge
//                     )
//                       ?.toString()
//                       .replace(/^0+/, "") || 0
//                   }
//                   onChange={(e) => {
//                     let value = Number(e.target.value);
//                     if (value > 0) {
//                       setGeneralInfo((prevState) => ({
//                         ...prevState,
//                         shippingCharge: value,
//                       }));
//                     } else {
//                       setGeneralInfo((prevState) => ({
//                         ...prevState,
//                         shippingCharge: -1 * value,
//                       }));
//                     }
//                   }}
//                   readOnly={!isNoCase || flag === "view"}
//                   maxLength="10"
//                   onInput={(e) =>
//                     (e.target.value = e.target.value.slice(0, 10))
//                   }
//                   style={mode ? { color: "#fff" } : {}}
//                   ref={shippingRef}
//                   onKeyDown={(e) => {
//                     if (e.key === "Enter") {
//                       checkboxRef.current?.focus();
//                     }
//                   }}
//                 />
//                 <div className={styles.so_check}>
//                   <p>To Pay</p>
//                   <input
//                     type="checkbox"
//                     checked={generalInfo.toPay}
//                     onChange={(e) => {
//                       const isChecked = e.target.checked;

//                       if (
//                         isChecked &&
//                         isNoCase &&
//                         generalInfo.shippingCharge === 0
//                       ) {
//                         e.preventDefault();
//                         show(
//                           "Update shipping charges to check To Pay!",
//                           "warning",
//                         );
//                         return;
//                       }

//                       setGeneralInfo((prevState) => ({
//                         ...prevState,
//                         toPay: isChecked,
//                       }));
//                     }}
//                     ref={checkboxRef}
//                     disabled={
//                       flag === "view" || (flag === "edit" && !isEditMode)
//                     }
//                     onKeyDown={(e) => {
//                       if (e.key === "Enter") {
//                         handleSubmit();
//                       }
//                     }}
//                   />
//                 </div>
//                 <p>
//                   {loadingBtn ? (
//                     <Spinner
//                       borderWidth={"1px"}
//                       height={10}
//                       width={10}
//                       color={mode ? "#000000" : "#4164E3"}
//                     />
//                   ) : (
//                     <>
//                       ₹{" "}
//                       {generalInfo.deliveryPartner === "Self"
//                         ? 0
//                         : generalInfo.shippingCharge}
//                     </>
//                   )}
//                 </p>
//               </div>

//               <div>
//                 <p>
//                   Total Amount(INR):{" "}
//                   {receipts?.length > 0 && (
//                     <span
//                       className={styles.info_btn}
//                       onClick={() => openAdvancePaymentInfoModal(receipts)}
//                     >
//                       <InfoRounded color={mode ? "#FFFFFF" : "#1C274C"} />
//                     </span>
//                   )}
//                 </p>

//                 <p>
//                   {loadingBtn ? (
//                     <Spinner
//                       borderWidth={"1px"}
//                       height={10}
//                       width={10}
//                       color={mode ? "#000000" : "#4164E3"}
//                     />
//                   ) : (
//                     <>₹ {Number(generalInfo.totalAmount) || 0}</>
//                   )}
//                 </p>
//               </div>
//             </div>

//             {flag === "edit" && (
//               <div>
//                 {isEditMode ? (
//                   <>
//                     {showSave ? (
//                       <Button
//                         buttonIcon={<SaveIcon />}
//                         buttonText={"Save"}
//                         buttonBgColor={"#4164E3"}
//                         buttonTextColor={"#FFFFFF"}
//                         buttonBorder={"none"}
//                         buttonClick={() => {
//                           if (verifyEntries()) {
//                             handleSubmit();
//                           }
//                         }}
//                       />
//                     ) : (
//                       <div className={styles.flex}>
//                         <Button
//                           buttonIcon={<CancelIcon2 />}
//                           buttonText={"Cancel"}
//                           buttonBgColor={"#000000"}
//                           buttonTextColor={"#ffffff"}
//                           buttonBorder={"none"}
//                           buttonClick={() => setIsEditMode(false)}
//                           loading={loadingBtn}
//                         />
//                       </div>
//                     )}
//                   </>
//                 ) : (
//                   <>
//                     {generalInfo.orderType !== "online" && (
//                       <Button
//                         buttonIcon={<EditManagerIcon />}
//                         buttonText={"Edit"}
//                         buttonBgColor={"#4164E3"}
//                         buttonTextColor={"#FFFFFF"}
//                         buttonBorder={"none"}
//                         buttonClick={editBtnClick}
//                       />
//                     )}
//                   </>
//                 )}
//               </div>
//             )}

//             {flag === "create" && (
//               <div>
//                 {showSave && (
//                   <Button
//                     buttonIcon={<SaveIcon />}
//                     buttonText={"Save"}
//                     buttonBgColor={"#4164E3"}
//                     buttonTextColor={"#FFFFFF"}
//                     buttonBorder={"none"}
//                     buttonClick={() => {
//                       if (verifyEntries()) {
//                         handleSubmit();
//                       }
//                     }}
//                   />
//                 )}
//               </div>
//             )}
//           </div>
//         </div>
//       )}

//       {/* ------------ Summary Slip ------------------- */}
//       <div style={{ display: "none" }}>
//         <NewSummarySlip
//           ref={summarySlipRef}
//           summarySlipData={itemDetails}
//           generalInfo={allOrdersData?.order}
//         />
//       </div>
//     </>
//   );
// };

// export default ProductionSale;

// ------------------- first Changes ------------------------------

// import { useNavigate, useSearchParams } from "react-router-dom";
// import styles from "./ProductionSale.module.css";
// import React, {
//   useCallback,
//   useEffect,
//   useMemo,
//   useRef,
//   useState,
// } from "react";
// import fetchData from "../../APIsControll/apiControll";
// import { useAuth } from "../../components/context/Auth";
// import InputTag from "../../components/updatedComponents/FormComponents/InputTag";
// import Skeleton from "../../components/updatedComponents/Skeleton/Skeleton";
// import SearchDealer from "../../components/updatedComponents/OrderManager/SearchDealer";
// import DealerAddressModal from "../../components/updatedComponents/OrderManager/DealerAddressModal";
// import AdduserModel from "../../components/updatedComponents/models/AdduserModel";
// import ModalWrapper from "../../components/updatedComponents/layoutWrapper/ModalWrapper";
// import {
//   CancelIcon2,
//   DividerIcon,
//   EditManagerIcon,
//   InfoRounded,
//   NewEyeIcon,
//   RemoveIcon,
//   SaveIcon,
//   ShareIcon,
//   TestTopAddDealerIcon,
// } from "../../components/icons/Icon";
// import ItemList from "../../components/updatedComponents/OrderManager/ItemList";
// import ManagerModal from "../../components/updatedComponents/Manager/ManagerModal";
// import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
// import OrderSuccessModal from "../../components/updatedComponents/OrderManager/OrderSuccessModal";
// import ShareLinkModal from "../../components/updatedComponents/OrderManager/ShareLinkModal";
// import AddReceiptModal from "../../components/updatedComponents/OrderManager/AddReceiptModal";
// import { handleFileData } from "../../APIsControll/apiControl2";
// import Button from "../../components/updatedComponents/Dealers/Button";
// import RequestForCancelModal from "../../components/updatedComponents/OrderManager/RequestForCancelModal";
// import Spinner from "../../components/updatedComponents/FormComponents/Spinner";
// import ConfirmOrder from "../../components/updatedComponents/OrderManager/ConfirmOrder";
// import Warning from "../../components/updatedComponents/Receipts/Warning";
// import ShippingTypeModal from "../../components/updatedComponents/OrderManager/ShippingTypeModal";
// import Selection from "../../components/updatedComponents/OrderManager/Selection";
// // import ShippingChargesInfoModal from "../../components/updatedComponents/OrderManager/ShippingChargesInfoModal";
// // import ShippingChargesModal2 from "../../components/updatedComponents/OrderManager/ShippingChargesModal2";
// import { useDispatch } from "react-redux";
// import { setFilter } from "../../store/slices/order/OrderSlice";
// import SelectDM from "../../components/updatedComponents/OrderManager/SelectDM";
// import { formatDateTime, getStatusColor } from "../../Utils/Utils";
// import SelectWarehouse from "../../components/updatedComponents/OrderManager/SelectWarehouse";
// import MoreDropdown from "../dispatchmanager/MoreDropdown";
// import { useReactToPrint } from "react-to-print";
// import NewSummarySlip from "../dispatchmanager/NewSummarySlip";
// import AdvanceAmountModalInfo from "../../components/updatedComponents/OrderManager/AdvanceAmountModalInfo";
// import ProductionSaleNewItemList from "../../components/updatedComponents/OrderManager/ProductionSaleNewItemList";
// import SlidingFilter from "../../components/updatedComponents/Dealers/SlidingFilter";
// import { versions, VesionsList } from "../hrm/HrmData";
// import ProSaleShippingChargesModal from "../../components/updatedComponents/OrderManager/ProSaleShippingChangesModal";
// import ProSaleShippingChargesModal2 from "../../components/updatedComponents/OrderManager/ProSaleShippingChangesModal2";
// import DataItemListProAndSale from "../../components/updatedComponents/OrderManager/DataItemListProAndSale";
// import ShippingChargesInfoModal from "../../components/updatedComponents/OrderManager/ShippingChargesInfoModal";
// import ProSaleShippingChargesInfoModal from "../../components/updatedComponents/OrderManager/ProSaleShippingChargesInfoModal";

// // ─── UID generator (frontend-only, never sent to API) ───────────────────────
// let _uidCounter = 0;
// const genUid = () => `item-${++_uidCounter}-${Date.now()}`;

// // Who/when for a version tab — uses the last change entry in that version
// const getVersionMeta = (versionEntry) => {
//   const last = versionEntry?.items?.[versionEntry.items.length - 1];
//   return {
//     updatedBy: last?.updatedBy || "",
//     updateTime: last?.updateTime || "",
//     action: last?.action || "",
//   };
// };

// const ProductionSale = ({ onOrderData }) => {
//   const { managerId, mode, designation } = useAuth();

//   const dispatch = useDispatch();

//   const { show } = useToast();
//   const navigate = useNavigate();
//   const [searchParams] = useSearchParams();
//   const orderId = searchParams.get("orderId")
//     ? searchParams.get("orderId")
//     : "";

//   const dealerInpRef = useRef(null);
//   const locationRef = useRef(null);
//   const scroll_wrapper_ref = useRef(null);
//   const itemInpRefs = useRef([]);
//   const qtyInputRefs = useRef([]);
//   const shippingRef = useRef(null);
//   const checkboxRef = useRef(null);
//   const dispatchManagersRef = useRef();
//   const summarySlipRef = useRef(null);

//   const initialItemDetails = useMemo(
//     () => ({
//       _uid: genUid(), // frontend-only, stripped before API calls
//       amount: 0,
//       collection_name: "",
//       desc: "",
//       descKey: "",
//       dp: 0,
//       itemNo: "",
//       price: 0,
//       product_name: "",
//       qty: 0,
//       thumbnail: "",
//       totalQty: "",
//       unit: "",
//       vm: 0,
//       warehouse: "",
//       weight: 0,
//     }),
//     [],
//   );

//   const initialReceiptData = useMemo(
//     () => ({
//       paymentMethod: "Cash",
//       transactionScreenshot: "",
//       paymentAmount: "",
//       transactionId: "",
//       accountNumber: "",
//       totalAmount: "",
//       receiptId: "",
//       paymentType: "Cash",
//       warehousename: "",
//       warehouseId: "",
//     }),
//     [],
//   );

//   const [generalInfo, setGeneralInfo] = useState({
//     warehouses: [],
//     selectedDMs: [],
//   });
//   const [itemDetails, setItemDetails] = useState([initialItemDetails]);

//   // ── Version History state ─────────────────────────────────────────────

//   const [selectedVersion, setSelectedVersion] = useState(null);
//   const [versionsData, setVersionsData] = useState([]);
//   // ────────────────────────────────────────────────────────────────────────

//   const flag = useMemo(() => {
//     if (!orderId) {
//       return "create";
//     }
//     if (orderId && generalInfo.status === "Payment Pending") {
//       return "edit";
//     }
//     if (orderId && generalInfo.status !== "Payment Pending") {
//       return "view";
//     }
//     return "";
//   }, [orderId, generalInfo.status]);

//   const [loading, setLoading] = useState(false);
//   const [showSave, setShowSave] = useState(false);
//   const [loadingBtn, setLoadingBtn] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);

//   const [receipts, setReceiptsInfo] = useState([]);

//   const [accounts, setAccounts] = useState([]);
//   const [warehouses, setWarehouses] = useState([]);
//   const [dispatchManagers, setDispatchManagers] = useState([]);
//   const [methodPartners, setMethodPartners] = useState([]);

//   const [showDealerSearch, setShowDealerSearch] = useState(
//     flag === "create" ? true : false,
//   );
//   const [searchDealer, setSearchDealer] = useState("");
//   const [dealerLoading, setDealerLoading] = useState(false);
//   const [dealerResults, setDealerResults] = useState([]);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [updatedAddress, setUpdatedAddress] = useState(null);
//   const [useFallback, setUseFallback] = useState(true);

//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [modalContent, setModalContent] = useState(null);

//   const [focusedItemIndex, setFocusedItemIndex] = useState(0);
//   const [showItemSearch, setShowItemSearch] = useState(false);

//   const [receiptData, setReceiptData] = useState(initialReceiptData);
//   const [paymentLink, setPaymentLink] = useState("");

//   const [skipped, setSkipped] = useState(false);
//   const [isNoCase, setIsNoCase] = useState(false);

//   const [shouldFocus, setShouldFocus] = useState(true);
//   const [showDescriptionInput, setShowDescriptionInput] = useState(false);

//   const [isManagerAssigned, setIsManagerAssigned] = useState(true);
//   const [isShippingBlocked, setIsShippingBlocked] = useState(false);
//   const [isPodBlocked, setIsPodBlocked] = useState(false);
//   const [orderManagers, setOrderManagers] = useState([]);
//   const [shippingType, setShippingType] = useState("Combined");
//   const [dispatchWarehouse, setDispatchWarehouse] = useState();

//   const [shippingAddress, setShippingAddress] = useState({});
//   const [allOrdersData, setAllOrdersData] = useState([{}]);

//   const initialShippingDetails = {
//     methodId: "",
//     shippingCharge: 0,
//     courierName: "Pick Up",
//     methodName: "Self",
//     partnerName: "Self",
//     warehousename: "",
//     warehouseId: "",
//     isDispatchWarehouse: false,
//     delInstruction: "",
//   };

//   const [shippingInfo, setShippingInfo] = useState([initialShippingDetails]);
//   const [instructions, setInstructions] = useState({});
//   const [uniqueWarehouses, setUniqueWarehouses] = useState([]);
//   const [receiptTotalAmount, setReceiptTotalAmount] = useState();

//   const shippingInfoRef = useRef(shippingInfo);

//   useEffect(() => {
//     shippingInfoRef.current = shippingInfo;
//   }, [shippingInfo]);

//   useEffect(() => {
//     dispatchManagersRef.current = dispatchManagers;
//   }, [dispatchManagers]);

//   useEffect(() => {
//     if (shouldFocus) {
//       dealerInpRef.current?.focus();
//     } else {
//       dealerInpRef.current?.blur();
//     }
//   }, [shouldFocus]);

//   useEffect(() => {
//     if (flag === "create") {
//       setGeneralInfo((prevState) =>
//         Object.keys(prevState).reduce((acc, key) => {
//           acc[key] = 0;
//           return acc;
//         }, {}),
//       );
//       setReceiptData(initialReceiptData);
//       setItemDetails([{ ...initialItemDetails, _uid: genUid() }]);
//       setDispatchManagers([]);
//       setShowDescriptionInput(false);
//       itemInpRefs.current = [];
//       qtyInputRefs.current = [];
//       setFocusedItemIndex(null);
//       setDealerResults([]);
//       setMethodPartners([]);
//       setIsNoCase(false);
//       setShouldFocus(true);
//       setSearchDealer("");
//       setShowItemSearch(false);
//       setIsEditMode(false);
//       setReceiptsInfo([]);
//       setAccounts([]);
//       setWarehouses([]);
//       setPaymentLink("");
//       setIsModalOpen(false);
//       setModalContent(null);
//       setSkipped(false);
//       setShowSave(false);
//       setLoading(false);
//       setLoadingBtn(false);
//       setIsManagerAssigned(true);
//       setIsShippingBlocked(false);
//       setIsPodBlocked(false);
//       setOrderManagers([]);
//       dispatch(setFilter({ selectedOption: "" }));
//       setShippingAddress({});
//       setShippingInfo([]);
//       setReceiptTotalAmount();
//       // ── reset version history state for a fresh "create" form ──────────
//       setVersionsData([]);
//       setSelectedVersion(null);
//       // ─────────────────────────────────────────────────────────────────
//     }
//   }, [dispatch, flag, initialItemDetails, initialReceiptData]);

//   const fetchOrder = useCallback(async () => {
//     setLoading(true);
//     try {
//       const apiData = {
//         managerId: managerId,
//         voucherId: orderId,
//         // warehousename: "",
//       };
//       const result = await fetchData("order/prodAndSalesVoucher", apiData);

//       if (result.status === "success") {
//         setLoading(false);
//         setAllOrdersData(result?.data);
//         if (result?.data?.voucher) {
//           setGeneralInfo((prevState) => ({
//             ...prevState,
//             dealerId: result?.data?.voucher?.dealerId,
//             storeName: result?.data?.voucher?.storeName,
//             dealerName: result?.data?.voucher?.name,
//             createdBy: result?.data?.voucher?.createdBy,
//             billingAddress: result?.data?.voucher?.billingAddress,
//             shippingCharge: result?.data?.voucher?.totalShippingCharge,
//             totalAmount: result?.data?.voucher?.totalAmount,
//             subtotal: result?.data?.voucher?.subtotal,
//             courierName: result?.data?.voucher?.courierName,
//             mobile: result?.data?.voucher?.shippingAddress?.mobile
//               ? result?.data?.voucher?.shippingAddress?.mobile
//               : result?.data?.voucher?.DealerInfo?.whatsapp,
//             whatsapp: result?.data?.voucher?.DealerInfo?.whatsapp
//               ? result?.data?.voucher?.DealerInfo?.whatsapp
//               : result?.data?.voucher?.shippingAddress?.mobile,
//             email: result?.data?.voucher?.DealerInfo?.email
//               ? result?.data?.voucher?.DealerInfo?.email
//               : "",
//             orderManagerName: result?.data?.voucher?.orderManagerName,
//             dmId: result?.data?.voucher?.dmId,
//             dmName: result?.data?.voucher?.dmName,
//             orderDate: result?.data?.voucher?.voucherDate,
//             orderId: result?.data?.voucher?.voucherId,
//             status: result?.data?.voucher?.status,
//             orderType: result?.data?.voucher?.voucherType,
//             toPay: result?.data?.voucher?.toPay,
//             dispatchStatus: result?.data?.voucher?.dispatchStatus,
//             reqType: result?.data?.voucher?.reqType,
//             // deliveryPartners: result?.data?.voucher?.shippingInfo?.map((d) => ({
//             //   label: d.methodName,
//             //   value: d.methodName,
//             // })),

//             deliveryPartners: {
//               label: result?.data?.voucher?.shippingInfo?.methodName,
//               value: result?.data?.voucher?.shippingInfo?.methodName,
//             },
//           }));
//           // setUniqueWarehouses(
//           //   result?.data?.voucher?.shippingInfo?.map((d) => ({
//           //     label: d.warehousename,
//           //     value: d.warehouseId,
//           //   })),
//           // );
//           // setDispatchManagers(
//           //   result.data.dispatchmanagers.map((d) => ({
//           //     label: d.name,
//           //     value: d.managerId,
//           //     warehousename: d.warehousename,
//           //     warehouseId: d.warehouseId,
//           //   })),
//           // );
//           // setDispatchWarehouse(() => {
//           //   if (shippingType !== "Separate") {
//           //     const dispatchWarehouse = result?.data?.voucher?.shippingInfo?.find(
//           //       (d) => d.isDispatchWarehouse === true,
//           //     );
//           //     return dispatchWarehouse
//           //       ? {
//           //           label: dispatchWarehouse.warehousename || "",
//           //           value: dispatchWarehouse.warehouseId || "",
//           //         }
//           //       : { label: "", value: "" };
//           //   }

//           //   return { label: "", value: "" };
//           // });
//           // setReceiptData((prev) => {
//           //   const warehouse =
//           //     shippingType !== "Separate"
//           //       ? result?.data?.voucher?.shippingInfo?.find(
//           //           (d) => d.isDispatchWarehouse === true,
//           //         ) || ""
//           //       : "";

//           //   return {
//           //     ...prev,
//           //     warehousename: warehouse.warehouseId,
//           //     warehouseId: warehouse.warehouseId,
//           //   };
//           // });
//           setShippingInfo(result.data.voucher.shippingInfo);
//           setShippingAddress(result?.data?.voucher?.shippingAddress);

//           // ── Stamp each item with a frontend-only _uid ──────────────────
//           const stampedItems = result?.data?.voucher?.items.map((item) => ({
//             ...item,
//             _uid: genUid(),
//           }));
//           setItemDetails(stampedItems);
//           // ───────────────────────────────────────────────────────────────

//           // ── Version History ────────────────────────────────────────────
//           if (result?.data?.voucher?.itemsHistory) {
//             setVersionsData(result.data.voucher.itemsHistory);
//           } else {
//             setVersionsData([]);
//           }
//           setSelectedVersion(null);
//           // ────────────────────────────────────────────────────────────────

//           setReceiptsInfo(result?.data?.receipts);
//           setIsPodBlocked(
//             result?.data?.voucher?.DealerInfo?.podBlock ? true : false,
//           );
//           setIsShippingBlocked(
//             result?.data?.voucher?.DealerInfo?.shippingBlock ? true : false,
//           );
//           setShippingType(result.data.voucher.shippingType);
//         }
//         if (result.data.accounts) {
//           setAccounts(result.data.accounts);
//         }
//       }
//     } catch {
//     } finally {
//       setLoading(false);
//     }
//   }, [managerId, orderId, shippingType]);

//   const fetchOrderRef = useRef(fetchOrder);
//   fetchOrderRef.current = fetchOrder;

//   useEffect(() => {
//     if (managerId && (flag === "edit" || flag === "view")) {
//       fetchOrder();
//     }
//   }, [fetchOrder, flag, managerId, orderId, shippingType]);

//   const fetchDMs = useCallback(
//     async (warehouse, oID) => {
//       try {
//         const apiData = {
//           managerId: managerId,
//           orderId: orderId || oID,
//           wareHouse: warehouse,
//         };

//         const result = await fetchData("order/order", apiData);

//         if (result.status === "success") {
//           if (result.data.warehouses) {
//             setWarehouses(result.data.warehouses);
//           }

//           if (warehouse === "") {
//             if (result.data.accounts) {
//               setAccounts(result.data.accounts);
//               return result.data.accounts;
//             } else {
//               setAccounts([]);
//               return [];
//             }
//           } else {
//             if (result.data.dispatchmanagers?.length > 0) {
//               setDispatchManagers(
//                 result.data.dispatchmanagers.map((d) => ({
//                   label: d.name,
//                   value: d.managerId,
//                   warehousename: d.warehousename,
//                   warehouseId: d.warehouseId,
//                 })),
//               );
//             }
//           }
//         }
//       } catch (error) {}
//     },
//     [managerId, orderId],
//   );

//   const fetchDealer = useCallback(async () => {
//     try {
//       setDealerLoading(true);
//       const apiData = {
//         managerId: managerId,
//         keyword: searchDealer,
//       };

//       const result = await fetchData("order/finddealer", apiData);

//       if (result.status === "success") {
//         setDealerResults(result.data);
//       }
//       setDealerLoading(false);
//     } catch (error) {
//       setDealerLoading(false);
//     }
//   }, [managerId, searchDealer]);

//   useEffect(() => {
//     if (searchDealer) {
//       const delayDebounceFn = setTimeout(() => {
//         fetchDealer();
//       }, 700);

//       return () => clearTimeout(delayDebounceFn);
//     }
//   }, [searchDealer, fetchDealer]);

//   const handleDealerKeyDown = (e) => {
//     if (showDealerSearch) {
//       if (e.key === "ArrowDown") {
//         setCurrentIndex((prevIndex) =>
//           prevIndex < dealerResults?.length - 1 ? prevIndex + 1 : prevIndex,
//         );
//         e.preventDefault();
//       }

//       if (e.key === "ArrowUp") {
//         setCurrentIndex((prevIndex) =>
//           prevIndex > 0 ? prevIndex - 1 : prevIndex,
//         );
//         e.preventDefault();
//       }

//       if ((e.altKey || e.metaKey) && e.key.toLowerCase() === "c") {
//         setSearchDealer("");
//         setTimeout(() => {
//           openAddDealerModal();
//         }, 100);
//       }

//       if (!dealerLoading) {
//         if (e.key === "Enter") {
//           e.preventDefault();
//           handleSelectDealer(dealerResults && dealerResults[currentIndex]);
//         }
//       }
//     }
//   };

//   const openAddDealerModal = () => {
//     handleOpenModal(
//       <AdduserModel
//         focus={true}
//         close={() => handleCloseModal()}
//         onDealerAdd={(newDealer) => handleSelectDealer(newDealer)}
//       />,
//     );
//   };

//   const editBtnClick = useCallback(
//     (d) => {
//       setIsEditMode(true);
//       handleOpenModal(
//         <DealerAddressModal
//           name={"dealer_address_modal"}
//           shippingAddress={
//             shippingAddress.street ||
//             shippingAddress.city ||
//             shippingAddress.district ||
//             shippingAddress.state ||
//             shippingAddress.pincode
//               ? [
//                   shippingAddress.street,
//                   shippingAddress.city,
//                   shippingAddress.district,
//                   shippingAddress.state,
//                   shippingAddress.pincode,
//                 ]
//                   .filter(Boolean)
//                   .join(" ")
//               : undefined
//           }
//           ref={locationRef}
//           handleCloseModal={() => handleCloseModal()}
//           onAddressUpdate={(data) => {
//             if (!isModalOpen) {
//               setTimeout(() => {
//                 updateShippingAddress(d, data);
//                 itemInpRefs?.current[0]?.focus();
//               }, 0);
//             }
//           }}
//           mode={mode}
//           onKeyPress={() => {
//             if (!isModalOpen) {
//               setTimeout(() => {
//                 itemInpRefs?.current[0]?.focus();
//               }, 0);
//             }
//           }}
//         />,
//       );
//     },
//     [
//       isModalOpen,
//       mode,
//       shippingAddress.city,
//       shippingAddress.district,
//       shippingAddress.pincode,
//       shippingAddress.state,
//       shippingAddress.street,
//     ],
//   );

//   const handleSelectDealer = (d) => {
//     let doesHaveAddress = false;

//     if (!d) {
//       console.error("Dealer data is undefined!");
//       return;
//     }

//     if (
//       d.street === "" ||
//       d.city === "" ||
//       d.district === "" ||
//       d.state === "" ||
//       d.pincode === ""
//     ) {
//       doesHaveAddress = true;
//     }

//     if (d.assignedManagerId === "") {
//       setIsManagerAssigned(false);
//     }

//     if (d.shippingBlock === true) {
//       setIsShippingBlocked(true);
//     }

//     if (d.podBlock === true) {
//       setIsPodBlocked(true);
//     }

//     setSearchDealer(
//       d.name && d.storeName
//         ? `${d.storeName} / ${d.name}`
//         : d.name || d.storeName || "",
//     );

//     if ("refcode" in d) {
//       updateGeneralInfo(d);
//       updateShippingAddress(d);
//     } else {
//       handleOpenModal(
//         <DealerAddressModal
//           name={"dealer_address_modal"}
//           shippingAddress={
//             d.street || d.city || d.district || d.state || d.pincode
//               ? [d.street, d.city, d.district, d.state, d.pincode]
//                   .filter(Boolean)
//                   .join(" ")
//               : undefined
//           }
//           form={doesHaveAddress}
//           ref={locationRef}
//           handleCloseModal={() => handleCloseModal()}
//           onAddressUpdate={(data) => {
//             setUpdatedAddress(data);
//             updateGeneralInfo(d);
//             updateShippingAddress(d, data);
//           }}
//           mode={mode}
//           onKeyPress={(e) => {
//             e.preventDefault();
//             e.stopPropagation();
//             updateGeneralInfo(d);
//             updateShippingAddress(d, updatedAddress);
//           }}
//           focus={true}
//         />,
//       );
//     }
//   };

//   const updateGeneralInfo = (d) => {
//     if (d?.name === "Cash") {
//       setGeneralInfo((prevState) => ({
//         ...prevState,
//         dealerId: d?.dealerId,
//         dealerName: d?.name,
//         storeName: d?.storeName,
//         mobile: d?.mobile,
//         whatsapp: d?.whatsapp,
//         email: d?.email,
//         gstuin: d?.gstuin ? d?.gstuin : "",
//         assignedManagerId: d?.assignedManagerId || d?.refcode,
//         shippingType: "Standard",
//         courierName: "Pick Up",
//         partnerName: "Self",
//       }));
//     } else {
//       setGeneralInfo((prevState) => ({
//         ...prevState,
//         dealerId: d?.dealerId,
//         dealerName: d?.name,
//         storeName: d?.storeName,
//         mobile: d?.mobile,
//         whatsapp: d?.whatsapp,
//         email: d?.email,
//         gstuin: d?.gstuin,
//         assignedManagerId: d?.assignedManagerId || d?.refcode,
//         billingAddress:
//           (d?.street || d?.city || d?.district || d?.state || d?.pincode) &&
//           [d?.street, d?.city, d?.district, d?.state, d?.pincode]
//             .filter(Boolean)
//             .join(" "),
//       }));
//     }
//     itemInpRefs.current[0]?.focus();
//   };

//   const updateShippingAddress = (dealer, address) => {
//     setShippingAddress((prevState) => ({
//       ...prevState,
//       mobile: dealer?.mobile,
//       name: dealer?.name,
//       storeName: dealer?.storeName,
//       pincode: address?.pinCode || dealer?.pincode,
//       street: address?.streetAddress || dealer?.street,
//       city: address?.city || dealer?.city,
//       district: address?.district || dealer?.district,
//       state: address?.state || dealer?.state,
//     }));
//   };

//   const handleFocusNextItem = () => {
//     setShouldFocus(false);
//     setShowDescriptionInput(false);
//     setTimeout(() => {
//       const lastItemIndex = itemDetails?.length - 1;

//       if (itemInpRefs?.current?.length) {
//         const nextItemIndex = lastItemIndex + 1;

//         if (nextItemIndex < itemInpRefs?.current?.length) {
//           const nextItemRef = itemInpRefs?.current[nextItemIndex];
//           nextItemRef?.focus();
//           setFocusedItemIndex(nextItemIndex);
//         }
//       }
//     }, 0);
//     if (flag === "create") {
//       setShowItemSearch(true);
//     }
//   };

//   const handleItemInputFocus = (index) => {
//     setFocusedItemIndex(index);
//   };

//   const handleItemInputBlur = () => {
//     setTimeout(() => {
//       setShowItemSearch(false);
//       setFocusedItemIndex(null);
//     }, 200);
//   };

//   const handleItemChange = async (index, field, value) => {
//     setItemDetails((prevItems) => {
//       const updatedItems = [...prevItems];
//       const previousItem = { ...updatedItems[index] };

//       updatedItems[index] = { ...updatedItems[index], [field]: value };

//       if (field === "warehouseId") {
//         const oldWarehouseId = previousItem.warehouseId;
//         const newWarehouseId = value;
//         const newWarehouseName = updatedItems[index].warehouse;

//         setGeneralInfo((prevState) => {
//           const currentList = prevState.warehouses || [];

//           const isOldWarehouseStillUsed = updatedItems.some(
//             (item, i) => i !== index && item.warehouseId === oldWarehouseId,
//           );

//           let updatedList = [...currentList];

//           if (newWarehouseId && !updatedList.includes(newWarehouseId)) {
//             updatedList.push(newWarehouseId);
//           }

//           if (oldWarehouseId && !isOldWarehouseStillUsed) {
//             updatedList = updatedList.filter((wh) => wh !== oldWarehouseId);
//           }

//           return {
//             ...prevState,
//             warehouses: updatedList,
//           };
//         });

//         setShippingInfo((prevShipping) => {
//           let updatedShipping = [...prevShipping];

//           const isOldWarehouseStillUsed = updatedItems.some(
//             (item, i) => i !== index && item.warehouseId === oldWarehouseId,
//           );

//           if (oldWarehouseId && !isOldWarehouseStillUsed) {
//             updatedShipping = updatedShipping.filter(
//               (item) => item.warehouseId !== oldWarehouseId,
//             );
//           }

//           const newWarehouseExists = updatedShipping.some(
//             (item) => item.warehouseId === newWarehouseId,
//           );

//           if (!newWarehouseExists && newWarehouseId && newWarehouseName) {
//             updatedShipping.push({
//               ...initialShippingDetails,
//               warehouseId: newWarehouseId,
//               warehousename: newWarehouseName,
//             });
//           }

//           return updatedShipping;
//         });
//       }

//       return updatedItems;
//     });
//   };

//   const removeItem = (index) => {
//     setItemDetails((prevItems) => {
//       const itemToRemove = prevItems[index];
//       const updatedItems = prevItems.filter((_, i) => i !== index);

//       if (itemToRemove?.warehouseId) {
//         const isWarehouseStillUsed = updatedItems.some(
//           (item) => item.warehouseId === itemToRemove.warehouseId,
//         );

//         if (!isWarehouseStillUsed) {
//           setShippingInfo((prevShipping) =>
//             prevShipping.filter(
//               (item) => item.warehouseId !== itemToRemove.warehouseId,
//             ),
//           );
//         }
//       }

//       return updatedItems;
//     });
//   };

//   const handleAddNewItem = () => {
//     const errors = [];

//     if (!itemDetails || itemDetails.length === 0) {
//       errors.push("No items to validate");
//     } else {
//       itemDetails.forEach((item, index) => {
//         if (item.outsourcedItem === "Disable") {
//           if (!item.itemNo)
//             errors.push(`Item ${index + 1}: Item Number cannot be empty`);
//           if (!item.qty)
//             errors.push(`Item ${index + 1}: Quantity cannot be empty`);
//           if (item.qty > item.totalQty) {
//             errors.push(
//               `Item ${index + 1}: Quantity exceeds available stock (${
//                 item.totalQty
//               })`,
//             );
//           }
//         } else if (item.outsourcedItem === "Active") {
//           if (!item.itemNo)
//             errors.push(`Item ${index + 1}: Item Number cannot be empty`);
//           if (!item.qty)
//             errors.push(`Item ${index + 1}: Quantity cannot be empty`);
//           if (item.qty > item.outSourceItemlimit) {
//             errors.push(
//               `Item ${index + 1}: Quantity exceeds limit (${
//                 item.outSourceItemlimit
//               })`,
//             );
//           }
//         }
//       });
//     }

//     if (errors.length > 0) {
//       show(errors.join("\n"), "warning");
//     } else {
//       // ── New item gets a fresh UID ──────────────────────────────────────
//       setItemDetails((prev) => [
//         ...prev,
//         { ...initialItemDetails, _uid: genUid() },
//       ]);
//       // ──────────────────────────────────────────────────────────────────
//       handleFocusNextItem();

//       setTimeout(() => {
//         scroll_wrapper_ref.current?.scrollBy({
//           top: 100,
//           behavior: "smooth",
//         });
//       }, 100);
//     }
//   };

//   const handleOpenModal = (content) => {
//     setShouldFocus(false);
//     setIsModalOpen(true);
//     setModalContent(content);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setModalContent(null);
//   };

//   const handleAddReceipt = useCallback(
//     async (updatedData, newOrderId, receiptId) => {
//       const formData = new FormData();
//       formData.append(
//         "transactionScreenshot",
//         updatedData.transactionScreenshot
//           ? updatedData.transactionScreenshot
//           : "",
//       );
//       formData.append(
//         "paymentMethod",
//         updatedData.paymentMethod ? updatedData.paymentMethod : "",
//       );
//       formData.append(
//         "paymentType",
//         updatedData.paymentType ? updatedData.paymentType : "",
//       );
//       formData.append(
//         "paymentAmount",
//         updatedData.paymentAmount
//           ? parseFloat(updatedData.paymentAmount).toFixed(2)
//           : "",
//       );
//       formData.append(
//         "transactionId",
//         updatedData.transactionId ? updatedData.transactionId : "",
//       );
//       formData.append(
//         "accountNumber",
//         updatedData.accountNumber ? updatedData.accountNumber : "",
//       );
//       formData.append(
//         "warehousename",
//         updatedData.warehousename ? updatedData.warehousename : "",
//       );
//       formData.append(
//         "totalAmount",
//         generalInfo.totalAmount ? generalInfo.totalAmount.toFixed(2) : "",
//       );

//       const orderIdentifier = newOrderId || orderId;

//       try {
//         const result = await handleFileData(
//           `receipt/offlinePay/${managerId}/${orderIdentifier}?receiptId=${
//             receiptId && receiptId
//           }`,
//           formData,
//         );
//         if (result.status === "success") {
//           show(result.msg, "success");
//           handleCloseModal();
//           setTimeout(async () => {
//             await fetchOrderRef.current();
//           }, 0);
//         }
//         if (result.status === "warning") {
//           setModalContent(
//             <Warning
//               message={result?.msg}
//               items={result?.items}
//               orderdItems={result?.orderdItems}
//               mode={mode}
//               handleCloseModal={handleCloseModal}
//             />,
//           );
//         }
//         if (result.status === "warn") {
//           show(result.msg, "error");
//         }
//         if (result.status === "failed") {
//           show(result.msg, "error");
//         }
//       } catch (error) {}
//     },
//     [generalInfo.totalAmount, managerId, mode, orderId, show],
//   );

//   const updateReceiptData = useCallback(
//     (updatedData, newOrderId, receiptId) => {
//       setReceiptData(updatedData);
//       setTimeout(async () => {
//         handleAddReceipt(updatedData, newOrderId, receiptId);
//       }, 0);
//     },
//     [handleAddReceipt],
//   );

//   const isSelf = shippingInfo?.methodName === "Self";

//   const orderSuccessKeyPress = useCallback(
//     (action, link, oID, acc) => {
//       const whatsappNo = generalInfo?.whatsapp || "Not Provided";
//       const mobileNo = generalInfo?.mobile || "Not Provided";
//       const email = generalInfo?.email || "Not Provided";
//       const generatedLink = link || paymentLink || "No Link Available";
//       const newOrderId = orderId || oID || "No Order Id Available";
//       const accounts2 = acc || accounts;

//       if (action === "shareLink") {
//         setTimeout(() => {
//           handleOpenModal(
//             <ShareLinkModal
//               mode={mode}
//               managerId={managerId}
//               handleCloseModal={handleCloseModal}
//               generatedLink={generatedLink}
//               whatsappNo={whatsappNo}
//               mobileNo={mobileNo}
//               email={email}
//               isModalOpen={true}
//             />,
//           );
//         }, 0);
//       } else if (action === "addReceipt") {
//         setTimeout(() => {
//           handleOpenModal(
//             <AddReceiptModal
//               handleCloseModal={handleCloseModal}
//               mode={mode}
//               totalAmount={generalInfo.totalAmount}
//               accounts={accounts2}
//               receiptData={receiptData && receiptData}
//               updateReceiptData={async (updatedData) =>
//                 updateReceiptData(updatedData, newOrderId)
//               }
//               type={"create"}
//               isPodBlocked={isPodBlocked}
//               uniqueWarehouses={uniqueWarehouses}
//               shippingType={shippingType}
//               dispatchWarehouse={dispatchWarehouse}
//               setReceiptData={setReceiptData}
//               isModalOpen={isModalOpen}
//               receiptTotalAmount={receiptTotalAmount}
//               isSelf={isSelf}
//             />,
//           );
//         }, 0);
//       }
//     },
//     [
//       generalInfo?.whatsapp,
//       generalInfo?.mobile,
//       generalInfo?.email,
//       generalInfo.totalAmount,
//       paymentLink,
//       orderId,
//       accounts,
//       mode,
//       managerId,
//       receiptData,
//       isPodBlocked,
//       uniqueWarehouses,
//       shippingType,
//       dispatchWarehouse,
//       isModalOpen,
//       receiptTotalAmount,
//       isSelf,
//       updateReceiptData,
//     ],
//   );

//   const generatePaymentLink = useCallback(
//     async (oId) => {
//       setPaymentLink("");
//       const currentOrderId = oId || orderId;
//       if (!currentOrderId) {
//         return;
//       }
//       try {
//         const apiData = { orderId: currentOrderId };
//         const result = await fetchData("receipt/generatePaymentLink", apiData);
//         if (result.status === "success" && result.shortUrl) {
//           const link = `${result.shortUrl}`;
//           setPaymentLink(link);
//           return link;
//         } else {
//         }
//       } catch (error) {}
//     },
//     [orderId],
//   );

//   // ── Strip _uid before sending to API ──────────────────────────────────────
//   const getValidSaleItems = (items) => {
//     return items
//       ?.filter((item) =>
//         Object.values(item).some(
//           (value) => value !== "" && value !== null && value !== undefined,
//         ),
//       )
//       .map(({ _uid, ...rest }) => rest); // _uid never reaches the API
//   };
//   // ──────────────────────────────────────────────────────────────────────────

//   // const handleSaleOrder = useCallback(
//   //   async (status, id, s) => {
//   //     if (
//   //       generalInfo.partnerName === "" &&
//   //       generalInfo.methodName === "" &&
//   //       generalInfo.courierName === ""
//   //     ) {
//   //       show("Delivery details are required!", "error");
//   //       return;
//   //     }
//   //     const assignedManagerId = isManagerAssigned
//   //       ? generalInfo.assignedManagerId
//   //       : id;

//   //     try {
//   //       setLoading(true);

//   //       const shippingCharge =
//   //         generalInfo.deliveryPartner === "Self"
//   //           ? 0
//   //           : generalInfo.shippingCharge;

//   //       const apiData = {
//   //         managerId: managerId,
//   //         orderId: orderId,
//   //         gstuin: generalInfo.gstuin,
//   //         assignedManagerId: assignedManagerId,
//   //         dealerId: generalInfo.dealerId,
//   //         shippingType: shippingType,
//   //         name: shippingAddress.name,
//   //         street: shippingAddress.street,
//   //         mobile: shippingAddress.mobile,
//   //         pincode: shippingAddress.pincode,
//   //         city: shippingAddress.city,
//   //         district: shippingAddress.district,
//   //         state: shippingAddress.state,
//   //         shippingCharge: shippingCharge,
//   //         toPay: generalInfo.toPay || false,
//   //         saleItems: getValidSaleItems(itemDetails),
//   //         role: designation,
//   //         status: status,
//   //         shippingInfo: s,
//   //       };

//   //       const result = await fetchData("order/saleOrder", apiData);

//   //       if (result.status === "success") {
//   //         setLoading(false);

//   //         if (status === "success") {
//   //           if (!orderId) {
//   //             navigate(
//   //               `/orders/order/productionAndSale?orderId=${result.data.orderId}`,
//   //             );
//   //           }
//   //           setShowSave(false);
//   //           setIsEditMode(false);
//   //           dispatch(setFilter({ selectedOption: "" }));
//   //           setShowItemSearch(false);

//   //           const oID = result.data.orderId;

//   //           setTimeout(async () => {
//   //             const link = await generatePaymentLink(oID);
//   //             const acc = await fetchDMs("", result.data.orderId);
//   //             setTimeout(() => {
//   //               handleOpenModal(
//   //                 <OrderSuccessModal
//   //                   mode={mode}
//   //                   handleCloseModal={handleCloseModal}
//   //                   orderSuccessKeyPress={(action) =>
//   //                     orderSuccessKeyPress(action, link, oID, acc)
//   //                   }
//   //                 />,
//   //               );
//   //             }, 100);
//   //           }, 100);
//   //         } else if (status === "draft") {
//   //           navigate("/orders");
//   //         }
//   //       } else if (result.status === "assignManager") {
//   //         setLoading(false);
//   //         dispatch(setFilter({ selectedOption: "" }));
//   //         setOrderManagers(result.orderManagers);
//   //       } else {
//   //         show(result.msg, "warning");
//   //         setLoading(false);
//   //       }
//   //     } catch (error) {
//   //       setLoading(false);
//   //     }
//   //   },
//   //   [
//   //     generalInfo.partnerName,
//   //     generalInfo.methodName,
//   //     generalInfo.courierName,
//   //     generalInfo.assignedManagerId,
//   //     generalInfo.deliveryPartner,
//   //     generalInfo.shippingCharge,
//   //     generalInfo.gstuin,
//   //     generalInfo.dealerId,
//   //     generalInfo.toPay,
//   //     isManagerAssigned,
//   //     show,
//   //     managerId,
//   //     orderId,
//   //     shippingType,
//   //     shippingAddress.name,
//   //     shippingAddress.street,
//   //     shippingAddress.mobile,
//   //     shippingAddress.pincode,
//   //     shippingAddress.city,
//   //     shippingAddress.district,
//   //     shippingAddress.state,
//   //     itemDetails,
//   //     designation,
//   //     dispatch,
//   //     navigate,
//   //     generatePaymentLink,
//   //     fetchDMs,
//   //     mode,
//   //     orderSuccessKeyPress,
//   //   ],
//   // );

//   const handleInstructionChange = useCallback((warehouseId, instruction) => {
//     setShippingInfo((prev) => {
//       const updated = prev.map((s) =>
//         s.warehouseId === warehouseId
//           ? { ...s, delInstruction: instruction }
//           : s,
//       );
//       return updated;
//     });
//   }, []);

//   const handleSubmit = useCallback(() => {
//     handleOpenModal(
//       <ConfirmOrder
//         heading={"Confirm Order"}
//         centerHeading={"Are you sure want to place this Order?"}
//         targetWord={"order"}
//         handleCloseModal={() => handleCloseModal()}
//         handleSubmit={async (status, id) => {
//           // await handleSaleOrder(status, id, shippingInfoRef.current);
//         }}
//         isManagerAssigned={isManagerAssigned}
//         orderManagers={orderManagers}
//         handleOpenModal={handleOpenModal}
//         shippingType={shippingType}
//         itemDetails={itemDetails}
//         setShippingInfo={setShippingInfo}
//         handleInstructionChange={handleInstructionChange}
//         instructions={instructions}
//         setInstructions={setInstructions}
//       />,
//     );
//   }, [
//     handleInstructionChange,
//     // handleSaleOrder,
//     instructions,
//     isManagerAssigned,
//     itemDetails,
//     orderManagers,
//     shippingType,
//   ]);

//   const handleSkipShippingCharges = useCallback(
//     (dw) => {
//       if (shippingType === "Combined") {
//         setShippingInfo((prev) =>
//           prev.map((item) => ({
//             ...item,
//             isDispatchWarehouse: item.warehouseId === dw.value,
//           })),
//         );
//       } else {
//         setShippingInfo((prev) =>
//           prev.map((item) => ({
//             ...item,
//             isDispatchWarehouse: true,
//           })),
//         );
//       }
//       setGeneralInfo((prevState) => ({
//         ...prevState,
//         courierName: "Pick Up",
//         toPay: false,
//         deliveryPartners: prevState.deliveryPartners
//           ? [...prevState.deliveryPartners, { label: "Self", value: "Self" }]
//           : [{ label: "Self", value: "Self" }],
//       }));
//       setSkipped(true);
//     },
//     [shippingType],
//   );

//   if (skipped) {
//     setTimeout(() => {
//       handleSubmit();
//     }, 700);
//     setSkipped(false);
//   }

//   const openShippingChargesInfoModal = useCallback(
//     (s, dw, tempShippingInfo, uw) => {
//       setUniqueWarehouses(uw);
//       handleOpenModal(
//         <ProSaleShippingChargesInfoModal
//           mode={mode}
//           handleCloseModal={handleCloseModal}
//           shippingType={s}
//           itemDetails={itemDetails}
//           shippingInfo={tempShippingInfo}
//           setShippingInfo={setShippingInfo}
//           dw={dw}
//           ref={checkboxRef}
//         />,
//       );
//     },
//     [itemDetails, mode],
//   );

//   // const openSelectDMModal = useCallback(
//   //   (s, dw, tempShippingInfo, uw) => {
//   //     handleOpenModal(
//   //       <SelectDM
//   //         mode={mode}
//   //         handleCloseModal={handleCloseModal}
//   //         uniqueWarehouses={uw}
//   //         dispatchManagers={dispatchManagersRef.current}
//   //         setShippingInfo={setShippingInfo}
//   //         openShippingChargesInfoModal={() =>
//   //           openShippingChargesInfoModal(s, dw, tempShippingInfo, uw)
//   //         }
//   //       />,
//   //     );
//   //   },
//   //   [mode, openShippingChargesInfoModal],
//   // );

//   const selectDispatchWarehouse = useCallback(
//     (value) => {
//       setDispatchWarehouse(value);
//       setReceiptData((prev) => ({
//         ...prev,
//         warehousename: value.label,
//         warehouseId: value.value,
//       }));
//       setShippingInfo((prev) => {
//         const updatedShippingInfo = prev.map((item) => ({
//           ...item,
//           isDispatchWarehouse:
//             item.warehouseId === value?.value ||
//             item.warehousename === value.label,
//         }));
//         return updatedShippingInfo;
//       });

//       setTimeout(() => {
//         setShippingInfo((prev) => {
//           fetchDMs(
//             prev.map(({ warehouseId, isDispatchWarehouse }) => ({
//               warehouseId,
//               isDispatchWarehouse,
//             })),
//             "",
//           );
//           return prev;
//         });
//       }, 0);
//     },
//     [fetchDMs],
//   );

//   const openShippingModal2 = useCallback(
//     (shippingType, type2) => {
//       handleOpenModal(
//         <ProSaleShippingChargesModal2
//           mode={mode}
//           orderId={orderId}
//           close={() => handleCloseModal()}
//           skipShippingCharges={(dw) => handleSkipShippingCharges(dw)}
//           itemsdetails={getValidSaleItems(itemDetails)}
//           isShippingBlocked={isShippingBlocked}
//           shippingType={shippingType}
//           pincode={shippingAddress.pincode}
//           shippingInfo={shippingInfo}
//           setShippingInfo={setShippingInfo}
//           // openSelectDMModal={openSelectDMModal}
//           openShippingChargesInfoModal={openShippingChargesInfoModal}
//           setGeneralInfo={setGeneralInfo}
//           type2={type2}
//           // fetchDMs={(a, b) => fetchDMs(a, b)}
//           setDispatchWarehouse={setDispatchWarehouse}
//           selectDispatchWarehouse={selectDispatchWarehouse}
//         />,
//       );
//     },
//     [
//       mode,
//       orderId,
//       itemDetails,
//       isShippingBlocked,
//       shippingAddress.pincode,
//       shippingInfo,
//       // openSelectDMModal,
//       selectDispatchWarehouse,
//       handleSkipShippingCharges,
//       // fetchDMs,
//     ],
//   );

//   useEffect(() => {
//     if (isModalOpen && modalContent?.type === ConfirmOrder) {
//       handleSubmit();
//     }
//   }, [handleSubmit, isModalOpen, modalContent?.type]);

//   useEffect(() => {
//     if (flag === "edit" || flag === "view") {
//       generatePaymentLink(orderId);
//     }
//   }, [flag, generatePaymentLink, orderId]);

//   const handleCancelOrder = async () => {
//     const apiData = {
//       managerId: managerId,
//       orderId: orderId,
//     };
//     try {
//       const result = await fetchData("order/cancelOrder", apiData);
//       if (result.status === "success") {
//         show("Order cancelled successfully", "success");
//         navigate("/orders");
//       }
//     } catch (error) {
//       show(error, "error");
//     }
//   };

//   const handleRequestForCancel = async (reason, warehouseId) => {
//     const apiData = {
//       managerId: managerId,
//       orderId: orderId,
//       reqType: "Request For Cancel",
//       reqIssue: reason,
//       warehouseId: warehouseId,
//     };
//     try {
//       const result = await fetchData("order/orderhelp", apiData);
//       if (result.status === "success") {
//         show(result.msg, "success");
//         navigate("/orders");
//       } else {
//         show(result.msg, "warning");
//       }
//     } catch (error) {
//       show(error, "error");
//     }
//   };

//   const openCancelOrderModal = () => {
//     handleOpenModal(
//       <ManagerModal
//         heading={"Cancel Order"}
//         centerHeading={"Are you sure want to cancel this Order?"}
//         subHeading={"To confirm! type cancel in the text field."}
//         targetWord={"cancel"}
//         handleCloseModal={() => handleCloseModal()}
//         handleSubmit={() => handleCancelOrder()}
//         focus={true}
//       />,
//     );
//   };

//   const openRequestForCancelModal = () => {
//     handleOpenModal(
//       <RequestForCancelModal
//         mode={mode}
//         handleCloseModal={() => handleCloseModal()}
//         handleSubmit={(reason, warehouseId) =>
//           handleRequestForCancel(reason, warehouseId)
//         }
//         type="order"
//         uniqueWarehouses={uniqueWarehouses}
//       />,
//     );
//   };

//   const openShippingTypeModal = () => {
//     handleOpenModal(
//       <ShippingTypeModal
//         mode={mode}
//         handleCloseModal={() => handleCloseModal()}
//         setShippingType={setShippingType}
//         openShippingModal2={(shippingType) => openShippingModal2(shippingType)}
//       />,
//     );
//   };

//   const dispatchDetailsClick = () => {
//     if (shippingInfo.length === 1) {
//       navigate(
//         "/dispatch/details/" + orderId + "/" + shippingInfo[0].warehouseId,
//       );
//     } else {
//       handleOpenModal(
//         <SelectWarehouse
//           mode={mode}
//           handleCloseModal={() => handleCloseModal()}
//           orderId={orderId}
//           shippingInfo={shippingInfo}
//         />,
//       );
//     }
//   };

//   useEffect(() => {
//     itemInpRefs.current = Array(itemDetails.length)
//       .fill()
//       .map((_, i) => itemInpRefs.current[i] || null);
//   }, [itemDetails.length]);

//   useEffect(() => {
//     const handleKeyDown = (event) => {
//       if (event.key === "Tab") {
//         event.preventDefault();
//       }

//       if (loadingBtn) {
//         event.preventDefault();
//         event.stopPropagation();
//       }

//       if (flag === "edit" && !isModalOpen) {
//         const isInputFocused = ["INPUT", "TEXTAREA", "SELECT"].includes(
//           document.activeElement.tagName,
//         );
//         if (
//           !isInputFocused &&
//           generalInfo.orderType !== "online" &&
//           event.key.toLowerCase() === "e"
//         ) {
//           event.preventDefault();
//           editBtnClick();
//         }
//       }
//     };

//     window.addEventListener("keydown", handleKeyDown, true);

//     return () => {
//       window.removeEventListener("keydown", handleKeyDown, true);
//     };
//   }, [editBtnClick, flag, isModalOpen, loadingBtn, generalInfo.orderType]);

//   useEffect(() => {
//     if (!itemDetails || itemDetails.length === 0) return;

//     const amount = itemDetails.reduce((sum, item) => {
//       if (item.amount && !isNaN(item.amount)) {
//         return sum + parseFloat(item.amount);
//       }
//       return sum;
//     }, 0);

//     const cartPriceSum = itemDetails.reduce((sum, currentItem) => {
//       return (
//         sum +
//         parseFloat(currentItem.price ?? 0) * parseFloat(currentItem.qty ?? 0)
//       );
//     }, 0);

//     const cartTotal = itemDetails
//       .map((x) =>
//         !x.accessories
//           ? 0
//           : x.accessories
//               .map((y) => (y.accessoriesQty ?? 0) * (y.accessoriesPrice ?? 0))
//               .reduce((a, b) => a + b, 0),
//       )
//       .reduce((a, b) => a + b, 0);

//     const subtotal = (cartPriceSum ?? 0) + (cartTotal ?? 0);

//     const gettotalAmount =
//       subtotal +
//       parseFloat(
//         generalInfo.toPay
//           ? 0
//           : generalInfo.deliveryPartner === "Self"
//             ? 0
//             : (generalInfo.shippingCharge ?? 0),
//       );

//     const totalAmount = Math.round(gettotalAmount);

//     setGeneralInfo((prev) => ({
//       ...prev,
//       amount,
//       cartPriceSum,
//       cartTotal,
//       subtotal,
//       totalAmount,
//     }));
//   }, [
//     itemDetails,
//     generalInfo.toPay,
//     generalInfo.deliveryPartner,
//     generalInfo.shippingCharge,
//   ]);

//   useEffect(() => {
//     const { totalAmount } = receipts.reduce(
//       (acc, receipt) => {
//         if (receipt.status === "Received") {
//           acc.totalAmount += receipt.paymentAmount;
//         }
//         if (receipt.status === "Cancelled") {
//           acc.cancelledAmount += receipt.paymentAmount;
//         }
//         return acc;
//       },
//       { totalAmount: 0, cancelledAmount: 0 },
//     );

//     setReceiptTotalAmount(totalAmount);
//   }, [receipts]);

//   const allReceived = receipts.every(
//     (receipt) => receipt.status === "Received",
//   );

//   const hasPod = receipts.some((receipt) => receipt.status === "POD Pending");

//   const shouldShowRequestForCancel =
//     orderId &&
//     ["Packing In Progress", "Packed", "Dispatched"].includes(
//       generalInfo.status,
//     ) &&
//     generalInfo.status !== "Cancelled" &&
//     generalInfo.reqType !== "Request For Cancel";

//   const shouldShowCancelOrder =
//     orderId &&
//     ["Payment Pending", "Payment Under Verification"].includes(
//       generalInfo.status,
//     ) &&
//     generalInfo.status !== "Cancelled" &&
//     generalInfo.reqType !== "Request For Cancel";

//   // const hasDispatchedOrCompleted = shippingInfo.some(
//   //   (item) =>
//   //     item.dispatchStatus === "Completed" ||
//   //     item.dispatchStatus === "Dispatched",
//   // );

//   const hasDispatchedOrCompleted =
//     allOrdersData?.voucher?.dispatchStatus === "Completed" ||
//     allOrdersData?.voucher?.dispatchStatus === "Dispatched";

//   useEffect(() => {
//     onOrderData({
//       loading,
//       orderId,
//       type: generalInfo.orderType,
//       status: generalInfo.status,
//       orderManagerName: generalInfo.orderManagerName,
//       createdBy: generalInfo.createdBy,
//       orderDate: generalInfo.orderDate,
//     });
//   }, [
//     generalInfo.createdBy,
//     generalInfo.orderDate,
//     generalInfo.orderManagerName,
//     generalInfo.orderType,
//     generalInfo.status,
//     loading,
//     onOrderData,
//     orderId,
//   ]);

//   const verifyEntries = () => {
//     const warnings = [];
//     if (
//       itemDetails.every(
//         (item) =>
//           item.amount === "" &&
//           item.price === "" &&
//           item.unit === "" &&
//           item.qty === "" &&
//           item.itemNo === "",
//       ) ||
//       itemDetails.some((item) =>
//         Object.values(item).every((value) => value === ""),
//       )
//     ) {
//       warnings.push("Item Details are required");
//     }
//     if (warnings?.length === 0) {
//       return true;
//     } else {
//       show(warnings.join(" "), "warning");
//       return false;
//     }
//   };

//   // const totalShippingCharges = shippingInfo?.reduce(
//   //   (sum, item) => sum + (Number(item?.shippingCharge) || 0),
//   //   0,
//   // );

//   const totalShippingCharges = shippingInfo?.shippingCharge;

//   useEffect(() => {
//     setGeneralInfo((prev) => ({
//       ...prev,
//       shippingCharge: totalShippingCharges,
//     }));
//   }, [totalShippingCharges]);

//   // const headerData = [
//   //   "S.No",
//   //   "Item No",
//   //   "Product",
//   //   "Collection",
//   //   // "Warehouse",
//   //   "Quantity",
//   //   "Unit",
//   //   "Rate",
//   //   "Amount",
//   // ];

//   const isLiveEditingItems =
//     flag === "create" || (flag === "edit" && isEditMode);
//   const headerData = useMemo(() => {
//     const base = [
//       "S.No",
//       "Item No",
//       "Product",
//       "Collection",
//       "Quantity",
//       "Unit",
//       "Rate",
//       "Amount",
//     ];
//     const action = !isLiveEditingItems && selectedVersion ? ["Action"] : [];
//     return [...base, ...action];
//   }, [isLiveEditingItems, selectedVersion]);

//   const printSummarySlip = useReactToPrint({
//     content: () => summarySlipRef.current,
//   });

//   const handlePrintSummary = async () => {
//     await fetchOrder();
//     setTimeout(() => {
//       printSummarySlip();
//     }, 300);
//   };

//   const openAdvancePaymentInfoModal = (data) => {
//     handleOpenModal(<AdvanceAmountModalInfo mode={mode} data={data} />);
//   };

//   const displayedItems = useMemo(() => {
//     if (isLiveEditingItems) return itemDetails;
//     if (selectedVersion) {
//       const entry = versionsData.find((v) => v.version === selectedVersion);
//       return (entry?.items || []).map((change) => ({
//         _uid: change.itemId + "-" + change.version,
//         itemId: change.itemId,
//         action: change.action,
//         updatedBy: change.updatedBy,
//         updateTime: change.updateTime,
//         changes: change.changes || [], // ← this was missing
//         ...change.data,
//       }));
//     }
//     return itemDetails;
//   }, [isLiveEditingItems, selectedVersion, versionsData, itemDetails]);

//   const hasVersionHistory = versionsData?.length > 0;

//   // ────────────────────────────────────────────────────────────────────────

//   return (
//     <>
//       <ModalWrapper isOpen={isModalOpen} onClose={handleCloseModal} noBtn>
//         {modalContent}
//       </ModalWrapper>

//       <div className={styles.so_scroll_wrapper} ref={scroll_wrapper_ref}>
//         <form className={styles.so_form}>
//           <div className={styles.so_form_1}>
//             {loading && (flag === "edit" || flag === "view") ? (
//               <div>
//                 <Skeleton
//                   lines={1}
//                   thickness={4.5}
//                   additionalStyles={{
//                     marginBottom: "0px",
//                     marginTop: "20px",
//                   }}
//                 />
//               </div>
//             ) : (
//               <div style={{ position: "relative" }}>
//                 <InputTag
//                   ref={dealerInpRef}
//                   labelText={"Company or Dealer's Name / ID"}
//                   placeholderText={"Search Dealer"}
//                   padding={"8px"}
//                   fontSize={"12px"}
//                   value={
//                     useFallback && !searchDealer
//                       ? generalInfo.storeName && generalInfo.dealerName
//                         ? `${generalInfo.storeName} / ${generalInfo.dealerName}`
//                         : generalInfo.storeName || generalInfo.dealerName || ""
//                       : searchDealer
//                   }
//                   onChange={(e) => {
//                     setSearchDealer(e.target.value);
//                     setUseFallback(false);
//                   }}
//                   onFocus={() => {
//                     if (flag === "create") {
//                       setShowDealerSearch(true);
//                     }
//                   }}
//                   onBlur={() => {
//                     setShowDealerSearch(false);
//                     if (searchDealer === "") {
//                       setUseFallback(true);
//                     }
//                   }}
//                   onKeyDown={(e) => handleDealerKeyDown(e)}
//                   maxLength={100}
//                   required
//                   enterKeyHint={"enter"}
//                   readOnly={flag === "view"}
//                 />

//                 {showDealerSearch && (
//                   <SearchDealer
//                     mode={mode}
//                     results={dealerResults}
//                     loading={dealerLoading}
//                     currentIndex={currentIndex}
//                     onDealerSelect={handleSelectDealer}
//                     openAddDealerModal={openAddDealerModal}
//                   />
//                 )}
//               </div>
//             )}

//             {loading && (flag === "edit" || flag === "view") ? (
//               <div>
//                 <Skeleton
//                   lines={1}
//                   thickness={4.5}
//                   additionalStyles={{
//                     marginBottom: "0px",
//                     marginTop: "20px",
//                   }}
//                 />
//               </div>
//             ) : (
//               <div>
//                 <InputTag
//                   labelText={"Shipping Address"}
//                   placeholderText={"Enter Dealer Address"}
//                   value={
//                     [
//                       shippingAddress.street,
//                       shippingAddress.city,
//                       shippingAddress.district,
//                       shippingAddress.state,
//                       shippingAddress.pincode,
//                     ]
//                       .filter(Boolean)
//                       .join(" ") || ""
//                   }
//                   padding={"8px"}
//                   fontSize={"12px"}
//                   required
//                 />
//               </div>
//             )}
//           </div>

//           <div className={styles.so_form_1}>
//             <div>
//               {loading && (flag === "edit" || flag === "view") ? (
//                 <div style={{ width: "100%" }}>
//                   <Skeleton
//                     lines={1}
//                     thickness={4.5}
//                     additionalStyles={{
//                       marginBottom: "0px",
//                       marginTop: "20px",
//                     }}
//                   />
//                 </div>
//               ) : (
//                 <div className={styles.warehouse_selectors}>
//                   <div
//                     style={{
//                       width: "100%",
//                       position: "relative",
//                     }}
//                   >
//                     {flag !== "create" && (
//                       <div className={styles.voucher_det}>
//                         <p style={{ color: mode && "#FFFFFF" }}>
//                           {shippingType}
//                         </p>
//                       </div>
//                     )}

//                     <div>
//                       <InputTag
//                         labelText={"Warehouse"}
//                         placeholderText={"Warehouse"}
//                         padding={"8px"}
//                         fontSize={"12px"}
//                         value={allOrdersData?.voucher?.warehousename}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>

//             {loading && (flag === "edit" || flag === "view") ? (
//               <div>
//                 <Skeleton
//                   lines={1}
//                   thickness={4.5}
//                   additionalStyles={{
//                     marginBottom: "0px",
//                     marginTop: "20px",
//                   }}
//                 />
//               </div>
//             ) : (
//               <div>
//                 <div style={{ width: "100%", position: "relative" }}>
//                   <div className={styles.voucher_det}>
//                     <p style={{ color: mode && "#FFFFFF" }}>
//                       {shippingInfo?.courierName}
//                     </p>
//                   </div>

//                   <div>
//                     <InputTag
//                       labelText={"Delivery Method"}
//                       placeholderText={"Delivery Method"}
//                       padding={"8px"}
//                       fontSize={"12px"}
//                       value={
//                         shippingInfo?.methodName || shippingInfo?.partnerName
//                       }
//                     />
//                   </div>

//                   {isEditMode && (
//                     <div className={styles.change_ship}>
//                       <span
//                         style={{ color: !mode && "#4164E3" }}
//                         onClick={() => openShippingModal2(shippingType, "")}
//                       >
//                         Update
//                       </span>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             )}
//           </div>
//         </form>

//         {/* ------------------------- Version History -------------------------- */}

//         {!isLiveEditingItems && hasVersionHistory && (
//           <div
//             style={{
//               flex: 1,
//               display: "flex",
//               flexDirection: "row",
//               marginTop: "10px",
//               alignItems: "center",
//               gap: "6px",
//             }}
//           >
//             <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//               <span
//                 style={{ fontSize: 14, color: mode ? "#ffffff" : "#000000" }}
//               >
//                 Version History
//               </span>

//               <SlidingFilter
//                 itemList={[
//                   "Current",
//                   ...[...versionsData]
//                     .sort((a, b) => b.version - a.version)
//                     .map((v) => `Version ${v.version}`),
//                 ]}
//                 activeFilter={
//                   selectedVersion ? `Version ${selectedVersion}` : "Current"
//                 }
//                 setFilter={(label) =>
//                   setSelectedVersion(
//                     label === "Current"
//                       ? null
//                       : Number(label.replace("Version ", "")),
//                   )
//                 }
//               />
//             </div>

//             {selectedVersion &&
//               (() => {
//                 const entry = versionsData.find(
//                   (v) => v.version === selectedVersion,
//                 );
//                 if (!entry) return null;
//                 const { updatedBy, updateTime } = getVersionMeta(entry);
//                 return (
//                   <div
//                     style={{
//                       fontSize: 12,
//                       color: "#4164E3",
//                       fontWeight: 600,
//                     }}
//                   >
//                     {updatedBy}
//                     {" • "}
//                     {formatDateTime(updateTime)}
//                   </div>
//                 );
//               })()}
//           </div>
//         )}
//         {/* ----------------------------------------------------------------------- */}

//         <ul className={styles.p_table}>
//           <div
//             className={styles.p_table_header_con}
//             style={{
//               visibility: loading && "hidden",
//             }}
//           >
//             <li
//               className={`${styles.p_table_header} ${
//                 mode ? styles.p_table_header_dark : ""
//               }`}
//             >
//               {headerData?.map((h, index) => (
//                 <div className={styles.entry_2} key={`${h}-${index}`}>
//                   {h}
//                 </div>
//               ))}
//             </li>
//             {(flag === "create" || isEditMode) && itemDetails?.length > 1 && (
//               <div
//                 style={{
//                   visibility: "hidden",
//                   display: flag === "view" && "none",
//                 }}
//               >
//                 <RemoveIcon />
//               </div>
//             )}
//           </div>

//           <div className={styles.p_table_list}>
//             <>
//               {displayedItems?.map((item, index) => (
//                 // ── Use _uid as key so removing an item never shifts
//                 //    React component instances or their local state ──────
//                 <React.Fragment key={item._uid ?? `${item.itemNo}-${index}`}>
//                   {isLiveEditingItems ? (
//                     <ProductionSaleNewItemList
//                       mode={mode}
//                       index={index}
//                       item={item}
//                       itemInpRefs={(el) => {
//                         if (el) itemInpRefs.current[index] = el;
//                       }}
//                       quantityRefs={qtyInputRefs}
//                       onItemChange={(field, value) =>
//                         handleItemChange(index, field, value)
//                       }
//                       onRemove={() => removeItem(index)}
//                       onAddNewItem={handleAddNewItem}
//                       itemDetailsLength={itemDetails.length}
//                       itemFocus={handleItemInputFocus}
//                       itemBlur={handleItemInputBlur}
//                       focusedItemIndex={focusedItemIndex}
//                       showItemSearch={showItemSearch}
//                       setShowItemSearch={setShowItemSearch}
//                       onShowDesc={(value) => setShowDescriptionInput(value)}
//                       onCompletion={() => {
//                         if (shippingInfo.length === 1) {
//                           openShippingModal2("Combined", "normal");
//                         } else {
//                           openShippingTypeModal();
//                         }
//                       }}
//                       flag={flag}
//                       allItems={displayedItems}
//                     />
//                   ) : (
//                     <>
//                       {loading ? (
//                         <div>
//                           <Skeleton
//                             lines={
//                               displayedItems?.length === 1
//                                 ? 1
//                                 : displayedItems?.length / 2
//                             }
//                             thickness={5}
//                             additionalStyles={{
//                               marginBottom: "0px",
//                               marginTop: "0px",
//                             }}
//                           />
//                         </div>
//                       ) : (
//                         <DataItemListProAndSale
//                           d={item}
//                           index={index}
//                           mode={mode}
//                           voucherType={"Production & Sale"}
//                           selectedVersion={selectedVersion}
//                           isLiveEditingItems={isLiveEditingItems}
//                         />
//                       )}
//                     </>
//                   )}
//                 </React.Fragment>
//               ))}
//             </>
//           </div>

//           {(flag === "create" || isEditMode) && (
//             <div
//               className={styles.cricle_btn}
//               onClick={() => {
//                 handleAddNewItem();
//               }}
//             >
//               <TestTopAddDealerIcon color="#4164E3" />
//             </div>
//           )}

//           {showDescriptionInput && (flag === "create" || flag === "edit") && (
//             <div className={styles.so_instc}>
//               <p>Press Enter to Add Item</p>
//               <DividerIcon />
//               <p>Double Enter for Next Option</p>
//               <DividerIcon />
//               <p>Ctrl + Backspace for Remove Item</p>
//             </div>
//           )}
//         </ul>
//       </div>

//       {loading ? (
//         <div
//           style={{ padding: "0", boxShadow: "none" }}
//           className={`${styles.so_footer} ${mode ? styles.so_footer_dark : ""}`}
//         >
//           <Skeleton
//             lines={1}
//             thickness={5}
//             additionalStyles={{
//               marginBottom: "0px",
//               marginTop: "0px",
//               borderRadius: "15px 15px 0 0",
//             }}
//           />
//         </div>
//       ) : (
//         <div
//           className={`${styles.so_footer} ${mode ? styles.so_footer_dark : ""}`}
//         >
//           {(flag === "edit" || flag === "view") && (
//             <div className={styles.so_footer_left}>
//               <div
//                 className={`${styles.so_receipt_data} ${
//                   mode ? styles.so_receipt_data_dark : ""
//                 }`}
//               >
//                 <div
//                   className={`${styles.so_receipt_data_header} ${
//                     mode ? styles.so_receipt_data_header_dark : ""
//                   }`}
//                   style={{ cursor: "auto" }}
//                 >
//                   <div className="col">Receipt ID</div>
//                   <div className="col">Method</div>
//                   <div className="col">Amount</div>
//                   <div className="col">Status</div>
//                 </div>
//                 <div
//                   className={styles.scroll_con}
//                   style={{ display: receipts?.length === 0 && "none" }}
//                 >
//                   {receipts?.length !== 0 &&
//                     receipts?.map((r, index) => (
//                       <div
//                         className={`${styles.so_receipt_data_entry} ${
//                           mode ? styles.so_receipt_data_entry_dark : ""
//                         }`}
//                         key={index}
//                         onClick={() => {
//                           handleOpenModal(
//                             <AddReceiptModal
//                               handleCloseModal={handleCloseModal}
//                               mode={mode}
//                               totalAmount={generalInfo.totalAmount}
//                               accounts={accounts}
//                               receiptData={r}
//                               updateReceiptData={async (updatedData) =>
//                                 updateReceiptData(
//                                   updatedData,
//                                   orderId,
//                                   r.receiptId,
//                                 )
//                               }
//                               type={"create"}
//                               flag={"notupdateamount"}
//                               uniqueWarehouses={uniqueWarehouses}
//                               shippingType={shippingType}
//                               dispatchWarehouse={dispatchWarehouse}
//                               setReceiptData={setReceiptData}
//                               isModalOpen={isModalOpen}
//                               receiptTotalAmount={receiptTotalAmount}
//                               isSelf={isSelf}
//                             />,
//                           );
//                         }}
//                       >
//                         <div className="col" key={index + r.receiptId}>
//                           {r.receiptId}
//                         </div>
//                         <div className="col" key={index + r.paymentMethod}>
//                           {r.paymentMethod}
//                         </div>
//                         <div className="col" key={index + r.paymentAmount}>
//                           {r.paymentAmount}
//                         </div>
//                         <div
//                           className="col"
//                           key={index + r.status}
//                           style={{ color: getStatusColor(r.status) }}
//                         >
//                           {r.status}
//                         </div>
//                       </div>
//                     ))}
//                 </div>
//               </div>

//               {(receiptTotalAmount < generalInfo.totalAmount ||
//                 hasPod ||
//                 !allReceived) && (
//                 <div
//                   className={styles.add_receipt_btn}
//                   onClick={async () => {
//                     await fetchDMs();
//                     orderSuccessKeyPress("addReceipt");
//                   }}
//                 >
//                   <TestTopAddDealerIcon />
//                 </div>
//               )}

//               {allOrdersData?.order?.paymentStatus && (
//                 <div>
//                   <p
//                     style={{
//                       color:
//                         allOrdersData?.order?.paymentStatus === "Received"
//                           ? "#297038"
//                           : "#f11717",
//                     }}
//                   >
//                     {allOrdersData?.order?.paymentStatus}
//                   </p>
//                 </div>
//               )}
//             </div>
//           )}

//           <div className={styles.so_footer_right}>
//             <div className={styles.right_btns}>
//               {(flag === "edit" || flag === "view") && (
//                 <MoreDropdown
//                   mode={mode}
//                   onSummaryClick={handlePrintSummary}
//                   onSlipClick={() => {
//                     show("Coming soon...");
//                   }}
//                 />
//               )}

//               {shouldShowRequestForCancel && (
//                 <Button
//                   buttonIcon={<CancelIcon2 />}
//                   buttonText={"Request for Cancel"}
//                   buttonBgColor={"#000000"}
//                   buttonTextColor={"#ffffff"}
//                   buttonBorder={"none"}
//                   buttonClick={openRequestForCancelModal}
//                 />
//               )}

//               {shouldShowCancelOrder && (
//                 <Button
//                   buttonIcon={<CancelIcon2 />}
//                   buttonText={"Cancel Order"}
//                   buttonBgColor={"#000000"}
//                   buttonTextColor={"#ffffff"}
//                   buttonBorder={"none"}
//                   buttonClick={openCancelOrderModal}
//                 />
//               )}

//               {(flag === "edit" || flag === "view") && (
//                 <Button
//                   buttonIcon={<NewEyeIcon />}
//                   buttonText={"Invoice"}
//                   buttonBgColor={"#000000"}
//                   buttonTextColor={"#ffffff"}
//                   buttonBorder={"none"}
//                   buttonClick={() =>
//                     navigate("/orders/saleinvoice?orderId=" + orderId)
//                   }
//                 />
//               )}

//               {hasDispatchedOrCompleted && (
//                 <Button
//                   buttonIcon={<NewEyeIcon />}
//                   buttonText={"Dispatch Details"}
//                   buttonBgColor={"#000000"}
//                   buttonTextColor={"#ffffff"}
//                   buttonBorder={"none"}
//                   buttonClick={dispatchDetailsClick}
//                 />
//               )}

//               {(flag === "edit" || flag === "view") &&
//                 generalInfo.status !== "Cancelled" &&
//                 generalInfo.reqType !== "Request For Cancel" && (
//                   <Button
//                     buttonIcon={<ShareIcon />}
//                     buttonText={"Share"}
//                     buttonBgColor={"#4164E3"}
//                     buttonTextColor={"#ffffff"}
//                     buttonBorder={"none"}
//                     buttonClick={() => orderSuccessKeyPress("shareLink")}
//                   />
//                 )}
//             </div>

//             <div
//               className={`${styles.so_amount_info} ${
//                 mode ? styles.so_amount_info_dark : ""
//               }`}
//             >
//               <div>
//                 <p>Sub Total:</p>
//                 <p>₹ {generalInfo.subtotal}</p>
//               </div>

//               <div className={styles.so_shipping}>
//                 <p>Shipping Charges:</p>{" "}
//                 <div className={styles.info_btn_con}>
//                   <span
//                     className={styles.info_btn}
//                     onClick={() =>
//                       openShippingChargesInfoModal(
//                         shippingType,
//                         dispatchWarehouse,
//                         shippingInfo,
//                       )
//                     }
//                   >
//                     <InfoRounded color={mode ? "#FFFFFF" : "#1C274C"} />
//                   </span>
//                 </div>
//                 <input
//                   type="number"
//                   value={
//                     (generalInfo.deliveryPartner === "Self"
//                       ? 0
//                       : generalInfo.shippingCharge
//                     )
//                       ?.toString()
//                       .replace(/^0+/, "") || 0
//                   }
//                   onChange={(e) => {
//                     let value = Number(e.target.value);
//                     if (value > 0) {
//                       setGeneralInfo((prevState) => ({
//                         ...prevState,
//                         shippingCharge: value,
//                       }));
//                     } else {
//                       setGeneralInfo((prevState) => ({
//                         ...prevState,
//                         shippingCharge: -1 * value,
//                       }));
//                     }
//                   }}
//                   readOnly={!isNoCase || flag === "view"}
//                   maxLength="10"
//                   onInput={(e) =>
//                     (e.target.value = e.target.value.slice(0, 10))
//                   }
//                   style={mode ? { color: "#fff" } : {}}
//                   ref={shippingRef}
//                   onKeyDown={(e) => {
//                     if (e.key === "Enter") {
//                       checkboxRef.current?.focus();
//                     }
//                   }}
//                 />
//                 <div className={styles.so_check}>
//                   <p>To Pay</p>
//                   <input
//                     type="checkbox"
//                     checked={generalInfo.toPay}
//                     onChange={(e) => {
//                       const isChecked = e.target.checked;

//                       if (
//                         isChecked &&
//                         isNoCase &&
//                         generalInfo.shippingCharge === 0
//                       ) {
//                         e.preventDefault();
//                         show(
//                           "Update shipping charges to check To Pay!",
//                           "warning",
//                         );
//                         return;
//                       }

//                       setGeneralInfo((prevState) => ({
//                         ...prevState,
//                         toPay: isChecked,
//                       }));
//                     }}
//                     ref={checkboxRef}
//                     disabled={
//                       flag === "view" || (flag === "edit" && !isEditMode)
//                     }
//                     onKeyDown={(e) => {
//                       if (e.key === "Enter") {
//                         handleSubmit();
//                       }
//                     }}
//                   />
//                 </div>
//                 <p>
//                   {loadingBtn ? (
//                     <Spinner
//                       borderWidth={"1px"}
//                       height={10}
//                       width={10}
//                       color={mode ? "#000000" : "#4164E3"}
//                     />
//                   ) : (
//                     <>
//                       ₹{" "}
//                       {generalInfo.deliveryPartner === "Self"
//                         ? 0
//                         : generalInfo.shippingCharge}
//                     </>
//                   )}
//                 </p>
//               </div>

//               <div>
//                 <p>
//                   Total Amount(INR):{" "}
//                   {receipts?.length > 0 && (
//                     <span
//                       className={styles.info_btn}
//                       onClick={() => openAdvancePaymentInfoModal(receipts)}
//                     >
//                       <InfoRounded color={mode ? "#FFFFFF" : "#1C274C"} />
//                     </span>
//                   )}
//                 </p>

//                 <p>
//                   {loadingBtn ? (
//                     <Spinner
//                       borderWidth={"1px"}
//                       height={10}
//                       width={10}
//                       color={mode ? "#000000" : "#4164E3"}
//                     />
//                   ) : (
//                     <>₹ {Number(generalInfo.totalAmount) || 0}</>
//                   )}
//                 </p>
//               </div>
//             </div>

//             {flag === "edit" && (
//               <div>
//                 {isEditMode ? (
//                   <>
//                     {showSave ? (
//                       <Button
//                         buttonIcon={<SaveIcon />}
//                         buttonText={"Save"}
//                         buttonBgColor={"#4164E3"}
//                         buttonTextColor={"#FFFFFF"}
//                         buttonBorder={"none"}
//                         buttonClick={() => {
//                           if (verifyEntries()) {
//                             handleSubmit();
//                           }
//                         }}
//                       />
//                     ) : (
//                       <div className={styles.flex}>
//                         <Button
//                           buttonIcon={<CancelIcon2 />}
//                           buttonText={"Cancel"}
//                           buttonBgColor={"#000000"}
//                           buttonTextColor={"#ffffff"}
//                           buttonBorder={"none"}
//                           buttonClick={() => setIsEditMode(false)}
//                           loading={loadingBtn}
//                         />
//                       </div>
//                     )}
//                   </>
//                 ) : (
//                   <>
//                     {generalInfo.orderType !== "online" && (
//                       <Button
//                         buttonIcon={<EditManagerIcon />}
//                         buttonText={"Edit"}
//                         buttonBgColor={"#4164E3"}
//                         buttonTextColor={"#FFFFFF"}
//                         buttonBorder={"none"}
//                         buttonClick={editBtnClick}
//                       />
//                     )}
//                   </>
//                 )}
//               </div>
//             )}

//             {flag === "create" && (
//               <div>
//                 {showSave && (
//                   <Button
//                     buttonIcon={<SaveIcon />}
//                     buttonText={"Save"}
//                     buttonBgColor={"#4164E3"}
//                     buttonTextColor={"#FFFFFF"}
//                     buttonBorder={"none"}
//                     buttonClick={() => {
//                       if (verifyEntries()) {
//                         handleSubmit();
//                       }
//                     }}
//                   />
//                 )}
//               </div>
//             )}
//           </div>
//         </div>
//       )}

//       {/* ------------ Summary Slip ------------------- */}
//       <div style={{ display: "none" }}>
//         <NewSummarySlip
//           ref={summarySlipRef}
//           summarySlipData={itemDetails}
//           generalInfo={allOrdersData?.order}
//         />
//       </div>
//     </>
//   );
// };

// export default ProductionSale;

// ------------------------------------ second Changes  -----------------
// import { useNavigate, useSearchParams } from "react-router-dom";
// import styles from "./ProductionSale.module.css";
// import React, {
//   useCallback,
//   useEffect,
//   useMemo,
//   useRef,
//   useState,
// } from "react";
// import fetchData from "../../APIsControll/apiControll";
// import { useAuth } from "../../components/context/Auth";
// import InputTag from "../../components/updatedComponents/FormComponents/InputTag";
// import Skeleton from "../../components/updatedComponents/Skeleton/Skeleton";
// import SearchDealer from "../../components/updatedComponents/OrderManager/SearchDealer";
// import DealerAddressModal from "../../components/updatedComponents/OrderManager/DealerAddressModal";
// import AdduserModel from "../../components/updatedComponents/models/AdduserModel";
// import ModalWrapper from "../../components/updatedComponents/layoutWrapper/ModalWrapper";
// import {
//   CancelIcon2,
//   DividerIcon,
//   EditManagerIcon,
//   InfoRounded,
//   NewEyeIcon,
//   RemoveIcon,
//   SaveIcon,
//   ShareIcon,
//   TestTopAddDealerIcon,
// } from "../../components/icons/Icon";
// import ManagerModal from "../../components/updatedComponents/Manager/ManagerModal";
// import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
// import OrderSuccessModal from "../../components/updatedComponents/OrderManager/OrderSuccessModal";
// import ShareLinkModal from "../../components/updatedComponents/OrderManager/ShareLinkModal";
// import AddReceiptModal from "../../components/updatedComponents/OrderManager/AddReceiptModal";
// import { handleFileData } from "../../APIsControll/apiControl2";
// import Button from "../../components/updatedComponents/Dealers/Button";
// import RequestForCancelModal from "../../components/updatedComponents/OrderManager/RequestForCancelModal";
// import Spinner from "../../components/updatedComponents/FormComponents/Spinner";
// import ConfirmOrder from "../../components/updatedComponents/OrderManager/ConfirmOrder";
// import Warning from "../../components/updatedComponents/Receipts/Warning";
// // import ShippingTypeModal from "../../components/updatedComponents/OrderManager/ShippingTypeModal";
// import { useDispatch } from "react-redux";
// import { setFilter } from "../../store/slices/order/OrderSlice";
// import { formatDateTime, getStatusColor } from "../../Utils/Utils";
// import SelectWarehouse from "../../components/updatedComponents/OrderManager/SelectWarehouse";
// import MoreDropdown from "../dispatchmanager/MoreDropdown";
// import { useReactToPrint } from "react-to-print";
// import NewSummarySlip from "../dispatchmanager/NewSummarySlip";
// import AdvanceAmountModalInfo from "../../components/updatedComponents/OrderManager/AdvanceAmountModalInfo";
// import ProductionSaleNewItemList from "../../components/updatedComponents/OrderManager/ProductionSaleNewItemList";
// import SlidingFilter from "../../components/updatedComponents/Dealers/SlidingFilter";
// import ProSaleShippingChargesModal from "../../components/updatedComponents/OrderManager/ProSaleShippingChangesModal";
// import DataItemListProAndSale from "../../components/updatedComponents/OrderManager/DataItemListProAndSale";
// import ProSaleShippingChargesInfoModal from "../../components/updatedComponents/OrderManager/ProSaleShippingChargesInfoModal";

// // ─── UID generator (frontend-only, never sent to API) ───────────────────────
// let _uidCounter = 0;
// const genUid = () => `item-${++_uidCounter}-${Date.now()}`;

// // Who/when for a version tab — uses the last change entry in that version
// const getVersionMeta = (versionEntry) => {
//   const last = versionEntry?.items?.[versionEntry.items.length - 1];
//   return {
//     updatedBy: last?.updatedBy || "",
//     updateTime: last?.updateTime || "",
//     action: last?.action || "",
//   };
// };

// // ─── API endpoint used for both fetching AND creating/updating the voucher ──
// const PROD_SALE_VOUCHER_API_1 = "order/prodAndSalesVoucher";
// const PROD_SALE_VOUCHER_API = "order/prodAndSaleVoucher";

// const ProductionSale = ({ onOrderData }) => {
//   const { managerId, mode, designation } = useAuth();

//   const dispatch = useDispatch();

//   const { show } = useToast();
//   const navigate = useNavigate();
//   const [searchParams] = useSearchParams();
//   const orderId = searchParams.get("orderId")
//     ? searchParams.get("orderId")
//     : "";

//   const dealerInpRef = useRef(null);
//   const locationRef = useRef(null);
//   const scroll_wrapper_ref = useRef(null);
//   const itemInpRefs = useRef([]);
//   const qtyInputRefs = useRef([]);
//   const shippingRef = useRef(null);
//   const checkboxRef = useRef(null);
//   const dispatchManagersRef = useRef();
//   const summarySlipRef = useRef(null);

//   const initialItemDetails = useMemo(
//     () => ({
//       _uid: genUid(), // frontend-only, stripped before API calls
//       itemId: "", // "" for a brand new line, real itemId once loaded from server
//       amount: 0,
//       collection_name: "",
//       desc: "",
//       descKey: "",
//       dp: 0,
//       itemNo: "",
//       price: 0,
//       product_name: "",
//       qty: 0,
//       thumbnail: "",
//       totalQty: "",
//       unit: "",
//       vm: 0,
//       warehouse: "",
//       warehouseId: "",
//       weight: 0,
//       batch: "",
//       specific: "Yes",
//     }),
//     [],
//   );

//   const initialReceiptData = useMemo(
//     () => ({
//       paymentMethod: "Cash",
//       transactionScreenshot: "",
//       paymentAmount: "",
//       transactionId: "",
//       accountNumber: "",
//       totalAmount: "",
//       receiptId: "",
//       paymentType: "Cash",
//       warehousename: "",
//       warehouseId: "",
//     }),
//     [],
//   );

//   const [generalInfo, setGeneralInfo] = useState({});
//   const [itemDetails, setItemDetails] = useState([initialItemDetails]);

//   // ── Version History state ─────────────────────────────────────────────

//   const [selectedVersion, setSelectedVersion] = useState(null);
//   const [versionsData, setVersionsData] = useState([]);
//   // ────────────────────────────────────────────────────────────────────────

//   const flag = useMemo(() => {
//     if (!orderId) {
//       return "create";
//     }
//     if (orderId && generalInfo.status === "Payment Pending") {
//       return "edit";
//     }
//     if (orderId && generalInfo.status !== "Payment Pending") {
//       return "view";
//     }
//     return "";
//   }, [orderId, generalInfo.status]);

//   const [loading, setLoading] = useState(false);
//   const [showSave, setShowSave] = useState(false);
//   const [loadingBtn, setLoadingBtn] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);

//   const [receipts, setReceiptsInfo] = useState([]);

//   const [accounts, setAccounts] = useState([]);
//   // const [warehouses, setWarehouses] = useState([]);
//   const [dispatchManagers, setDispatchManagers] = useState([]);
//   // const [methodPartners, setMethodPartners] = useState([]);

//   const [showDealerSearch, setShowDealerSearch] = useState(
//     flag === "create" ? true : false,
//   );
//   const [searchDealer, setSearchDealer] = useState("");
//   const [dealerLoading, setDealerLoading] = useState(false);
//   const [dealerResults, setDealerResults] = useState([]);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [updatedAddress, setUpdatedAddress] = useState(null);
//   const [useFallback, setUseFallback] = useState(true);

//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [modalContent, setModalContent] = useState(null);

//   const [focusedItemIndex, setFocusedItemIndex] = useState(0);
//   const [showItemSearch, setShowItemSearch] = useState(false);

//   const [receiptData, setReceiptData] = useState(initialReceiptData);
//   const [paymentLink, setPaymentLink] = useState("");

//   const [skipped, setSkipped] = useState(false);
//   const [isNoCase, setIsNoCase] = useState(false);

//   const [shouldFocus, setShouldFocus] = useState(true);
//   const [showDescriptionInput, setShowDescriptionInput] = useState(false);

//   const [isManagerAssigned, setIsManagerAssigned] = useState(true);
//   const [isShippingBlocked, setIsShippingBlocked] = useState(false);
//   const [isPodBlocked, setIsPodBlocked] = useState(false);
//   const [orderManagers, setOrderManagers] = useState([]);
//   // const [shippingType, setShippingType] = useState("Combined");
//   const [dispatchWarehouse, setDispatchWarehouse] = useState();

//   const [shippingAddress, setShippingAddress] = useState({});
//   const [allOrdersData, setAllOrdersData] = useState([{}]);

//   const initialShippingDetails = {
//     methodId: "",
//     shippingCharge: 0,
//     courierName: "Pick Up",
//     methodName: "Self",
//     partnerName: "Self",
//     warehousename: "",
//     warehouseId: "",
//     isDispatchWarehouse: false,
//     delInstruction: "",
//   };

//   const [shippingInfo, setShippingInfo] = useState([initialShippingDetails]);
//   const [instructions, setInstructions] = useState({});
//   const [uniqueWarehouses, setUniqueWarehouses] = useState([]);
//   const [receiptTotalAmount, setReceiptTotalAmount] = useState();

//   const shippingInfoRef = useRef(shippingInfo);

//   useEffect(() => {
//     shippingInfoRef.current = shippingInfo;
//   }, [shippingInfo]);

//   useEffect(() => {
//     dispatchManagersRef.current = dispatchManagers;
//   }, [dispatchManagers]);

//   useEffect(() => {
//     if (shouldFocus) {
//       dealerInpRef.current?.focus();
//     } else {
//       dealerInpRef.current?.blur();
//     }
//   }, [shouldFocus]);

//   useEffect(() => {
//     if (flag === "create") {
//       setGeneralInfo((prevState) =>
//         Object.keys(prevState).reduce((acc, key) => {
//           acc[key] = 0;
//           return acc;
//         }, {}),
//       );
//       setReceiptData(initialReceiptData);
//       setItemDetails([{ ...initialItemDetails, _uid: genUid() }]);
//       setDispatchManagers([]);
//       setShowDescriptionInput(false);
//       itemInpRefs.current = [];
//       qtyInputRefs.current = [];
//       setFocusedItemIndex(null);
//       setDealerResults([]);
//       // setMethodPartners([]);
//       setIsNoCase(false);
//       setShouldFocus(true);
//       setSearchDealer("");
//       setShowItemSearch(false);
//       setIsEditMode(false);
//       setReceiptsInfo([]);
//       setAccounts([]);
//       // setWarehouses([]);
//       setPaymentLink("");
//       setIsModalOpen(false);
//       setModalContent(null);
//       setSkipped(false);
//       setShowSave(false);
//       setLoading(false);
//       setLoadingBtn(false);
//       setIsManagerAssigned(true);
//       setIsShippingBlocked(false);
//       setIsPodBlocked(false);
//       setOrderManagers([]);
//       dispatch(setFilter({ selectedOption: "" }));
//       setShippingAddress({});
//       setShippingInfo([]);
//       setReceiptTotalAmount();
//       // ── reset version history state for a fresh "create" form ──────────
//       setVersionsData([]);
//       setSelectedVersion(null);
//       // ─────────────────────────────────────────────────────────────────
//     }
//   }, [dispatch, flag, initialItemDetails, initialReceiptData]);

//   const fetchOrder = useCallback(async () => {
//     setLoading(true);
//     try {
//       const apiData = {
//         managerId: managerId,
//         voucherId: orderId,
//       };
//       const result = await fetchData(PROD_SALE_VOUCHER_API_1, apiData);

//       if (result.status === "success") {
//         setLoading(false);
//         setAllOrdersData(result?.data);
//         if (result?.data?.voucher) {
//           setGeneralInfo((prevState) => ({
//             ...prevState,
//             dealerId: result?.data?.voucher?.dealerId,
//             storeName: result?.data?.voucher?.storeName,
//             dealerName: result?.data?.voucher?.name,
//             createdBy: result?.data?.voucher?.createdBy,
//             billingAddress: result?.data?.voucher?.billingAddress,
//             shippingCharge: result?.data?.voucher?.totalShippingCharge,
//             totalAmount: result?.data?.voucher?.totalAmount,
//             subtotal: result?.data?.voucher?.subtotal,
//             courierName: result?.data?.voucher?.courierName,
//             mobile: result?.data?.voucher?.shippingAddress?.mobile
//               ? result?.data?.voucher?.shippingAddress?.mobile
//               : result?.data?.voucher?.DealerInfo?.whatsapp,
//             whatsapp: result?.data?.voucher?.DealerInfo?.whatsapp
//               ? result?.data?.voucher?.DealerInfo?.whatsapp
//               : result?.data?.voucher?.shippingAddress?.mobile,
//             email: result?.data?.voucher?.DealerInfo?.email
//               ? result?.data?.voucher?.DealerInfo?.email
//               : "",
//             orderManagerName: result?.data?.voucher?.orderManagerName,
//             dmId: result?.data?.voucher?.dmId,
//             dmName: result?.data?.voucher?.dmName,
//             orderDate: result?.data?.voucher?.voucherDate,
//             orderId: result?.data?.voucher?.voucherId,
//             status: result?.data?.voucher?.status,
//             orderType: result?.data?.voucher?.voucherType,
//             warehousename: result?.data?.voucher?.warehousename,
//             warehouseId: result?.data?.voucher?.warehouseId,

//             toPay: result?.data?.voucher?.toPay,
//             dispatchStatus: result?.data?.voucher?.dispatchStatus,
//             reqType: result?.data?.voucher?.reqType,
//             deliveryPartners: {
//               label: result?.data?.voucher?.shippingInfo?.methodName,
//               value: result?.data?.voucher?.shippingInfo?.methodName,
//             },
//           }));

//           setShippingInfo(result.data.voucher.shippingInfo);
//           setShippingAddress(result?.data?.voucher?.shippingAddress);

//           // ── Stamp each item with a frontend-only _uid, keep server itemId ──
//           const stampedItems = result?.data?.voucher?.items.map((item) => ({
//             ...item,
//             _uid: genUid(),
//           }));
//           setItemDetails(stampedItems);
//           // ───────────────────────────────────────────────────────────────

//           // ── Version History ────────────────────────────────────────────
//           if (result?.data?.voucher?.itemsHistory) {
//             setVersionsData(result.data.voucher.itemsHistory);
//           } else {
//             setVersionsData([]);
//           }
//           setSelectedVersion(null);
//           // ────────────────────────────────────────────────────────────────

//           setReceiptsInfo(result?.data?.receipts);
//           setIsPodBlocked(
//             result?.data?.voucher?.DealerInfo?.podBlock ? true : false,
//           );
//           setIsShippingBlocked(
//             result?.data?.voucher?.DealerInfo?.shippingBlock ? true : false,
//           );
//           // setShippingType(result.data.voucher.shippingType);
//         }
//         if (result.data.accounts) {
//           setAccounts(result.data.accounts);
//         }
//       }
//     } catch {
//     } finally {
//       setLoading(false);
//     }
//   }, [managerId, orderId]);

//   const fetchOrderRef = useRef(fetchOrder);
//   fetchOrderRef.current = fetchOrder;

//   useEffect(() => {
//     if (managerId && (flag === "edit" || flag === "view")) {
//       fetchOrder();
//     }
//   }, [fetchOrder, flag, managerId, orderId]);

//   const fetchDealer = useCallback(async () => {
//     try {
//       setDealerLoading(true);
//       const apiData = {
//         managerId: managerId,
//         keyword: searchDealer,
//       };

//       const result = await fetchData("order/finddealer", apiData);

//       if (result.status === "success") {
//         setDealerResults(result.data);
//       }
//       setDealerLoading(false);
//     } catch (error) {
//       setDealerLoading(false);
//     }
//   }, [managerId, searchDealer]);

//   useEffect(() => {
//     if (searchDealer) {
//       const delayDebounceFn = setTimeout(() => {
//         fetchDealer();
//       }, 700);

//       return () => clearTimeout(delayDebounceFn);
//     }
//   }, [searchDealer, fetchDealer]);

//   const handleDealerKeyDown = (e) => {
//     if (showDealerSearch) {
//       if (e.key === "ArrowDown") {
//         setCurrentIndex((prevIndex) =>
//           prevIndex < dealerResults?.length - 1 ? prevIndex + 1 : prevIndex,
//         );
//         e.preventDefault();
//       }

//       if (e.key === "ArrowUp") {
//         setCurrentIndex((prevIndex) =>
//           prevIndex > 0 ? prevIndex - 1 : prevIndex,
//         );
//         e.preventDefault();
//       }

//       if ((e.altKey || e.metaKey) && e.key.toLowerCase() === "c") {
//         setSearchDealer("");
//         setTimeout(() => {
//           openAddDealerModal();
//         }, 100);
//       }

//       if (!dealerLoading) {
//         if (e.key === "Enter") {
//           e.preventDefault();
//           handleSelectDealer(dealerResults && dealerResults[currentIndex]);
//         }
//       }
//     }
//   };

//   const openAddDealerModal = () => {
//     handleOpenModal(
//       <AdduserModel
//         focus={true}
//         close={() => handleCloseModal()}
//         onDealerAdd={(newDealer) => handleSelectDealer(newDealer)}
//       />,
//     );
//   };

//   const editBtnClick = useCallback(
//     (d) => {
//       setIsEditMode(true);
//       handleOpenModal(
//         <DealerAddressModal
//           name={"dealer_address_modal"}
//           shippingAddress={
//             shippingAddress.street ||
//             shippingAddress.city ||
//             shippingAddress.district ||
//             shippingAddress.state ||
//             shippingAddress.pincode
//               ? [
//                   shippingAddress.street,
//                   shippingAddress.city,
//                   shippingAddress.district,
//                   shippingAddress.state,
//                   shippingAddress.pincode,
//                 ]
//                   .filter(Boolean)
//                   .join(" ")
//               : undefined
//           }
//           ref={locationRef}
//           handleCloseModal={() => handleCloseModal()}
//           onAddressUpdate={(data) => {
//             if (!isModalOpen) {
//               setTimeout(() => {
//                 updateShippingAddress(d, data);
//                 itemInpRefs?.current[0]?.focus();
//               }, 0);
//             }
//           }}
//           mode={mode}
//           onKeyPress={() => {
//             if (!isModalOpen) {
//               setTimeout(() => {
//                 itemInpRefs?.current[0]?.focus();
//               }, 0);
//             }
//           }}
//         />,
//       );
//     },
//     [
//       isModalOpen,
//       mode,
//       shippingAddress.city,
//       shippingAddress.district,
//       shippingAddress.pincode,
//       shippingAddress.state,
//       shippingAddress.street,
//     ],
//   );

//   const handleSelectDealer = (d) => {
//     let doesHaveAddress = false;

//     if (!d) {
//       console.error("Dealer data is undefined!");
//       return;
//     }

//     if (
//       d.street === "" ||
//       d.city === "" ||
//       d.district === "" ||
//       d.state === "" ||
//       d.pincode === ""
//     ) {
//       doesHaveAddress = true;
//     }

//     if (d.assignedManagerId === "") {
//       setIsManagerAssigned(false);
//     }

//     if (d.shippingBlock === true) {
//       setIsShippingBlocked(true);
//     }

//     if (d.podBlock === true) {
//       setIsPodBlocked(true);
//     }

//     setSearchDealer(
//       d.name && d.storeName
//         ? `${d.storeName} / ${d.name}`
//         : d.name || d.storeName || "",
//     );

//     if ("refcode" in d) {
//       updateGeneralInfo(d);
//       updateShippingAddress(d);
//     } else {
//       handleOpenModal(
//         <DealerAddressModal
//           name={"dealer_address_modal"}
//           shippingAddress={
//             d.street || d.city || d.district || d.state || d.pincode
//               ? [d.street, d.city, d.district, d.state, d.pincode]
//                   .filter(Boolean)
//                   .join(" ")
//               : undefined
//           }
//           form={doesHaveAddress}
//           ref={locationRef}
//           handleCloseModal={() => handleCloseModal()}
//           onAddressUpdate={(data) => {
//             setUpdatedAddress(data);
//             updateGeneralInfo(d);
//             updateShippingAddress(d, data);
//           }}
//           mode={mode}
//           onKeyPress={(e) => {
//             e.preventDefault();
//             e.stopPropagation();
//             updateGeneralInfo(d);
//             updateShippingAddress(d, updatedAddress);
//           }}
//           focus={true}
//         />,
//       );
//     }
//   };

//   const updateGeneralInfo = (d) => {
//     if (d?.name === "Cash") {
//       setGeneralInfo((prevState) => ({
//         ...prevState,
//         dealerId: d?.dealerId,
//         dealerName: d?.name,
//         storeName: d?.storeName,
//         mobile: d?.mobile,
//         whatsapp: d?.whatsapp,
//         email: d?.email,
//         gstuin: d?.gstuin ? d?.gstuin : "",
//         assignedManagerId: d?.assignedManagerId || d?.refcode,
//         shippingType: "Standard",
//         courierName: "Pick Up",
//         partnerName: "Self",
//       }));
//     } else {
//       setGeneralInfo((prevState) => ({
//         ...prevState,
//         dealerId: d?.dealerId,
//         dealerName: d?.name,
//         storeName: d?.storeName,
//         mobile: d?.mobile,
//         whatsapp: d?.whatsapp,
//         email: d?.email,
//         gstuin: d?.gstuin,
//         assignedManagerId: d?.assignedManagerId || d?.refcode,
//         billingAddress:
//           (d?.street || d?.city || d?.district || d?.state || d?.pincode) &&
//           [d?.street, d?.city, d?.district, d?.state, d?.pincode]
//             .filter(Boolean)
//             .join(" "),
//       }));
//     }
//     itemInpRefs.current[0]?.focus();
//   };

//   const updateShippingAddress = (dealer, address) => {
//     setShippingAddress((prevState) => ({
//       ...prevState,
//       mobile: dealer?.mobile,
//       name: dealer?.name,
//       storeName: dealer?.storeName,
//       pincode: address?.pinCode || dealer?.pincode,
//       street: address?.streetAddress || dealer?.street,
//       city: address?.city || dealer?.city,
//       district: address?.district || dealer?.district,
//       state: address?.state || dealer?.state,
//       country: dealer?.country || "India",
//     }));
//   };

//   const handleFocusNextItem = () => {
//     setShouldFocus(false);
//     setShowDescriptionInput(false);
//     setTimeout(() => {
//       const lastItemIndex = itemDetails?.length - 1;

//       if (itemInpRefs?.current?.length) {
//         const nextItemIndex = lastItemIndex + 1;

//         if (nextItemIndex < itemInpRefs?.current?.length) {
//           const nextItemRef = itemInpRefs?.current[nextItemIndex];
//           nextItemRef?.focus();
//           setFocusedItemIndex(nextItemIndex);
//         }
//       }
//     }, 0);
//     if (flag === "create") {
//       setShowItemSearch(true);
//     }
//   };

//   const handleItemInputFocus = (index) => {
//     setFocusedItemIndex(index);
//   };

//   const handleItemInputBlur = () => {
//     setTimeout(() => {
//       setShowItemSearch(false);
//       setFocusedItemIndex(null);
//     }, 200);
//   };

//   // const handleItemChange = async (index, field, value) => {
//   //   setItemDetails((prevItems) => {
//   //     const updatedItems = [...prevItems];
//   //     const previousItem = { ...updatedItems[index] };

//   //     updatedItems[index] = { ...updatedItems[index], [field]: value };

//   //     if (field === "warehouseId") {
//   //       const oldWarehouseId = previousItem.warehouseId;
//   //       const newWarehouseId = value;
//   //       const newWarehouseName = updatedItems[index].warehouse;

//   //       setGeneralInfo((prevState) => {
//   //         const currentList = prevState.warehouses || [];

//   //         const isOldWarehouseStillUsed = updatedItems.some(
//   //           (item, i) => i !== index && item.warehouseId === oldWarehouseId,
//   //         );

//   //         let updatedList = [...currentList];

//   //         if (newWarehouseId && !updatedList.includes(newWarehouseId)) {
//   //           updatedList.push(newWarehouseId);
//   //         }

//   //         if (oldWarehouseId && !isOldWarehouseStillUsed) {
//   //           updatedList = updatedList.filter((wh) => wh !== oldWarehouseId);
//   //         }

//   //         return {
//   //           ...prevState,
//   //           warehouses: updatedList,
//   //         };
//   //       });

//   //       setShippingInfo((prevShipping) => {
//   //         let updatedShipping = [...prevShipping];

//   //         const isOldWarehouseStillUsed = updatedItems.some(
//   //           (item, i) => i !== index && item.warehouseId === oldWarehouseId,
//   //         );

//   //         if (oldWarehouseId && !isOldWarehouseStillUsed) {
//   //           updatedShipping = updatedShipping.filter(
//   //             (item) => item.warehouseId !== oldWarehouseId,
//   //           );
//   //         }

//   //         const newWarehouseExists = updatedShipping.some(
//   //           (item) => item.warehouseId === newWarehouseId,
//   //         );

//   //         if (!newWarehouseExists && newWarehouseId && newWarehouseName) {
//   //           updatedShipping.push({
//   //             ...initialShippingDetails,
//   //             warehouseId: newWarehouseId,
//   //             warehousename: newWarehouseName,
//   //           });
//   //         }

//   //         return updatedShipping;
//   //       });
//   //     }

//   //     return updatedItems;
//   //   });
//   // };

//   // const removeItem = (index) => {
//   //   setItemDetails((prevItems) => {
//   //     const itemToRemove = prevItems[index];
//   //     const updatedItems = prevItems.filter((_, i) => i !== index);

//   //     if (itemToRemove?.warehouseId) {
//   //       const isWarehouseStillUsed = updatedItems.some(
//   //         (item) => item.warehouseId === itemToRemove.warehouseId,
//   //       );

//   //       if (!isWarehouseStillUsed) {
//   //         setShippingInfo((prevShipping) =>
//   //           prevShipping.filter(
//   //             (item) => item.warehouseId !== itemToRemove.warehouseId,
//   //           ),
//   //         );
//   //       }
//   //     }

//   //     return updatedItems;
//   //   });
//   // };

//   // const handleAddNewItem = () => {
//   //   const errors = [];

//   //   if (!itemDetails || itemDetails.length === 0) {
//   //     errors.push("No items to validate");
//   //   } else {
//   //     itemDetails.forEach((item, index) => {
//   //       if (item.outsourcedItem === "Disable") {
//   //         if (!item.itemNo)
//   //           errors.push(`Item ${index + 1}: Item Number cannot be empty`);
//   //         if (!item.qty)
//   //           errors.push(`Item ${index + 1}: Quantity cannot be empty`);
//   //         if (item.qty > item.totalQty) {
//   //           errors.push(
//   //             `Item ${index + 1}: Quantity exceeds available stock (${
//   //               item.totalQty
//   //             })`,
//   //           );
//   //         }
//   //       } else if (item.outsourcedItem === "Active") {
//   //         if (!item.itemNo)
//   //           errors.push(`Item ${index + 1}: Item Number cannot be empty`);
//   //         if (!item.qty)
//   //           errors.push(`Item ${index + 1}: Quantity cannot be empty`);
//   //         if (item.qty > item.outSourceItemlimit) {
//   //           errors.push(
//   //             `Item ${index + 1}: Quantity exceeds limit (${
//   //               item.outSourceItemlimit
//   //             })`,
//   //           );
//   //         }
//   //       }
//   //     });
//   //   }

//   //   if (errors.length > 0) {
//   //     show(errors.join("\n"), "warning");
//   //   } else {
//   //     // ── New item gets a fresh UID, empty itemId (create-only line) ──────
//   //     setItemDetails((prev) => [
//   //       ...prev,
//   //       { ...initialItemDetails, _uid: genUid() },
//   //     ]);
//   //     // ──────────────────────────────────────────────────────────────────
//   //     handleFocusNextItem();

//   //     setTimeout(() => {
//   //       scroll_wrapper_ref.current?.scrollBy({
//   //         top: 100,
//   //         behavior: "smooth",
//   //       });
//   //     }, 100);
//   //   }
//   // };

//   const handleItemChange = (index, field, value) => {
//     setItemDetails((prevItems) => {
//       const updatedItems = [...prevItems];

//       updatedItems[index] = {
//         ...updatedItems[index],
//         [field]: value,
//       };

//       return updatedItems;
//     });
//   };

//   const removeItem = (index) => {
//     setItemDetails((prevItems) => prevItems.filter((_, i) => i !== index));
//   };

//   const handleAddNewItem = () => {
//     const errors = [];

//     if (!itemDetails || itemDetails.length === 0) {
//       errors.push("No items to validate");
//     } else {
//       itemDetails.forEach((item, index) => {
//         if (item.outsourcedItem === "Disable") {
//           if (!item.itemNo)
//             errors.push(`Item ${index + 1}: Item Number cannot be empty`);

//           if (!item.qty)
//             errors.push(`Item ${index + 1}: Quantity cannot be empty`);

//           if (item.qty > item.totalQty) {
//             errors.push(
//               `Item ${index + 1}: Quantity exceeds available stock (${item.totalQty})`,
//             );
//           }
//         } else if (item.outsourcedItem === "Active") {
//           if (!item.itemNo)
//             errors.push(`Item ${index + 1}: Item Number cannot be empty`);

//           if (!item.qty)
//             errors.push(`Item ${index + 1}: Quantity cannot be empty`);

//           if (item.qty > item.outSourceItemlimit) {
//             errors.push(
//               `Item ${index + 1}: Quantity exceeds limit (${item.outSourceItemlimit})`,
//             );
//           }
//         }
//       });
//     }

//     if (errors.length > 0) {
//       show(errors.join("\n"), "warning");
//       return;
//     }

//     setItemDetails((prev) => [
//       ...prev,
//       {
//         ...initialItemDetails,
//         _uid: genUid(),
//       },
//     ]);

//     handleFocusNextItem();

//     setTimeout(() => {
//       scroll_wrapper_ref.current?.scrollBy({
//         top: 100,
//         behavior: "smooth",
//       });
//     }, 100);
//   };

//   const handleOpenModal = (content) => {
//     setShouldFocus(false);
//     setIsModalOpen(true);
//     setModalContent(content);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setModalContent(null);
//   };

//   const handleAddReceipt = useCallback(
//     async (updatedData, newOrderId, receiptId) => {
//       const formData = new FormData();
//       formData.append(
//         "transactionScreenshot",
//         updatedData.transactionScreenshot
//           ? updatedData.transactionScreenshot
//           : "",
//       );
//       formData.append(
//         "paymentMethod",
//         updatedData.paymentMethod ? updatedData.paymentMethod : "",
//       );
//       formData.append(
//         "paymentType",
//         updatedData.paymentType ? updatedData.paymentType : "",
//       );
//       formData.append(
//         "paymentAmount",
//         updatedData.paymentAmount
//           ? parseFloat(updatedData.paymentAmount).toFixed(2)
//           : "",
//       );
//       formData.append(
//         "transactionId",
//         updatedData.transactionId ? updatedData.transactionId : "",
//       );
//       formData.append(
//         "accountNumber",
//         updatedData.accountNumber ? updatedData.accountNumber : "",
//       );
//       formData.append(
//         "warehousename",
//         updatedData.warehousename ? updatedData.warehousename : "",
//       );
//       formData.append(
//         "totalAmount",
//         generalInfo.totalAmount ? generalInfo.totalAmount.toFixed(2) : "",
//       );

//       const orderIdentifier = newOrderId || orderId;

//       try {
//         const result = await handleFileData(
//           `receipt/offlinePay/${managerId}/${orderIdentifier}?receiptId=${
//             receiptId && receiptId
//           }`,
//           formData,
//         );
//         if (result.status === "success") {
//           show(result.msg, "success");
//           handleCloseModal();
//           setTimeout(async () => {
//             await fetchOrderRef.current();
//           }, 0);
//         }
//         if (result.status === "warning") {
//           setModalContent(
//             <Warning
//               message={result?.msg}
//               items={result?.items}
//               orderdItems={result?.orderdItems}
//               mode={mode}
//               handleCloseModal={handleCloseModal}
//             />,
//           );
//         }
//         if (result.status === "warn") {
//           show(result.msg, "error");
//         }
//         if (result.status === "failed") {
//           show(result.msg, "error");
//         }
//       } catch (error) {}
//     },
//     [generalInfo.totalAmount, managerId, mode, orderId, show],
//   );

//   const updateReceiptData = useCallback(
//     (updatedData, newOrderId, receiptId) => {
//       setReceiptData(updatedData);
//       setTimeout(async () => {
//         handleAddReceipt(updatedData, newOrderId, receiptId);
//       }, 0);
//     },
//     [handleAddReceipt],
//   );

//   const isSelf = shippingInfo?.methodName === "Self";

//   const orderSuccessKeyPress = useCallback(
//     (action, link, oID, acc) => {
//       const whatsappNo = generalInfo?.whatsapp || "Not Provided";
//       const mobileNo = generalInfo?.mobile || "Not Provided";
//       const email = generalInfo?.email || "Not Provided";
//       const generatedLink = link || paymentLink || "No Link Available";
//       const newOrderId = orderId || oID || "No Order Id Available";
//       const accounts2 = acc || accounts;

//       if (action === "shareLink") {
//         setTimeout(() => {
//           handleOpenModal(
//             <ShareLinkModal
//               mode={mode}
//               managerId={managerId}
//               handleCloseModal={handleCloseModal}
//               generatedLink={generatedLink}
//               whatsappNo={whatsappNo}
//               mobileNo={mobileNo}
//               email={email}
//               isModalOpen={true}
//             />,
//           );
//         }, 0);
//       } else if (action === "addReceipt") {
//         setTimeout(() => {
//           handleOpenModal(
//             <AddReceiptModal
//               handleCloseModal={handleCloseModal}
//               mode={mode}
//               totalAmount={generalInfo.totalAmount}
//               accounts={accounts2}
//               receiptData={receiptData && receiptData}
//               updateReceiptData={async (updatedData) =>
//                 updateReceiptData(updatedData, newOrderId)
//               }
//               type={"create"}
//               isPodBlocked={isPodBlocked}
//               uniqueWarehouses={uniqueWarehouses}
//               // shippingType={shippingType}
//               dispatchWarehouse={dispatchWarehouse}
//               setReceiptData={setReceiptData}
//               isModalOpen={isModalOpen}
//               receiptTotalAmount={receiptTotalAmount}
//               isSelf={isSelf}
//             />,
//           );
//         }, 0);
//       }
//     },
//     [
//       generalInfo?.whatsapp,
//       generalInfo?.mobile,
//       generalInfo?.email,
//       generalInfo.totalAmount,
//       paymentLink,
//       orderId,
//       accounts,
//       mode,
//       managerId,
//       receiptData,
//       isPodBlocked,
//       uniqueWarehouses,
//       // shippingType,
//       dispatchWarehouse,
//       isModalOpen,
//       receiptTotalAmount,
//       isSelf,
//       updateReceiptData,
//     ],
//   );

//   // const generatePaymentLink = useCallback(
//   //   async (oId) => {
//   //     setPaymentLink("");
//   //     const currentOrderId = oId || orderId;
//   //     if (!currentOrderId) {
//   //       return;
//   //     }
//   //     try {
//   //       const apiData = { orderId: currentOrderId };
//   //       const result = await fetchData("receipt/generatePaymentLink", apiData);
//   //       if (result.status === "success" && result.shortUrl) {
//   //         const link = `${result.shortUrl}`;
//   //         setPaymentLink(link);
//   //         return link;
//   //       } else {
//   //       }
//   //     } catch (error) {}
//   //   },
//   //   [orderId],
//   // );

//   // ── Strip _uid before sending to API ──────────────────────────────────────
//   const getValidSaleItems = (items) => {
//     return items
//       ?.filter((item) =>
//         Object.values(item).some(
//           (value) => value !== "" && value !== null && value !== undefined,
//         ),
//       )
//       .map(({ _uid, ...rest }) => rest); // _uid never reaches the API
//   };
//   // ──────────────────────────────────────────────────────────────────────────

//   // ── Build the `productionItem[]` payload expected by order/prodAndSaleVoucher ──
//   // itemId is "" for a freshly added line (create), and the real server itemId
//   // when the line came from an already-loaded voucher (edit).
//   const buildProductionSaleItems = useCallback(() => {
//     return getValidSaleItems(itemDetails).map((item, index) => ({
//       itemId: item.itemId || "",
//       itemNo: item.itemNo,
//       itemQueue: String(index + 1),
//       warehouseId: item.warehouseId || "",
//       qty: String(item.qty ?? ""),
//       price: String(item.price ?? ""),
//       specific: item.specific || "Yes",
//       unit: item.unit || "",
//       batch: item.batch || "",
//       desc: item.desc || "",
//     }));
//   }, [itemDetails]);
//   // ──────────────────────────────────────────────────────────────────────────

//   // ── Create / update the Production & Sale voucher ─────────────────────────
//   const handleSaleOrder = useCallback(
//     async (status, id, s) => {
//       if (
//         generalInfo.partnerName === "" &&
//         generalInfo.methodName === "" &&
//         generalInfo.courierName === ""
//       ) {
//         show("Delivery details are required!", "error");
//         return;
//       }

//       const assignedManagerId = isManagerAssigned
//         ? generalInfo.assignedManagerId
//         : id;

//       const shipping = s || shippingInfoRef.current || {};
//       const shippingObj = Array.isArray(shipping) ? shipping[0] : shipping;

//       try {
//         setLoadingBtn(true);
//         setShowSave(false);

//         const shippingCharge =
//           generalInfo.deliveryPartner === "Self"
//             ? 0
//             : generalInfo.shippingCharge;

//         const apiData = {
//           managerId: managerId,
//           warehouseId: dispatchWarehouse?.value || "",
//           assignedManagerId: assignedManagerId || "",
//           voucherId: orderId || "", // "" on create, orderId on edit
//           dealerId: generalInfo.dealerId,
//           name: shippingAddress.name,
//           mobile: shippingAddress.mobile,
//           pincode: shippingAddress.pincode,
//           street: shippingAddress.street,
//           city: shippingAddress.city,
//           district: shippingAddress.district,
//           state: shippingAddress.state,
//           country: shippingAddress.country || "India",
//           shippingCharge: String(shippingCharge || 0),
//           toPay: generalInfo.toPay || false,
//           courierName: shippingObj?.courierName || "",
//           methodName: shippingObj?.methodName || "",
//           partnerName: shippingObj?.partnerName || "",
//           delInstruction: shippingObj?.delInstruction || "",
//           priority: "",
//           productionItem: buildProductionSaleItems(),
//           role: designation,
//           status: status,
//         };

//         const result = await fetchData(PROD_SALE_VOUCHER_API, apiData);

//         if (result.status === "success") {
//           setLoadingBtn(false);

//           if (status === "success") {
//             if (!orderId) {
//               navigate(
//                 `/orders/order/productionAndSale?orderId=${
//                   result.data.voucherId || result.data.orderId
//                 }`,
//               );
//             }
//             setShowSave(false);
//             setIsEditMode(false);
//             dispatch(setFilter({ selectedOption: "" }));
//             setShowItemSearch(false);

//             const oID = result.data.voucherId || result.data.orderId;

//             setTimeout(async () => {
//               // const link = await generatePaymentLink(oID);
//               // const acc = await fetchDMs("", oID);
//               setTimeout(() => {
//                 handleOpenModal(
//                   <OrderSuccessModal
//                     mode={mode}
//                     handleCloseModal={handleCloseModal}
//                     orderSuccessKeyPress={(action) =>
//                       // orderSuccessKeyPress(action, link, oID, acc)
//                       orderSuccessKeyPress(action, oID)
//                     }
//                   />,
//                 );
//               }, 100);
//             }, 100);
//           } else if (status === "draft") {
//             navigate("/orders");
//           }
//         } else if (result.status === "assignManager") {
//           setLoadingBtn(false);
//           dispatch(setFilter({ selectedOption: "" }));
//           setOrderManagers(result.orderManagers);
//         } else {
//           show(result.msg, "warning");
//           setLoadingBtn(false);
//         }
//       } catch (error) {
//         setLoadingBtn(false);
//       }
//     },
//     [
//       generalInfo.partnerName,
//       generalInfo.methodName,
//       generalInfo.courierName,
//       generalInfo.assignedManagerId,
//       generalInfo.deliveryPartner,
//       generalInfo.shippingCharge,
//       generalInfo.dealerId,
//       generalInfo.toPay,
//       isManagerAssigned,
//       show,
//       managerId,
//       orderId,
//       dispatchWarehouse,
//       shippingAddress,
//       buildProductionSaleItems,
//       designation,
//       dispatch,
//       navigate,
//       // generatePaymentLink,
//       // fetchDMs,
//       mode,
//       orderSuccessKeyPress,
//     ],
//   );
//   // ──────────────────────────────────────────────────────────────────────────

//   const handleInstructionChange = useCallback((warehouseId, instruction) => {
//     setShippingInfo((prev) => {
//       const updated = prev.map((s) =>
//         s.warehouseId === warehouseId
//           ? { ...s, delInstruction: instruction }
//           : s,
//       );
//       return updated;
//     });
//   }, []);

//   const handleSubmit = useCallback(() => {
//     handleOpenModal(
//       <ConfirmOrder
//         heading={"Confirm Order"}
//         centerHeading={"Are you sure want to place this Order?"}
//         targetWord={"order"}
//         handleCloseModal={() => handleCloseModal()}
//         handleSubmit={async (status, id) => {
//           await handleSaleOrder(status, id, shippingInfoRef.current);
//         }}
//         isManagerAssigned={isManagerAssigned}
//         orderManagers={orderManagers}
//         handleOpenModal={handleOpenModal}
//         // shippingType={shippingType}
//         itemDetails={itemDetails}
//         setShippingInfo={setShippingInfo}
//         handleInstructionChange={handleInstructionChange}
//         instructions={instructions}
//         setInstructions={setInstructions}
//       />,
//     );
//   }, [
//     handleInstructionChange,
//     handleSaleOrder,
//     instructions,
//     isManagerAssigned,
//     itemDetails,
//     orderManagers,
//     // shippingType,
//   ]);

//   // const handleSkipShippingCharges = useCallback(
//   //   (dw) => {
//   //     if (shippingType === "Combined") {
//   //       setShippingInfo((prev) =>
//   //         prev.map((item) => ({
//   //           ...item,
//   //           isDispatchWarehouse: item.warehouseId === dw.value,
//   //         })),
//   //       );
//   //     } else {
//   //       setShippingInfo((prev) =>
//   //         prev.map((item) => ({
//   //           ...item,
//   //           isDispatchWarehouse: true,
//   //         })),
//   //       );
//   //     }
//   //     setGeneralInfo((prevState) => ({
//   //       ...prevState,
//   //       courierName: "Pick Up",
//   //       toPay: false,
//   //       deliveryPartners: prevState.deliveryPartners
//   //         ? [...prevState.deliveryPartners, { label: "Self", value: "Self" }]
//   //         : [{ label: "Self", value: "Self" }],
//   //     }));
//   //     setSkipped(true);
//   //   },
//   //   [shippingType],
//   // );

//   if (skipped) {
//     setTimeout(() => {
//       handleSubmit();
//     }, 700);
//     setSkipped(false);
//   }

//   const openShippingChargesInfoModal = useCallback(
//     (s, dw, tempShippingInfo, uw) => {
//       setUniqueWarehouses(uw);
//       handleOpenModal(
//         <ProSaleShippingChargesInfoModal
//           mode={mode}
//           handleCloseModal={handleCloseModal}
//           shippingType={s}
//           itemDetails={itemDetails}
//           shippingInfo={tempShippingInfo}
//           setShippingInfo={setShippingInfo}
//           dw={dw}
//           ref={checkboxRef}
//         />,
//       );
//     },
//     [itemDetails, mode],
//   );

//   // const selectDispatchWarehouse = useCallback(
//   //   (value) => {
//   //     setDispatchWarehouse(value);
//   //     setReceiptData((prev) => ({
//   //       ...prev,
//   //       warehousename: value.label,
//   //       warehouseId: value.value,
//   //     }));
//   //     setShippingInfo((prev) => {
//   //       const updatedShippingInfo = prev.map((item) => ({
//   //         ...item,
//   //         isDispatchWarehouse:
//   //           item.warehouseId === value?.value ||
//   //           item.warehousename === value.label,
//   //       }));
//   //       return updatedShippingInfo;
//   //     });

//   //     setTimeout(() => {
//   //       setShippingInfo((prev) => {
//   //         fetchDMs(
//   //           prev.map(({ warehouseId, isDispatchWarehouse }) => ({
//   //             warehouseId,
//   //             isDispatchWarehouse,
//   //           })),
//   //           "",
//   //         );
//   //         return prev;
//   //       });
//   //     }, 0);
//   //   },
//   //   [fetchDMs],
//   // );

//   const openShippingModal2 = useCallback(
//     (type2) => {
//       handleOpenModal(
//         // <ProSaleShippingChargesModal
//         //   mode={mode}
//         //   orderId={orderId}
//         //   close={() => handleCloseModal()}
//         //   // skipShippingCharges={(dw) => handleSkipShippingCharges(dw)}
//         //   itemsdetails={getValidSaleItems(itemDetails)}
//         //   isShippingBlocked={isShippingBlocked}
//         //   // shippingType={shippingType}
//         //   pincode={shippingAddress.pincode}
//         //   shippingInfo={shippingInfo}
//         //   setShippingInfo={setShippingInfo}
//         //   openShippingChargesInfoModal={openShippingChargesInfoModal}
//         //   setGeneralInfo={setGeneralInfo}
//         //   type2={type2}
//         //   setDispatchWarehouse={setDispatchWarehouse}
//         //   // selectDispatchWarehouse={selectDispatchWarehouse}
//         // />,

//         <ProSaleShippingChargesModal/>

//       );
//     },
//     [
//       mode,
//       orderId,
//       itemDetails,
//       isShippingBlocked,
//       shippingAddress.pincode,
//       shippingInfo,
//       // selectDispatchWarehouse,
//       // handleSkipShippingCharges,
//       openShippingChargesInfoModal,
//     ],
//   );

//   useEffect(() => {
//     if (isModalOpen && modalContent?.type === ConfirmOrder) {
//       handleSubmit();
//     }
//   }, [handleSubmit, isModalOpen, modalContent?.type]);

//   // useEffect(() => {
//   //   if (flag === "edit" || flag === "view") {
//   //     generatePaymentLink(orderId);
//   //   }
//   // }, [flag, generatePaymentLink, orderId]);

//   const handleCancelOrder = async () => {
//     const apiData = {
//       managerId: managerId,
//       orderId: orderId,
//     };
//     try {
//       const result = await fetchData("order/cancelOrder", apiData);
//       if (result.status === "success") {
//         show("Order cancelled successfully", "success");
//         navigate("/orders");
//       }
//     } catch (error) {
//       show(error, "error");
//     }
//   };

//   const handleRequestForCancel = async (reason, warehouseId) => {
//     const apiData = {
//       managerId: managerId,
//       orderId: orderId,
//       reqType: "Request For Cancel",
//       reqIssue: reason,
//       warehouseId: warehouseId,
//     };
//     try {
//       const result = await fetchData("order/orderhelp", apiData);
//       if (result.status === "success") {
//         show(result.msg, "success");
//         navigate("/orders");
//       } else {
//         show(result.msg, "warning");
//       }
//     } catch (error) {
//       show(error, "error");
//     }
//   };

//   const openCancelOrderModal = () => {
//     handleOpenModal(
//       <ManagerModal
//         heading={"Cancel Order"}
//         centerHeading={"Are you sure want to cancel this Order?"}
//         subHeading={"To confirm! type cancel in the text field."}
//         targetWord={"cancel"}
//         handleCloseModal={() => handleCloseModal()}
//         handleSubmit={() => handleCancelOrder()}
//         focus={true}
//       />,
//     );
//   };

//   const openRequestForCancelModal = () => {
//     handleOpenModal(
//       <RequestForCancelModal
//         mode={mode}
//         handleCloseModal={() => handleCloseModal()}
//         handleSubmit={(reason, warehouseId) =>
//           handleRequestForCancel(reason, warehouseId)
//         }
//         type="order"
//         uniqueWarehouses={uniqueWarehouses}
//       />,
//     );
//   };

//   // const openShippingTypeModal = () => {
//   //   handleOpenModal(
//   //     <ShippingTypeModal
//   //       mode={mode}
//   //       handleCloseModal={() => handleCloseModal()}
//   //       setShippingType={setShippingType}
//   //       openShippingModal2={(shippingType) => openShippingModal2(shippingType)}
//   //     />,
//   //   );
//   // };

//   const dispatchDetailsClick = () => {
//     if (shippingInfo.length === 1) {
//       navigate(
//         "/dispatch/details/" + orderId + "/" + shippingInfo[0].warehouseId,
//       );
//     } else {
//       handleOpenModal(
//         <SelectWarehouse
//           mode={mode}
//           handleCloseModal={() => handleCloseModal()}
//           orderId={orderId}
//           shippingInfo={shippingInfo}
//         />,
//       );
//     }
//   };

//   useEffect(() => {
//     itemInpRefs.current = Array(itemDetails.length)
//       .fill()
//       .map((_, i) => itemInpRefs.current[i] || null);
//   }, [itemDetails.length]);

//   useEffect(() => {
//     const handleKeyDown = (event) => {
//       if (event.key === "Tab") {
//         event.preventDefault();
//       }

//       if (loadingBtn) {
//         event.preventDefault();
//         event.stopPropagation();
//       }

//       if (flag === "edit" && !isModalOpen) {
//         const isInputFocused = ["INPUT", "TEXTAREA", "SELECT"].includes(
//           document.activeElement.tagName,
//         );
//         if (
//           !isInputFocused &&
//           generalInfo.orderType !== "online" &&
//           event.key.toLowerCase() === "e"
//         ) {
//           event.preventDefault();
//           editBtnClick();
//         }
//       }
//     };

//     window.addEventListener("keydown", handleKeyDown, true);

//     return () => {
//       window.removeEventListener("keydown", handleKeyDown, true);
//     };
//   }, [editBtnClick, flag, isModalOpen, loadingBtn, generalInfo.orderType]);

//   useEffect(() => {
//     if (!itemDetails || itemDetails.length === 0) return;

//     const amount = itemDetails.reduce((sum, item) => {
//       if (item.amount && !isNaN(item.amount)) {
//         return sum + parseFloat(item.amount);
//       }
//       return sum;
//     }, 0);

//     const cartPriceSum = itemDetails.reduce((sum, currentItem) => {
//       return (
//         sum +
//         parseFloat(currentItem.price ?? 0) * parseFloat(currentItem.qty ?? 0)
//       );
//     }, 0);

//     const cartTotal = itemDetails
//       .map((x) =>
//         !x.accessories
//           ? 0
//           : x.accessories
//               .map((y) => (y.accessoriesQty ?? 0) * (y.accessoriesPrice ?? 0))
//               .reduce((a, b) => a + b, 0),
//       )
//       .reduce((a, b) => a + b, 0);

//     const subtotal = (cartPriceSum ?? 0) + (cartTotal ?? 0);

//     const gettotalAmount =
//       subtotal +
//       parseFloat(
//         generalInfo.toPay
//           ? 0
//           : generalInfo.deliveryPartner === "Self"
//             ? 0
//             : (generalInfo.shippingCharge ?? 0),
//       );

//     const totalAmount = Math.round(gettotalAmount);

//     setGeneralInfo((prev) => ({
//       ...prev,
//       amount,
//       cartPriceSum,
//       cartTotal,
//       subtotal,
//       totalAmount,
//     }));
//   }, [
//     itemDetails,
//     generalInfo.toPay,
//     generalInfo.deliveryPartner,
//     generalInfo.shippingCharge,
//   ]);

//   useEffect(() => {
//     const { totalAmount } = receipts.reduce(
//       (acc, receipt) => {
//         if (receipt.status === "Received") {
//           acc.totalAmount += receipt.paymentAmount;
//         }
//         if (receipt.status === "Cancelled") {
//           acc.cancelledAmount += receipt.paymentAmount;
//         }
//         return acc;
//       },
//       { totalAmount: 0, cancelledAmount: 0 },
//     );

//     setReceiptTotalAmount(totalAmount);
//   }, [receipts]);

//   const allReceived = receipts.every(
//     (receipt) => receipt.status === "Received",
//   );

//   const hasPod = receipts.some((receipt) => receipt.status === "POD Pending");

//   const shouldShowRequestForCancel =
//     orderId &&
//     ["Packing In Progress", "Packed", "Dispatched"].includes(
//       generalInfo.status,
//     ) &&
//     generalInfo.status !== "Cancelled" &&
//     generalInfo.reqType !== "Request For Cancel";

//   const shouldShowCancelOrder =
//     orderId &&
//     ["Payment Pending", "Payment Under Verification"].includes(
//       generalInfo.status,
//     ) &&
//     generalInfo.status !== "Cancelled" &&
//     generalInfo.reqType !== "Request For Cancel";

//   const hasDispatchedOrCompleted =
//     allOrdersData?.voucher?.dispatchStatus === "Completed" ||
//     allOrdersData?.voucher?.dispatchStatus === "Dispatched";

//   useEffect(() => {
//     onOrderData({
//       loading,
//       orderId,
//       type: generalInfo.orderType,
//       status: generalInfo.status,
//       orderManagerName: generalInfo.orderManagerName,
//       createdBy: generalInfo.createdBy,
//       orderDate: generalInfo.orderDate,
//     });
//   }, [
//     generalInfo.createdBy,
//     generalInfo.orderDate,
//     generalInfo.orderManagerName,
//     generalInfo.orderType,
//     generalInfo.status,
//     loading,
//     onOrderData,
//     orderId,
//   ]);

//   const verifyEntries = () => {
//     const warnings = [];
//     if (
//       itemDetails.every(
//         (item) =>
//           item.amount === "" &&
//           item.price === "" &&
//           item.unit === "" &&
//           item.qty === "" &&
//           item.itemNo === "",
//       ) ||
//       itemDetails.some((item) =>
//         Object.values(item).every((value) => value === ""),
//       )
//     ) {
//       warnings.push("Item Details are required");
//     }
//     if (warnings?.length === 0) {
//       return true;
//     } else {
//       show(warnings.join(" "), "warning");
//       return false;
//     }
//   };

//   const totalShippingCharges = shippingInfo?.shippingCharge;

//   useEffect(() => {
//     setGeneralInfo((prev) => ({
//       ...prev,
//       shippingCharge: totalShippingCharges,
//     }));
//   }, [totalShippingCharges]);

//   const isLiveEditingItems =
//     flag === "create" || (flag === "edit" && isEditMode);
//   const headerData = useMemo(() => {
//     const base = [
//       "S.No",
//       "Item No",
//       "Product",
//       "Collection",
//       "Quantity",
//       "Unit",
//       "Rate",
//       "Amount",
//     ];
//     const action = !isLiveEditingItems && selectedVersion ? ["Action"] : [];
//     return [...base, ...action];
//   }, [isLiveEditingItems, selectedVersion]);

//   const printSummarySlip = useReactToPrint({
//     content: () => summarySlipRef.current,
//   });

//   const handlePrintSummary = async () => {
//     await fetchOrder();
//     setTimeout(() => {
//       printSummarySlip();
//     }, 300);
//   };

//   const openAdvancePaymentInfoModal = (data) => {
//     handleOpenModal(<AdvanceAmountModalInfo mode={mode} data={data} />);
//   };

//   const displayedItems = useMemo(() => {
//     if (isLiveEditingItems) return itemDetails;
//     if (selectedVersion) {
//       const entry = versionsData.find((v) => v.version === selectedVersion);
//       return (entry?.items || []).map((change) => ({
//         _uid: change.itemId + "-" + change.version,
//         itemId: change.itemId,
//         action: change.action,
//         updatedBy: change.updatedBy,
//         updateTime: change.updateTime,
//         changes: change.changes || [],
//         ...change.data,
//       }));
//     }
//     return itemDetails;
//   }, [isLiveEditingItems, selectedVersion, versionsData, itemDetails]);

//   const hasVersionHistory = versionsData?.length > 0;

//   // ────────────────────────────────────────────────────────────────────────

//   return (
//     <>
//       <ModalWrapper isOpen={isModalOpen} onClose={handleCloseModal} noBtn>
//         {modalContent}
//       </ModalWrapper>

//       <div className={styles.so_scroll_wrapper} ref={scroll_wrapper_ref}>
//         <form className={styles.so_form}>
//           <div className={styles.so_form_1}>
//             {loading && (flag === "edit" || flag === "view") ? (
//               <div>
//                 <Skeleton
//                   lines={1}
//                   thickness={4.5}
//                   additionalStyles={{
//                     marginBottom: "0px",
//                     marginTop: "20px",
//                   }}
//                 />
//               </div>
//             ) : (
//               <div style={{ position: "relative" }}>
//                 <InputTag
//                   ref={dealerInpRef}
//                   labelText={"Company or Dealer's Name / ID"}
//                   placeholderText={"Search Dealer"}
//                   padding={"8px"}
//                   fontSize={"12px"}
//                   value={
//                     useFallback && !searchDealer
//                       ? generalInfo.storeName && generalInfo.dealerName
//                         ? `${generalInfo.storeName} / ${generalInfo.dealerName}`
//                         : generalInfo.storeName || generalInfo.dealerName || ""
//                       : searchDealer
//                   }
//                   onChange={(e) => {
//                     setSearchDealer(e.target.value);
//                     setUseFallback(false);
//                   }}
//                   onFocus={() => {
//                     if (flag === "create") {
//                       setShowDealerSearch(true);
//                     }
//                   }}
//                   onBlur={() => {
//                     setShowDealerSearch(false);
//                     if (searchDealer === "") {
//                       setUseFallback(true);
//                     }
//                   }}
//                   onKeyDown={(e) => handleDealerKeyDown(e)}
//                   maxLength={100}
//                   required
//                   enterKeyHint={"enter"}
//                   readOnly={flag === "view"}
//                 />

//                 {showDealerSearch && (
//                   <SearchDealer
//                     mode={mode}
//                     results={dealerResults}
//                     loading={dealerLoading}
//                     currentIndex={currentIndex}
//                     onDealerSelect={handleSelectDealer}
//                     openAddDealerModal={openAddDealerModal}
//                   />
//                 )}
//               </div>
//             )}

//             {loading && (flag === "edit" || flag === "view") ? (
//               <div>
//                 <Skeleton
//                   lines={1}
//                   thickness={4.5}
//                   additionalStyles={{
//                     marginBottom: "0px",
//                     marginTop: "20px",
//                   }}
//                 />
//               </div>
//             ) : (
//               <div>
//                 <InputTag
//                   labelText={"Shipping Address"}
//                   placeholderText={"Enter Dealer Address"}
//                   value={
//                     [
//                       shippingAddress.street,
//                       shippingAddress.city,
//                       shippingAddress.district,
//                       shippingAddress.state,
//                       shippingAddress.pincode,
//                     ]
//                       .filter(Boolean)
//                       .join(" ") || ""
//                   }
//                   padding={"8px"}
//                   fontSize={"12px"}
//                   required
//                 />
//               </div>
//             )}
//           </div>

//           <div className={styles.so_form_1}>
//             <div>
//               {loading && (flag === "edit" || flag === "view") ? (
//                 <div style={{ width: "100%" }}>
//                   <Skeleton
//                     lines={1}
//                     thickness={4.5}
//                     additionalStyles={{
//                       marginBottom: "0px",
//                       marginTop: "20px",
//                     }}
//                   />
//                 </div>
//               ) : (
//                 <div className={styles.warehouse_selectors}>
//                   <div
//                     style={{
//                       width: "100%",
//                       position: "relative",
//                     }}
//                   >
//                     {/* {flag !== "create" && (
//                       <div className={styles.voucher_det}>
//                         <p style={{ color: mode && "#FFFFFF" }}>
//                           {shippingType}
//                         </p>
//                       </div>
//                     )} */}

//                     <div>
//                       <InputTag
//                         labelText={"Warehouse"}
//                         placeholderText={"Warehouse"}
//                         padding={"8px"}
//                         fontSize={"12px"}
//                         value={generalInfo?.warehousename}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>

//             {loading && (flag === "edit" || flag === "view") ? (
//               <div>
//                 <Skeleton
//                   lines={1}
//                   thickness={4.5}
//                   additionalStyles={{
//                     marginBottom: "0px",
//                     marginTop: "20px",
//                   }}
//                 />
//               </div>
//             ) : (
//               <div>
//                 <div style={{ width: "100%", position: "relative" }}>
//                   <div className={styles.voucher_det}>
//                     <p style={{ color: mode && "#FFFFFF" }}>
//                       {shippingInfo?.courierName}
//                     </p>
//                   </div>

//                   <div>
//                     <InputTag
//                       labelText={"Delivery Method"}
//                       placeholderText={"Delivery Method"}
//                       padding={"8px"}
//                       fontSize={"12px"}
//                       value={
//                         shippingInfo?.methodName || shippingInfo?.partnerName
//                       }
//                     />
//                   </div>

//                   {isEditMode && (
//                     <div className={styles.change_ship}>
//                       <span
//                         style={{ color: !mode && "#4164E3" }}
//                         // onClick={() => openShippingModal2(shippingType, "")}
//                         onClick={() => openShippingModal2("")}
//                       >
//                         Update
//                       </span>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             )}
//           </div>
//         </form>

//         {/* ------------------------- Version History -------------------------- */}

//         {!isLiveEditingItems && hasVersionHistory && (
//           <div
//             style={{
//               flex: 1,
//               display: "flex",
//               flexDirection: "row",
//               marginTop: "10px",
//               alignItems: "center",
//               gap: "6px",
//             }}
//           >
//             <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//               <span
//                 style={{ fontSize: 14, color: mode ? "#ffffff" : "#000000" }}
//               >
//                 Version History
//               </span>

//               <SlidingFilter
//                 itemList={[
//                   "Current",
//                   ...[...versionsData]
//                     .sort((a, b) => b.version - a.version)
//                     .map((v) => `Version ${v.version}`),
//                 ]}
//                 activeFilter={
//                   selectedVersion ? `Version ${selectedVersion}` : "Current"
//                 }
//                 setFilter={(label) =>
//                   setSelectedVersion(
//                     label === "Current"
//                       ? null
//                       : Number(label.replace("Version ", "")),
//                   )
//                 }
//               />
//             </div>

//             {selectedVersion &&
//               (() => {
//                 const entry = versionsData.find(
//                   (v) => v.version === selectedVersion,
//                 );
//                 if (!entry) return null;
//                 const { updatedBy, updateTime } = getVersionMeta(entry);
//                 return (
//                   <div
//                     style={{
//                       fontSize: 12,
//                       color: "#4164E3",
//                       fontWeight: 600,
//                     }}
//                   >
//                     {updatedBy}
//                     {" • "}
//                     {formatDateTime(updateTime)}
//                   </div>
//                 );
//               })()}
//           </div>
//         )}
//         {/* ----------------------------------------------------------------------- */}

//         <ul className={styles.p_table}>
//           <div
//             className={styles.p_table_header_con}
//             style={{
//               visibility: loading && "hidden",
//             }}
//           >
//             <li
//               className={`${styles.p_table_header} ${
//                 mode ? styles.p_table_header_dark : ""
//               }`}
//             >
//               {headerData?.map((h, index) => (
//                 <div className={styles.entry_2} key={`${h}-${index}`}>
//                   {h}
//                 </div>
//               ))}
//             </li>
//             {(flag === "create" || isEditMode) && itemDetails?.length > 1 && (
//               <div
//                 style={{
//                   visibility: "hidden",
//                   display: flag === "view" && "none",
//                 }}
//               >
//                 <RemoveIcon />
//               </div>
//             )}
//           </div>

//           <div className={styles.p_table_list}>
//             <>
//               {displayedItems?.map((item, index) => (
//                 // ── Use _uid as key so removing an item never shifts
//                 //    React component instances or their local state ──────
//                 <React.Fragment key={item._uid ?? `${item.itemNo}-${index}`}>
//                   {isLiveEditingItems ? (
//                     <ProductionSaleNewItemList
//                       mode={mode}
//                       index={index}
//                       item={item}
//                       itemInpRefs={(el) => {
//                         if (el) itemInpRefs.current[index] = el;
//                       }}
//                       quantityRefs={qtyInputRefs}
//                       onItemChange={(field, value) =>
//                         handleItemChange(index, field, value)
//                       }
//                       onRemove={() => removeItem(index)}
//                       onAddNewItem={handleAddNewItem}
//                       itemDetailsLength={itemDetails.length}
//                       itemFocus={handleItemInputFocus}
//                       itemBlur={handleItemInputBlur}
//                       focusedItemIndex={focusedItemIndex}
//                       showItemSearch={showItemSearch}
//                       setShowItemSearch={setShowItemSearch}
//                       onShowDesc={(value) => setShowDescriptionInput(value)}
//                       // onCompletion={() => {
//                       //   if (shippingInfo.length === 1) {
//                       //     openShippingModal2("Combined", "normal");
//                       //   }
//                       // }}

//                       onCompletion={() => {
//                         const canOpen =
//                           itemDetails.length > 0 &&
//                           (shippingInfo.length === 1 ||
//                             generalInfo?.warehouseId);

//                         if (canOpen) {
//                           openShippingModal2("Combined", "normal");
//                         }
//                       }}
//                       flag={flag}
//                       allItems={displayedItems}
//                       setDispatchWarehouse={setDispatchWarehouse}
//                       setGeneralInfo={setGeneralInfo}
//                       generalInfo={generalInfo}
//                     />
//                   ) : (
//                     <>
//                       {loading ? (
//                         <div>
//                           <Skeleton
//                             lines={
//                               displayedItems?.length === 1
//                                 ? 1
//                                 : displayedItems?.length / 2
//                             }
//                             thickness={5}
//                             additionalStyles={{
//                               marginBottom: "0px",
//                               marginTop: "0px",
//                             }}
//                           />
//                         </div>
//                       ) : (
//                         <DataItemListProAndSale
//                           d={item}
//                           index={index}
//                           mode={mode}
//                           voucherType={"Production & Sale"}
//                           selectedVersion={selectedVersion}
//                           isLiveEditingItems={isLiveEditingItems}
//                         />
//                       )}
//                     </>
//                   )}
//                 </React.Fragment>
//               ))}
//             </>
//           </div>

//           {(flag === "create" || isEditMode) && (
//             <div
//               className={styles.cricle_btn}
//               onClick={() => {
//                 handleAddNewItem();
//               }}
//             >
//               <TestTopAddDealerIcon color="#4164E3" />
//             </div>
//           )}

//           {showDescriptionInput && (flag === "create" || flag === "edit") && (
//             <div className={styles.so_instc}>
//               <p>Press Enter to Add Item</p>
//               <DividerIcon />
//               <p>Double Enter for Next Option</p>
//               <DividerIcon />
//               <p>Ctrl + Backspace for Remove Item</p>
//             </div>
//           )}
//         </ul>
//       </div>

//       {loading ? (
//         <div
//           style={{ padding: "0", boxShadow: "none" }}
//           className={`${styles.so_footer} ${mode ? styles.so_footer_dark : ""}`}
//         >
//           <Skeleton
//             lines={1}
//             thickness={5}
//             additionalStyles={{
//               marginBottom: "0px",
//               marginTop: "0px",
//               borderRadius: "15px 15px 0 0",
//             }}
//           />
//         </div>
//       ) : (
//         <div
//           className={`${styles.so_footer} ${mode ? styles.so_footer_dark : ""}`}
//         >
//           {(flag === "edit" || flag === "view") && (
//             <div className={styles.so_footer_left}>
//               <div
//                 className={`${styles.so_receipt_data} ${
//                   mode ? styles.so_receipt_data_dark : ""
//                 }`}
//               >
//                 <div
//                   className={`${styles.so_receipt_data_header} ${
//                     mode ? styles.so_receipt_data_header_dark : ""
//                   }`}
//                   style={{ cursor: "auto" }}
//                 >
//                   <div className="col">Receipt ID</div>
//                   <div className="col">Method</div>
//                   <div className="col">Amount</div>
//                   <div className="col">Status</div>
//                 </div>
//                 <div
//                   className={styles.scroll_con}
//                   style={{ display: receipts?.length === 0 && "none" }}
//                 >
//                   {receipts?.length !== 0 &&
//                     receipts?.map((r, index) => (
//                       <div
//                         className={`${styles.so_receipt_data_entry} ${
//                           mode ? styles.so_receipt_data_entry_dark : ""
//                         }`}
//                         key={index}
//                         onClick={() => {
//                           handleOpenModal(
//                             <AddReceiptModal
//                               handleCloseModal={handleCloseModal}
//                               mode={mode}
//                               totalAmount={generalInfo.totalAmount}
//                               accounts={accounts}
//                               receiptData={r}
//                               updateReceiptData={async (updatedData) =>
//                                 updateReceiptData(
//                                   updatedData,
//                                   orderId,
//                                   r.receiptId,
//                                 )
//                               }
//                               type={"create"}
//                               flag={"notupdateamount"}
//                               uniqueWarehouses={uniqueWarehouses}
//                               // shippingType={shippingType}
//                               dispatchWarehouse={dispatchWarehouse}
//                               setReceiptData={setReceiptData}
//                               isModalOpen={isModalOpen}
//                               receiptTotalAmount={receiptTotalAmount}
//                               isSelf={isSelf}
//                             />,
//                           );
//                         }}
//                       >
//                         <div className="col" key={index + r.receiptId}>
//                           {r.receiptId}
//                         </div>
//                         <div className="col" key={index + r.paymentMethod}>
//                           {r.paymentMethod}
//                         </div>
//                         <div className="col" key={index + r.paymentAmount}>
//                           {r.paymentAmount}
//                         </div>
//                         <div
//                           className="col"
//                           key={index + r.status}
//                           style={{ color: getStatusColor(r.status) }}
//                         >
//                           {r.status}
//                         </div>
//                       </div>
//                     ))}
//                 </div>
//               </div>

//               {(receiptTotalAmount < generalInfo.totalAmount ||
//                 hasPod ||
//                 !allReceived) && (
//                 <div
//                   className={styles.add_receipt_btn}
//                   onClick={async () => {
//                     // await fetchDMs();
//                     // orderSuccessKeyPress("addReceipt");
//                   }}
//                 >
//                   <TestTopAddDealerIcon />
//                 </div>
//               )}

//               {allOrdersData?.order?.paymentStatus && (
//                 <div>
//                   <p
//                     style={{
//                       color:
//                         allOrdersData?.order?.paymentStatus === "Received"
//                           ? "#297038"
//                           : "#f11717",
//                     }}
//                   >
//                     {allOrdersData?.order?.paymentStatus}
//                   </p>
//                 </div>
//               )}
//             </div>
//           )}

//           <div className={styles.so_footer_right}>
//             <div className={styles.right_btns}>
//               {(flag === "edit" || flag === "view") && (
//                 <MoreDropdown
//                   mode={mode}
//                   onSummaryClick={handlePrintSummary}
//                   onSlipClick={() => {
//                     show("Coming soon...");
//                   }}
//                 />
//               )}

//               {shouldShowRequestForCancel && (
//                 <Button
//                   buttonIcon={<CancelIcon2 />}
//                   buttonText={"Request for Cancel"}
//                   buttonBgColor={"#000000"}
//                   buttonTextColor={"#ffffff"}
//                   buttonBorder={"none"}
//                   buttonClick={openRequestForCancelModal}
//                 />
//               )}

//               {shouldShowCancelOrder && (
//                 <Button
//                   buttonIcon={<CancelIcon2 />}
//                   buttonText={"Cancel Order"}
//                   buttonBgColor={"#000000"}
//                   buttonTextColor={"#ffffff"}
//                   buttonBorder={"none"}
//                   buttonClick={openCancelOrderModal}
//                 />
//               )}

//               {(flag === "edit" || flag === "view") && (
//                 <Button
//                   buttonIcon={<NewEyeIcon />}
//                   buttonText={"Invoice"}
//                   buttonBgColor={"#000000"}
//                   buttonTextColor={"#ffffff"}
//                   buttonBorder={"none"}
//                   buttonClick={() =>
//                     navigate("/orders/saleinvoice?orderId=" + orderId)
//                   }
//                 />
//               )}

//               {hasDispatchedOrCompleted && (
//                 <Button
//                   buttonIcon={<NewEyeIcon />}
//                   buttonText={"Dispatch Details"}
//                   buttonBgColor={"#000000"}
//                   buttonTextColor={"#ffffff"}
//                   buttonBorder={"none"}
//                   buttonClick={dispatchDetailsClick}
//                 />
//               )}

//               {(flag === "edit" || flag === "view") &&
//                 generalInfo.status !== "Cancelled" &&
//                 generalInfo.reqType !== "Request For Cancel" && (
//                   <Button
//                     buttonIcon={<ShareIcon />}
//                     buttonText={"Share"}
//                     buttonBgColor={"#4164E3"}
//                     buttonTextColor={"#ffffff"}
//                     buttonBorder={"none"}
//                     buttonClick={() => orderSuccessKeyPress("shareLink")}
//                   />
//                 )}
//             </div>

//             <div
//               className={`${styles.so_amount_info} ${
//                 mode ? styles.so_amount_info_dark : ""
//               }`}
//             >
//               <div>
//                 <p>Sub Total:</p>
//                 <p>₹ {generalInfo.subtotal}</p>
//               </div>

//               <div className={styles.so_shipping}>
//                 <p>Shipping Charges:</p>{" "}
//                 <div className={styles.info_btn_con}>
//                   <span
//                     className={styles.info_btn}
//                     onClick={() =>
//                       openShippingChargesInfoModal(
//                         // shippingType,
//                         dispatchWarehouse,
//                         shippingInfo,
//                       )
//                     }
//                   >
//                     <InfoRounded color={mode ? "#FFFFFF" : "#1C274C"} />
//                   </span>
//                 </div>
//                 <input
//                   type="number"
//                   value={
//                     (generalInfo.deliveryPartner === "Self"
//                       ? 0
//                       : generalInfo.shippingCharge
//                     )
//                       ?.toString()
//                       .replace(/^0+/, "") || 0
//                   }
//                   onChange={(e) => {
//                     let value = Number(e.target.value);
//                     if (value > 0) {
//                       setGeneralInfo((prevState) => ({
//                         ...prevState,
//                         shippingCharge: value,
//                       }));
//                     } else {
//                       setGeneralInfo((prevState) => ({
//                         ...prevState,
//                         shippingCharge: -1 * value,
//                       }));
//                     }
//                   }}
//                   readOnly={!isNoCase || flag === "view"}
//                   maxLength="10"
//                   onInput={(e) =>
//                     (e.target.value = e.target.value.slice(0, 10))
//                   }
//                   style={mode ? { color: "#fff" } : {}}
//                   ref={shippingRef}
//                   onKeyDown={(e) => {
//                     if (e.key === "Enter") {
//                       checkboxRef.current?.focus();
//                     }
//                   }}
//                 />
//                 <div className={styles.so_check}>
//                   <p>To Pay</p>
//                   <input
//                     type="checkbox"
//                     checked={generalInfo.toPay}
//                     onChange={(e) => {
//                       const isChecked = e.target.checked;

//                       if (
//                         isChecked &&
//                         isNoCase &&
//                         generalInfo.shippingCharge === 0
//                       ) {
//                         e.preventDefault();
//                         show(
//                           "Update shipping charges to check To Pay!",
//                           "warning",
//                         );
//                         return;
//                       }

//                       setGeneralInfo((prevState) => ({
//                         ...prevState,
//                         toPay: isChecked,
//                       }));
//                     }}
//                     ref={checkboxRef}
//                     disabled={
//                       flag === "view" || (flag === "edit" && !isEditMode)
//                     }
//                     onKeyDown={(e) => {
//                       if (e.key === "Enter") {
//                         handleSubmit();
//                       }
//                     }}
//                   />
//                 </div>
//                 <p>
//                   {loadingBtn ? (
//                     <Spinner
//                       borderWidth={"1px"}
//                       height={10}
//                       width={10}
//                       color={mode ? "#000000" : "#4164E3"}
//                     />
//                   ) : (
//                     <>
//                       ₹{" "}
//                       {generalInfo.deliveryPartner === "Self"
//                         ? 0
//                         : generalInfo.shippingCharge}
//                     </>
//                   )}
//                 </p>
//               </div>

//               <div>
//                 <p>
//                   Total Amount(INR):{" "}
//                   {receipts?.length > 0 && (
//                     <span
//                       className={styles.info_btn}
//                       onClick={() => openAdvancePaymentInfoModal(receipts)}
//                     >
//                       <InfoRounded color={mode ? "#FFFFFF" : "#1C274C"} />
//                     </span>
//                   )}
//                 </p>

//                 <p>
//                   {loadingBtn ? (
//                     <Spinner
//                       borderWidth={"1px"}
//                       height={10}
//                       width={10}
//                       color={mode ? "#000000" : "#4164E3"}
//                     />
//                   ) : (
//                     <>₹ {Number(generalInfo.totalAmount) || 0}</>
//                   )}
//                 </p>
//               </div>
//             </div>

//             {flag === "edit" && (
//               <div>
//                 {isEditMode ? (
//                   <>
//                     {showSave ? (
//                       <Button
//                         buttonIcon={<SaveIcon />}
//                         buttonText={"Save"}
//                         buttonBgColor={"#4164E3"}
//                         buttonTextColor={"#FFFFFF"}
//                         buttonBorder={"none"}
//                         buttonClick={() => {
//                           if (verifyEntries()) {
//                             handleSubmit();
//                           }
//                         }}
//                       />
//                     ) : (
//                       <div className={styles.flex}>
//                         <Button
//                           buttonIcon={<CancelIcon2 />}
//                           buttonText={"Cancel"}
//                           buttonBgColor={"#000000"}
//                           buttonTextColor={"#ffffff"}
//                           buttonBorder={"none"}
//                           buttonClick={() => setIsEditMode(false)}
//                           loading={loadingBtn}
//                         />
//                       </div>
//                     )}
//                   </>
//                 ) : (
//                   <>
//                     {generalInfo.orderType !== "online" && (
//                       <Button
//                         buttonIcon={<EditManagerIcon />}
//                         buttonText={"Edit"}
//                         buttonBgColor={"#4164E3"}
//                         buttonTextColor={"#FFFFFF"}
//                         buttonBorder={"none"}
//                         buttonClick={editBtnClick}
//                       />
//                     )}
//                   </>
//                 )}
//               </div>
//             )}

//             {flag === "create" && (
//               <div>
//                 {showSave && (
//                   <Button
//                     buttonIcon={<SaveIcon />}
//                     buttonText={"Save"}
//                     buttonBgColor={"#4164E3"}
//                     buttonTextColor={"#FFFFFF"}
//                     buttonBorder={"none"}
//                     buttonClick={() => {
//                       if (verifyEntries()) {
//                         handleSubmit();
//                       }
//                     }}
//                   />
//                 )}
//               </div>
//             )}
//           </div>
//         </div>
//       )}

//       {/* ------------ Summary Slip ------------------- */}
//       <div style={{ display: "none" }}>
//         <NewSummarySlip
//           ref={summarySlipRef}
//           summarySlipData={itemDetails}
//           generalInfo={allOrdersData?.order}
//         />
//       </div>
//     </>
//   );
// };

// export default ProductionSale;

// ---------------------------------

import { useNavigate, useSearchParams } from "react-router-dom";
import styles from "./ProductionSale.module.css";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import fetchData from "../../APIsControll/apiControll";
import { useAuth } from "../../components/context/Auth";
import InputTag from "../../components/updatedComponents/FormComponents/InputTag";
import Skeleton from "../../components/updatedComponents/Skeleton/Skeleton";
import SearchDealer from "../../components/updatedComponents/OrderManager/SearchDealer";
import DealerAddressModal from "../../components/updatedComponents/OrderManager/DealerAddressModal";
import AdduserModel from "../../components/updatedComponents/models/AdduserModel";
import ModalWrapper from "../../components/updatedComponents/layoutWrapper/ModalWrapper";
import {
  CancelIcon2,
  DividerIcon,
  EditManagerIcon,
  InfoRounded,
  NewEyeIcon,
  RemoveIcon,
  SaveIcon,
  ShareIcon,
  TestTopAddDealerIcon,
} from "../../components/icons/Icon";
import ManagerModal from "../../components/updatedComponents/Manager/ManagerModal";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
import OrderSuccessModal from "../../components/updatedComponents/OrderManager/OrderSuccessModal";
import ShareLinkModal from "../../components/updatedComponents/OrderManager/ShareLinkModal";
import AddReceiptModal from "../../components/updatedComponents/OrderManager/AddReceiptModal";
import { handleFileData } from "../../APIsControll/apiControl2";
import Button from "../../components/updatedComponents/Dealers/Button";
import RequestForCancelModal from "../../components/updatedComponents/OrderManager/RequestForCancelModal";
import Spinner from "../../components/updatedComponents/FormComponents/Spinner";
import ConfirmOrder from "../../components/updatedComponents/OrderManager/ConfirmOrder";
import Warning from "../../components/updatedComponents/Receipts/Warning";
import { useDispatch } from "react-redux";
import { setFilter } from "../../store/slices/order/OrderSlice";
import { formatDateTime, getStatusColor } from "../../Utils/Utils";
import MoreDropdown from "../dispatchmanager/MoreDropdown";
import { useReactToPrint } from "react-to-print";
import NewSummarySlip from "../dispatchmanager/NewSummarySlip";
import AdvanceAmountModalInfo from "../../components/updatedComponents/OrderManager/AdvanceAmountModalInfo";
import ProductionSaleNewItemList from "../../components/updatedComponents/OrderManager/ProductionSaleNewItemList";
import SlidingFilter from "../../components/updatedComponents/Dealers/SlidingFilter";
import ProSaleShippingChargesModal from "../../components/updatedComponents/OrderManager/ProSaleShippingChangesModal";
import DataItemListProAndSale from "../../components/updatedComponents/OrderManager/DataItemListProAndSale";
import ProSaleShippingChargesInfoModal from "../../components/updatedComponents/OrderManager/ProSaleShippingChargesInfoModal";

// ─── UID generator (frontend-only, never sent to API) ───────────────────────
let _uidCounter = 0;
const genUid = () => `item-${++_uidCounter}-${Date.now()}`;

const getVersionMeta = (versionEntry) => {
  const items = versionEntry?.items || [];

  for (let i = items.length - 1; i >= 0; i--) {
    if (items[i].updatedBy && items[i].updateTime) {
      return {
        updatedBy: items[i].updatedBy,
        updateTime: items[i].updateTime,
        action: items[i].action,
      };
    }
  }

  return {
    updatedBy: "",
    updateTime: "",
    action: "",
  };
};

// ─── API endpoints ────────────────────────────────────────────────────────
const PROD_SALE_VOUCHER_API_1 = "order/prodAndSalesVoucher"; // GET / fetch
const PROD_SALE_VOUCHER_API = "order/prodAndSaleVoucher"; // POST / create+update

const ProductionSale = ({ onOrderData }) => {
  const { managerId, mode, designation } = useAuth();

  const dispatch = useDispatch();

  const { show } = useToast();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("orderId")
    ? searchParams.get("orderId")
    : "";

  const dealerInpRef = useRef(null);
  const locationRef = useRef(null);
  const scroll_wrapper_ref = useRef(null);
  const itemInpRefs = useRef([]);
  const qtyInputRefs = useRef([]);
  const shippingRef = useRef(null);
  const checkboxRef = useRef(null);
  const summarySlipRef = useRef(null);

  const initialItemDetails = useMemo(
    () => ({
      _uid: genUid(), // frontend-only, stripped before API calls
      itemId: "", // "" for a brand new line, real itemId once loaded from server
      amount: 0,
      collection_name: "",
      desc: "",
      descKey: "",
      dp: 0,
      itemNo: "",
      price: 0,
      product_name: "",
      qty: 0,
      thumbnail: "",
      totalQty: "",
      unit: "",
      vm: 0,
      warehouse: "",
      warehouseId: "",
      weight: 0,
      batch: "",
      specific: "Yes",
    }),
    [],
  );

  const initialReceiptData = useMemo(
    () => ({
      paymentMethod: "Cash",
      transactionScreenshot: "",
      paymentAmount: "",
      transactionId: "",
      accountNumber: "",
      totalAmount: "",
      receiptId: "",
      paymentType: "Cash",
      warehousename: "",
      warehouseId: "",
    }),
    [],
  );

  const [generalInfo, setGeneralInfo] = useState({});
  const [itemDetails, setItemDetails] = useState([initialItemDetails]);

  // ── Version History state ─────────────────────────────────────────────
  const [selectedVersion, setSelectedVersion] = useState(null);
  const [versionsData, setVersionsData] = useState([]);
  // ────────────────────────────────────────────────────────────────────────

  const flag = useMemo(() => {
    if (!orderId) {
      return "create";
    }
    if (orderId && generalInfo.status === "Payment Pending") {
      return "edit";
    }
    if (orderId && generalInfo.status !== "Payment Pending") {
      return "view";
    }
    return "";
  }, [orderId, generalInfo.status]);

  const [loading, setLoading] = useState(false);
  const [showSave, setShowSave] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const [receipts, setReceiptsInfo] = useState([]);

  const [accounts, setAccounts] = useState([]);
  const [dispatchManagers, setDispatchManagers] = useState([]);

  const [showDealerSearch, setShowDealerSearch] = useState(
    flag === "create" ? true : false,
  );
  const [searchDealer, setSearchDealer] = useState("");
  const [dealerLoading, setDealerLoading] = useState(false);
  const [dealerResults, setDealerResults] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [updatedAddress, setUpdatedAddress] = useState(null);
  const [useFallback, setUseFallback] = useState(true);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);

  const [focusedItemIndex, setFocusedItemIndex] = useState(0);
  const [showItemSearch, setShowItemSearch] = useState(false);

  const [receiptData, setReceiptData] = useState(initialReceiptData);
  const [paymentLink, setPaymentLink] = useState("");

  const [skipped, setSkipped] = useState(false);
  const [isNoCase, setIsNoCase] = useState(false);

  const [shouldFocus, setShouldFocus] = useState(true);
  const [showDescriptionInput, setShowDescriptionInput] = useState(false);

  const [isManagerAssigned, setIsManagerAssigned] = useState(true);
  const [isShippingBlocked, setIsShippingBlocked] = useState(false);
  const [isPodBlocked, setIsPodBlocked] = useState(false);
  const [orderManagers, setOrderManagers] = useState([]);
  const [dispatchWarehouse, setDispatchWarehouse] = useState();

  const [shippingAddress, setShippingAddress] = useState({});
  const [allOrdersData, setAllOrdersData] = useState([{}]);

  // ── shippingInfo is ONE object for the whole voucher — NOT an array,
  //    NOT warehouse-wise. Matches the API's voucher.shippingInfo shape.
  const initialShippingDetails = {
    methodId: "",
    shippingCharge: 0,
    courierName: "Pick Up",
    methodName: "Self",
    partnerName: "Self",
    delInstruction: "",
    toPay: false,
  };

  const [shippingInfo, setShippingInfo] = useState(initialShippingDetails);
  const [instructions, setInstructions] = useState({});
  const [uniqueWarehouses, setUniqueWarehouses] = useState([]);
  const [receiptTotalAmount, setReceiptTotalAmount] = useState();

  const shippingInfoRef = useRef(shippingInfo);

  useEffect(() => {
    shippingInfoRef.current = shippingInfo;
  }, [shippingInfo]);

  useEffect(() => {
    if (shouldFocus) {
      dealerInpRef.current?.focus();
    } else {
      dealerInpRef.current?.blur();
    }
  }, [shouldFocus]);

  useEffect(() => {
    if (flag === "create") {
      setGeneralInfo({});
      setReceiptData(initialReceiptData);
      setItemDetails([{ ...initialItemDetails, _uid: genUid() }]);
      setDispatchManagers([]);
      setShowDescriptionInput(false);
      itemInpRefs.current = [];
      qtyInputRefs.current = [];
      setFocusedItemIndex(null);
      setDealerResults([]);
      setIsNoCase(false);
      setShouldFocus(true);
      setSearchDealer("");
      setShowItemSearch(false);
      setIsEditMode(false);
      setReceiptsInfo([]);
      setAccounts([]);
      setPaymentLink("");
      setIsModalOpen(false);
      setModalContent(null);
      setSkipped(false);
      setShowSave(false);
      setLoading(false);
      setLoadingBtn(false);
      setIsManagerAssigned(true);
      setIsShippingBlocked(false);
      setIsPodBlocked(false);
      setOrderManagers([]);
      dispatch(setFilter({ selectedOption: "" }));
      setShippingAddress({});
      setShippingInfo(initialShippingDetails);
      setDispatchWarehouse(undefined);
      setReceiptTotalAmount();
      // ── reset version history state for a fresh "create" form ──────────
      setVersionsData([]);
      setSelectedVersion(null);
      // ─────────────────────────────────────────────────────────────────
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, flag, initialItemDetails, initialReceiptData]);

  const fetchOrder = useCallback(async () => {
    setLoading(true);
    try {
      const apiData = {
        managerId: managerId,
        voucherId: orderId,
      };
      const result = await fetchData(PROD_SALE_VOUCHER_API_1, apiData);

      if (result.status === "success") {
        setLoading(false);
        setAllOrdersData(result?.data);
        if (result?.data?.voucher) {
          setGeneralInfo((prevState) => ({
            ...prevState,
            dealerId: result?.data?.voucher?.dealerId,
            storeName: result?.data?.voucher?.storeName,
            dealerName: result?.data?.voucher?.name,
            createdBy: result?.data?.voucher?.createdBy,
            billingAddress: result?.data?.voucher?.billingAddress,
            shippingCharge: result?.data?.voucher?.shippingInfo?.shippingCharge,
            totalAmount: result?.data?.voucher?.totalAmount,
            subtotal: result?.data?.voucher?.subtotal,
            courierName: result?.data?.voucher?.shippingInfo?.courierName,
            mobile: result?.data?.voucher?.shippingAddress?.mobile
              ? result?.data?.voucher?.shippingAddress?.mobile
              : result?.data?.voucher?.DealerInfo?.whatsapp,
            whatsapp: result?.data?.voucher?.DealerInfo?.whatsapp
              ? result?.data?.voucher?.DealerInfo?.whatsapp
              : result?.data?.voucher?.shippingAddress?.mobile,
            email: result?.data?.voucher?.DealerInfo?.email
              ? result?.data?.voucher?.DealerInfo?.email
              : "",
            orderManagerName: result?.data?.voucher?.orderManagerName,
            dmId: result?.data?.voucher?.dmId,
            dmName: result?.data?.voucher?.dmName,
            orderDate: result?.data?.voucher?.voucherDate,
            orderId: result?.data?.voucher?.voucherId,
            status: result?.data?.voucher?.status,
            orderType: result?.data?.voucher?.voucherType,
            warehousename: result?.data?.voucher?.warehousename,
            warehouseId: result?.data?.voucher?.warehouseId,
            toPay: result?.data?.voucher?.shippingInfo?.toPay,
            dispatchStatus: result?.data?.voucher?.dispatchStatus,
            reqType: result?.data?.voucher?.reqType,
            deliveryPartners: {
              label: result?.data?.voucher?.shippingInfo?.methodName,
              value: result?.data?.voucher?.shippingInfo?.methodName,
            },
          }));

          // ── shippingInfo comes straight from the API as ONE object ──────
          setShippingInfo(
            result.data.voucher.shippingInfo || initialShippingDetails,
          );
          setShippingAddress(result?.data?.voucher?.shippingAddress);

          // ── Stamp each item with a frontend-only _uid, keep server itemId ──
          const stampedItems = result?.data?.voucher?.items.map((item) => ({
            ...item,
            _uid: genUid(),
          }));
          setItemDetails(stampedItems);
          // ───────────────────────────────────────────────────────────────

          // ── restore the single dispatch/order warehouse for edit/view ──
          setDispatchWarehouse({
            label: result?.data?.voucher?.warehousename || "",
            value: result?.data?.voucher?.warehouseId || "",
          });

          // ── Version History ────────────────────────────────────────────
          if (result?.data?.voucher?.itemsHistory) {
            setVersionsData(result.data.voucher.itemsHistory);
          } else {
            setVersionsData([]);
          }
          setSelectedVersion(null);
          // ────────────────────────────────────────────────────────────────

          setReceiptsInfo(result?.data?.receipts);
          setIsPodBlocked(
            result?.data?.voucher?.DealerInfo?.podBlock ? true : false,
          );
          setIsShippingBlocked(
            result?.data?.voucher?.DealerInfo?.shippingBlock ? true : false,
          );
        }
        if (result.data.accounts) {
          setAccounts(result.data.accounts);
        }
      }
    } catch {
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [managerId, orderId]);

  const fetchOrderRef = useRef(fetchOrder);
  fetchOrderRef.current = fetchOrder;

  useEffect(() => {
    if (managerId && (flag === "edit" || flag === "view")) {
      fetchOrder();
    }
  }, [fetchOrder, flag, managerId, orderId]);

  const fetchDealer = useCallback(async () => {
    try {
      setDealerLoading(true);
      const apiData = {
        managerId: managerId,
        keyword: searchDealer,
      };

      const result = await fetchData("order/finddealer", apiData);

      if (result.status === "success") {
        setDealerResults(result.data);
      }
      setDealerLoading(false);
    } catch (error) {
      setDealerLoading(false);
    }
  }, [managerId, searchDealer]);

  useEffect(() => {
    if (searchDealer) {
      const delayDebounceFn = setTimeout(() => {
        fetchDealer();
      }, 700);

      return () => clearTimeout(delayDebounceFn);
    }
  }, [searchDealer, fetchDealer]);

  const handleDealerKeyDown = (e) => {
    if (showDealerSearch) {
      if (e.key === "ArrowDown") {
        setCurrentIndex((prevIndex) =>
          prevIndex < dealerResults?.length - 1 ? prevIndex + 1 : prevIndex,
        );
        e.preventDefault();
      }

      if (e.key === "ArrowUp") {
        setCurrentIndex((prevIndex) =>
          prevIndex > 0 ? prevIndex - 1 : prevIndex,
        );
        e.preventDefault();
      }

      if ((e.altKey || e.metaKey) && e.key.toLowerCase() === "c") {
        setSearchDealer("");
        setTimeout(() => {
          openAddDealerModal();
        }, 100);
      }

      if (!dealerLoading) {
        if (e.key === "Enter") {
          e.preventDefault();
          handleSelectDealer(dealerResults && dealerResults[currentIndex]);
        }
      }
    }
  };

  const openAddDealerModal = () => {
    handleOpenModal(
      <AdduserModel
        focus={true}
        close={() => handleCloseModal()}
        onDealerAdd={(newDealer) => handleSelectDealer(newDealer)}
      />,
    );
  };

  const editBtnClick = useCallback(
    (d) => {
      setIsEditMode(true);
      handleOpenModal(
        <DealerAddressModal
          name={"dealer_address_modal"}
          shippingAddress={
            shippingAddress.street ||
            shippingAddress.city ||
            shippingAddress.district ||
            shippingAddress.state ||
            shippingAddress.pincode
              ? [
                  shippingAddress.street,
                  shippingAddress.city,
                  shippingAddress.district,
                  shippingAddress.state,
                  shippingAddress.pincode,
                ]
                  .filter(Boolean)
                  .join(" ")
              : undefined
          }
          ref={locationRef}
          handleCloseModal={() => handleCloseModal()}
          onAddressUpdate={(data) => {
            if (!isModalOpen) {
              setTimeout(() => {
                updateShippingAddress(d, data);
                itemInpRefs?.current[0]?.focus();
              }, 0);
            }
          }}
          mode={mode}
          onKeyPress={() => {
            if (!isModalOpen) {
              setTimeout(() => {
                itemInpRefs?.current[0]?.focus();
              }, 0);
            }
          }}
        />,
      );
    },
    [
      isModalOpen,
      mode,
      shippingAddress.city,
      shippingAddress.district,
      shippingAddress.pincode,
      shippingAddress.state,
      shippingAddress.street,
    ],
  );

  const handleSelectDealer = (d) => {
    let doesHaveAddress = false;

    if (!d) {
      console.error("Dealer data is undefined!");
      return;
    }

    if (
      d.street === "" ||
      d.city === "" ||
      d.district === "" ||
      d.state === "" ||
      d.pincode === ""
    ) {
      doesHaveAddress = true;
    }

    if (d.assignedManagerId === "") {
      setIsManagerAssigned(false);
    }

    if (d.shippingBlock === true) {
      setIsShippingBlocked(true);
    }

    if (d.podBlock === true) {
      setIsPodBlocked(true);
    }

    setSearchDealer(
      d.name && d.storeName
        ? `${d.storeName} / ${d.name}`
        : d.name || d.storeName || "",
    );

    if ("refcode" in d) {
      updateGeneralInfo(d);
      updateShippingAddress(d);
    } else {
      handleOpenModal(
        <DealerAddressModal
          name={"dealer_address_modal"}
          shippingAddress={
            d.street || d.city || d.district || d.state || d.pincode
              ? [d.street, d.city, d.district, d.state, d.pincode]
                  .filter(Boolean)
                  .join(" ")
              : undefined
          }
          form={doesHaveAddress}
          ref={locationRef}
          handleCloseModal={() => handleCloseModal()}
          onAddressUpdate={(data) => {
            setUpdatedAddress(data);
            updateGeneralInfo(d);
            updateShippingAddress(d, data);
          }}
          mode={mode}
          onKeyPress={(e) => {
            e.preventDefault();
            e.stopPropagation();
            updateGeneralInfo(d);
            updateShippingAddress(d, updatedAddress);
          }}
          focus={true}
        />,
      );
    }
  };

  const updateGeneralInfo = (d) => {
    if (d?.name === "Cash") {
      setGeneralInfo((prevState) => ({
        ...prevState,
        dealerId: d?.dealerId,
        dealerName: d?.name,
        storeName: d?.storeName,
        mobile: d?.mobile,
        whatsapp: d?.whatsapp,
        email: d?.email,
        gstuin: d?.gstuin ? d?.gstuin : "",
        assignedManagerId: d?.assignedManagerId || d?.refcode,
        courierName: "Pick Up",
        partnerName: "Self",
      }));
    } else {
      setGeneralInfo((prevState) => ({
        ...prevState,
        dealerId: d?.dealerId,
        dealerName: d?.name,
        storeName: d?.storeName,
        mobile: d?.mobile,
        whatsapp: d?.whatsapp,
        email: d?.email,
        gstuin: d?.gstuin,
        assignedManagerId: d?.assignedManagerId || d?.refcode,
        billingAddress:
          (d?.street || d?.city || d?.district || d?.state || d?.pincode) &&
          [d?.street, d?.city, d?.district, d?.state, d?.pincode]
            .filter(Boolean)
            .join(" "),
      }));
    }
    itemInpRefs.current[0]?.focus();
  };

  const updateShippingAddress = (dealer, address) => {
    setShippingAddress((prevState) => ({
      ...prevState,
      mobile: dealer?.mobile,
      name: dealer?.name,
      storeName: dealer?.storeName,
      pincode: address?.pinCode || dealer?.pincode,
      street: address?.streetAddress || dealer?.street,
      city: address?.city || dealer?.city,
      district: address?.district || dealer?.district,
      state: address?.state || dealer?.state,
      country: dealer?.country || "India",
    }));
  };

  const handleFocusNextItem = () => {
    setShouldFocus(false);
    setShowDescriptionInput(false);
    setTimeout(() => {
      const lastItemIndex = itemDetails?.length - 1;

      if (itemInpRefs?.current?.length) {
        const nextItemIndex = lastItemIndex + 1;

        if (nextItemIndex < itemInpRefs?.current?.length) {
          const nextItemRef = itemInpRefs?.current[nextItemIndex];
          nextItemRef?.focus();
          setFocusedItemIndex(nextItemIndex);
        }
      }
    }, 0);
    if (flag === "create") {
      setShowItemSearch(true);
    }
  };

  const handleItemInputFocus = (index) => {
    setFocusedItemIndex(index);
  };

  const handleItemInputBlur = () => {
    setTimeout(() => {
      setShowItemSearch(false);
      setFocusedItemIndex(null);
    }, 200);
  };

  const handleItemChange = (index, field, value) => {
    setItemDetails((prevItems) => {
      const updatedItems = [...prevItems];

      updatedItems[index] = {
        ...updatedItems[index],
        [field]: value,
      };

      return updatedItems;
    });
  };

  const removeItem = (index) => {
    setItemDetails((prevItems) => prevItems.filter((_, i) => i !== index));
  };

  const handleAddNewItem = () => {
    const errors = [];

    if (!itemDetails || itemDetails.length === 0) {
      errors.push("No items to validate");
    } else {
      itemDetails.forEach((item, index) => {
        if (item.outsourcedItem === "Disable") {
          if (!item.itemNo)
            errors.push(`Item ${index + 1}: Item Number cannot be empty`);

          if (!item.qty)
            errors.push(`Item ${index + 1}: Quantity cannot be empty`);

          if (item.qty > item.totalQty) {
            errors.push(
              `Item ${index + 1}: Quantity exceeds available stock (${item.totalQty})`,
            );
          }
        } else if (item.outsourcedItem === "Active") {
          if (!item.itemNo)
            errors.push(`Item ${index + 1}: Item Number cannot be empty`);

          if (!item.qty)
            errors.push(`Item ${index + 1}: Quantity cannot be empty`);

          if (item.qty > item.outSourceItemlimit) {
            errors.push(
              `Item ${index + 1}: Quantity exceeds limit (${item.outSourceItemlimit})`,
            );
          }
        }
      });
    }

    if (errors.length > 0) {
      show(errors.join("\n"), "warning");
      return;
    }

    setItemDetails((prev) => [
      ...prev,
      {
        ...initialItemDetails,
        _uid: genUid(),
      },
    ]);

    handleFocusNextItem();

    setTimeout(() => {
      scroll_wrapper_ref.current?.scrollBy({
        top: 100,
        behavior: "smooth",
      });
    }, 100);
  };

  const handleOpenModal = (content) => {
    setShouldFocus(false);
    setIsModalOpen(true);
    setModalContent(content);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setModalContent(null);
  };

  const handleAddReceipt = useCallback(
    async (updatedData, newOrderId, receiptId) => {
      const formData = new FormData();
      formData.append(
        "transactionScreenshot",
        updatedData.transactionScreenshot
          ? updatedData.transactionScreenshot
          : "",
      );
      formData.append(
        "paymentMethod",
        updatedData.paymentMethod ? updatedData.paymentMethod : "",
      );
      formData.append(
        "paymentType",
        updatedData.paymentType ? updatedData.paymentType : "",
      );
      formData.append(
        "paymentAmount",
        updatedData.paymentAmount
          ? parseFloat(updatedData.paymentAmount).toFixed(2)
          : "",
      );
      formData.append(
        "transactionId",
        updatedData.transactionId ? updatedData.transactionId : "",
      );
      formData.append(
        "accountNumber",
        updatedData.accountNumber ? updatedData.accountNumber : "",
      );
      formData.append(
        "warehousename",
        updatedData.warehousename ? updatedData.warehousename : "",
      );
      formData.append(
        "totalAmount",
        generalInfo.totalAmount ? generalInfo.totalAmount.toFixed(2) : "",
      );

      const orderIdentifier = newOrderId || orderId;

      try {
        const result = await handleFileData(
          `order/createReceipt/${managerId}/${orderIdentifier}?receiptId=${
            receiptId && receiptId
          }`,
          formData,
        );
        if (result.status === "success") {
          show(result.msg, "success");
          handleCloseModal();
          setTimeout(async () => {
            await fetchOrderRef.current();
          }, 0);
        }
        if (result.status === "warning") {
          setModalContent(
            <Warning
              message={result?.msg}
              items={result?.items}
              orderdItems={result?.orderdItems}
              mode={mode}
              handleCloseModal={handleCloseModal}
            />,
          );
        }
        if (result.status === "warn") {
          show(result.msg, "error");
        }
        if (result.status === "failed") {
          show(result.msg, "error");
        }
      } catch (error) {}
    },
    [generalInfo.totalAmount, managerId, mode, orderId, show],
  );

  const updateReceiptData = useCallback(
    (updatedData, newOrderId, receiptId) => {
      setReceiptData(updatedData);
      setTimeout(async () => {
        handleAddReceipt(updatedData, newOrderId, receiptId);
      }, 0);
    },
    [handleAddReceipt],
  );

  const isSelf = shippingInfo?.methodName === "Self";

  const orderSuccessKeyPress = useCallback(
    (action, oID) => {
      const whatsappNo = generalInfo?.whatsapp || "Not Provided";
      const mobileNo = generalInfo?.mobile || "Not Provided";
      const email = generalInfo?.email || "Not Provided";
      const generatedLink = paymentLink || "No Link Available";
      const newOrderId = orderId || oID || "No Order Id Available";

      if (action === "shareLink") {
        setTimeout(() => {
          handleOpenModal(
            <ShareLinkModal
              mode={mode}
              managerId={managerId}
              handleCloseModal={handleCloseModal}
              generatedLink={generatedLink}
              whatsappNo={whatsappNo}
              mobileNo={mobileNo}
              email={email}
              isModalOpen={true}
            />,
          );
        }, 0);
      } else if (action === "addReceipt") {
        setTimeout(() => {
          handleOpenModal(
            <AddReceiptModal
              handleCloseModal={handleCloseModal}
              mode={mode}
              totalAmount={generalInfo.totalAmount}
              accounts={accounts}
              receiptData={receiptData && receiptData}
              updateReceiptData={async (updatedData) =>
                updateReceiptData(updatedData, newOrderId)
              }
              type={"create"}
              isPodBlocked={isPodBlocked}
              uniqueWarehouses={uniqueWarehouses}
              dispatchWarehouse={dispatchWarehouse}
              setReceiptData={setReceiptData}
              isModalOpen={isModalOpen}
              receiptTotalAmount={receiptTotalAmount}
              isSelf={isSelf}
              orderType="Production & Sale"
            />,
          );
        }, 0);
      }
    },
    [
      generalInfo?.whatsapp,
      generalInfo?.mobile,
      generalInfo?.email,
      generalInfo.totalAmount,
      paymentLink,
      orderId,
      accounts,
      mode,
      managerId,
      receiptData,
      isPodBlocked,
      uniqueWarehouses,
      dispatchWarehouse,
      isModalOpen,
      receiptTotalAmount,
      isSelf,
      updateReceiptData,
    ],
  );

  const generatePaymentLink = useCallback(
    async (oId) => {
      setPaymentLink("");
      const currentOrderId = oId || orderId;
      if (!currentOrderId) {
        return;
      }
      try {
        const apiData = { voucherId: currentOrderId };
        const result = await fetchData("receipt/generatePaymentLink", apiData);
        if (result.status === "success" && result.shortUrl) {
          const link = `${result.shortUrl}`;
          setPaymentLink(link);
          return link;
        }
      } catch (error) {}
    },
    [orderId],
  );

  // ── Strip _uid before sending to API ──────────────────────────────────────
  const getValidSaleItems = (items) => {
    return items
      ?.filter((item) =>
        Object.values(item).some(
          (value) => value !== "" && value !== null && value !== undefined,
        ),
      )
      .map(({ _uid, ...rest }) => rest); // _uid never reaches the API
  };
  // ──────────────────────────────────────────────────────────────────────────

  // ── Build the `productionItem[]` payload expected by order/prodAndSaleVoucher ──
  // itemId is "" for a freshly added line (create), and the real server itemId
  // when the line came from an already-loaded voucher (edit).
  const buildProductionSaleItems = useCallback(() => {
    return getValidSaleItems(itemDetails).map((item, index) => ({
      itemId: item.itemId || "",
      itemNo: item.itemNo,
      itemQueue: String(index + 1),
      warehouseId: item.warehouseId || generalInfo.warehouseId || "",
      qty: String(item.qty ?? ""),
      price: String(item.price ?? ""),
      specific: item.specific || "Yes",
      unit: item.unit || "",
      batch: item.batch || "",
      desc: item.desc || "",
    }));
  }, [itemDetails, generalInfo]);
  // ──────────────────────────────────────────────────────────────────────────

  // ── Create / update the Production & Sale voucher ─────────────────────────
  const handleSaleOrder = useCallback(
    async (status, id, s) => {
      // shippingInfo is a single object now — read straight off it (or the
      // ref, if nothing was passed) instead of array/warehouse lookups.
      const shippingObj = s || shippingInfoRef.current || {};

      if (
        !shippingObj.partnerName &&
        !shippingObj.methodName &&
        !shippingObj.courierName
      ) {
        show("Delivery details are required!", "error");
        return;
      }

      const assignedManagerId = isManagerAssigned
        ? generalInfo.assignedManagerId
        : id;

      try {
        setLoadingBtn(true);
        setShowSave(false);

        const shippingCharge =
          shippingObj.methodName === "Self" ? 0 : shippingObj.shippingCharge;

        const apiData = {
          managerId: managerId,
          warehouseId:
            dispatchWarehouse?.value || generalInfo?.warehouseId || "",
          assignedManagerId: assignedManagerId || "",
          voucherId: orderId || "", // "" on create, orderId on edit
          dealerId: generalInfo.dealerId,
          name: shippingAddress.name,
          mobile: shippingAddress.mobile,
          pincode: shippingAddress.pincode,
          street: shippingAddress.street,
          city: shippingAddress.city,
          district: shippingAddress.district,
          state: shippingAddress.state,
          country: shippingAddress.country || "India",
          shippingCharge: String(shippingCharge || 0),
          toPay: generalInfo.toPay || false,
          courierName: shippingObj?.courierName || "",
          methodName: shippingObj?.methodName || "",
          partnerName: shippingObj?.partnerName || "",
          delInstruction: shippingObj?.delInstruction || "",
          priority: "",
          productionItem: buildProductionSaleItems(),
          role: designation,
          status: status,
        };

        const result = await fetchData(PROD_SALE_VOUCHER_API, apiData);

        if (result.status === "success") {
          setLoadingBtn(false);

          if (status === "success") {
            if (!orderId) {
              navigate(
                `/orders/order/productionAndSale?orderId=${
                  result.data.voucherId || result.data.orderId
                }`,
              );
            }

            fetchOrder();
            setShowSave(false);
            setIsEditMode(false);
            dispatch(setFilter({ selectedOption: "" }));
            setShowItemSearch(false);

            const oID = result.data.voucherId || result.data.orderId;

            setTimeout(async () => {
              await generatePaymentLink(oID);
              setTimeout(() => {
                handleOpenModal(
                  <OrderSuccessModal
                    mode={mode}
                    handleCloseModal={handleCloseModal}
                    orderSuccessKeyPress={(action) =>
                      orderSuccessKeyPress(action, oID)
                    }
                  />,
                );
              }, 100);
            }, 100);
          } else if (status === "draft") {
            navigate("/orders");
          }
        } else if (result.status === "assignManager") {
          setLoadingBtn(false);
          dispatch(setFilter({ selectedOption: "" }));
          setOrderManagers(result.orderManagers);
        } else {
          show(result.msg, "warning");
          setLoadingBtn(false);
        }
      } catch (error) {
        setLoadingBtn(false);
      }
    },
    [
      isManagerAssigned,
      generalInfo.assignedManagerId,
      generalInfo.dealerId,
      generalInfo.toPay,
      generalInfo?.warehouseId,
      show,
      managerId,
      orderId,
      dispatchWarehouse,
      shippingAddress,
      buildProductionSaleItems,
      designation,
      dispatch,
      navigate,
      generatePaymentLink,
      mode,
      orderSuccessKeyPress,
    ],
  );
  // ──────────────────────────────────────────────────────────────────────────

  const handleInstructionChange = useCallback((instruction) => {
    setShippingInfo((prev) => ({
      ...(prev || {}),
      delInstruction: instruction,
    }));
  }, []);

  const handleSubmit = useCallback(() => {
    handleOpenModal(
      <ConfirmOrder
        heading={"Confirm Order"}
        centerHeading={"Are you sure want to place this Order?"}
        targetWord={"order"}
        handleCloseModal={() => handleCloseModal()}
        handleSubmit={async (status, id) => {
          await handleSaleOrder(status, id, shippingInfoRef.current);
        }}
        isManagerAssigned={isManagerAssigned}
        orderManagers={orderManagers}
        handleOpenModal={handleOpenModal}
        itemDetails={itemDetails}
        setShippingInfo={setShippingInfo}
        handleInstructionChange={handleInstructionChange}
        instructions={instructions}
        setInstructions={setInstructions}
      />,
    );
  }, [
    handleInstructionChange,
    handleSaleOrder,
    instructions,
    isManagerAssigned,
    itemDetails,
    orderManagers,
  ]);

  // ── Skip shipping charges entirely → default to Self/Pick Up, single
  //    shippingInfo object (no per-warehouse entries to reset). ─────────
  const handleSkipShippingCharges = useCallback(() => {
    setShippingInfo({
      ...initialShippingDetails,
    });
    setGeneralInfo((prevState) => ({
      ...prevState,
      courierName: "Pick Up",
      toPay: false,
      deliveryPartners: { label: "Self", value: "Self" },
    }));
    setSkipped(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (skipped) {
    setTimeout(() => {
      handleSubmit();
    }, 700);
    setSkipped(false);
  }

  // ── Single-object shipping-charges-info modal: just needs the current
  //    shippingInfo object to edit — no dw / uniqueWarehouses needed. ────
  const openShippingChargesInfoModal = useCallback(
    (tempShippingInfo) => {
      handleOpenModal(
        <ProSaleShippingChargesInfoModal
          mode={mode}
          handleCloseModal={handleCloseModal}
          itemDetails={itemDetails}
          shippingInfo={tempShippingInfo || shippingInfo}
          setShippingInfo={setShippingInfo}
          ref={checkboxRef}
          generalInfo={generalInfo}
        />,
      );
    },
    [itemDetails, mode, shippingInfo, generalInfo],
  );

  const openShippingModal2 = useCallback(
    (type2) => {
      handleOpenModal(
        <ProSaleShippingChargesModal
          mode={mode}
          orderId={orderId}
          close={() => handleCloseModal()}
          skipShippingCharges={handleSkipShippingCharges}
          itemsdetails={getValidSaleItems(itemDetails)}
          isShippingBlocked={isShippingBlocked}
          pincode={shippingAddress.pincode}
          shippingInfo={shippingInfo}
          setShippingInfo={setShippingInfo}
          openShippingChargesInfoModal={openShippingChargesInfoModal}
          setGeneralInfo={setGeneralInfo}
          type2={type2}
          checkboxRef={checkboxRef}
          generalInfo={generalInfo}
        />,
      );
    },
    [
      mode,
      orderId,
      itemDetails,
      isShippingBlocked,
      shippingAddress.pincode,
      shippingInfo,
      handleSkipShippingCharges,
      openShippingChargesInfoModal,
      generalInfo,
    ],
  );

  useEffect(() => {
    if (isModalOpen && modalContent?.type === ConfirmOrder) {
      handleSubmit();
    }
  }, [handleSubmit, isModalOpen, modalContent?.type]);

  useEffect(() => {
    if (flag === "edit" || flag === "view") {
      generatePaymentLink(orderId);
    }
  }, [flag, generatePaymentLink, orderId]);

  const handleCancelOrder = async () => {
    const apiData = {
      managerId: managerId,
      voucherId: orderId,
    };
    try {
      const result = await fetchData("order/CancelVoucher", apiData);
      if (result.status === "success") {
        show("Order cancelled successfully", "success");
        navigate("/orders");
      }
    } catch (error) {
      show(error, "error");
    }
  };

  const handleRequestForCancel = async (reason, warehouseId) => {
    const apiData = {
      managerId: managerId,
      orderId: orderId,
      reqType: "Request For Cancel",
      reqIssue: reason,
      warehouseId: warehouseId,
    };
    try {
      const result = await fetchData("order/orderhelp", apiData);
      if (result.status === "success") {
        show(result.msg, "success");
        navigate("/orders");
      } else {
        show(result.msg, "warning");
      }
    } catch (error) {
      show(error, "error");
    }
  };

  const openCancelOrderModal = () => {
    handleOpenModal(
      <ManagerModal
        heading={"Cancel Order"}
        centerHeading={"Are you sure want to cancel this Order?"}
        subHeading={"To confirm! type cancel in the text field."}
        targetWord={"cancel"}
        handleCloseModal={() => handleCloseModal()}
        handleSubmit={() => handleCancelOrder()}
        focus={true}
      />,
    );
  };

  const openRequestForCancelModal = () => {
    handleOpenModal(
      <RequestForCancelModal
        mode={mode}
        handleCloseModal={() => handleCloseModal()}
        handleSubmit={(reason, warehouseId) =>
          handleRequestForCancel(reason, warehouseId)
        }
        type="order"
        uniqueWarehouses={uniqueWarehouses}
      />,
    );
  };

  // ── Single warehouse per voucher now — no more per-warehouse routing. ──
  const dispatchDetailsClick = () => {
    navigate(
      "/dispatch/prodAndSaleDetails/" +
        orderId +
        "/" +
        (dispatchWarehouse?.value || generalInfo?.warehouseId || ""),
    );
  };

  useEffect(() => {
    itemInpRefs.current = Array(itemDetails.length)
      .fill()
      .map((_, i) => itemInpRefs.current[i] || null);
  }, [itemDetails.length]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Tab") {
        event.preventDefault();
      }

      if (loadingBtn) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (flag === "edit" && !isModalOpen) {
        const isInputFocused = ["INPUT", "TEXTAREA", "SELECT"].includes(
          document.activeElement.tagName,
        );
        if (
          !isInputFocused &&
          generalInfo.orderType !== "online" &&
          event.key.toLowerCase() === "e"
        ) {
          event.preventDefault();
          editBtnClick();
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown, true);

    return () => {
      window.removeEventListener("keydown", handleKeyDown, true);
    };
  }, [editBtnClick, flag, isModalOpen, loadingBtn, generalInfo.orderType]);

  useEffect(() => {
    if (!itemDetails || itemDetails.length === 0) return;

    const amount = itemDetails.reduce((sum, item) => {
      if (item.amount && !isNaN(item.amount)) {
        return sum + parseFloat(item.amount);
      }
      return sum;
    }, 0);

    const cartPriceSum = itemDetails.reduce((sum, currentItem) => {
      return (
        sum +
        parseFloat(currentItem.price ?? 0) * parseFloat(currentItem.qty ?? 0)
      );
    }, 0);

    const cartTotal = itemDetails
      .map((x) =>
        !x.accessories
          ? 0
          : x.accessories
              .map((y) => (y.accessoriesQty ?? 0) * (y.accessoriesPrice ?? 0))
              .reduce((a, b) => a + b, 0),
      )
      .reduce((a, b) => a + b, 0);

    const subtotal = (cartPriceSum ?? 0) + (cartTotal ?? 0);

    const gettotalAmount =
      subtotal +
      parseFloat(
        generalInfo.toPay
          ? 0
          : shippingInfo?.methodName === "Self"
            ? 0
            : (generalInfo.shippingCharge ?? 0),
      );

    const totalAmount = Math.round(gettotalAmount);

    setGeneralInfo((prev) => ({
      ...prev,
      amount,
      cartPriceSum,
      cartTotal,
      subtotal,
      totalAmount,
    }));
  }, [
    itemDetails,
    generalInfo.toPay,
    generalInfo.shippingCharge,
    shippingInfo?.methodName,
  ]);

  useEffect(() => {
    const { totalAmount } = receipts.reduce(
      (acc, receipt) => {
        if (receipt.status === "Received") {
          acc.totalAmount += receipt.paymentAmount;
        }
        if (receipt.status === "Cancelled") {
          acc.cancelledAmount += receipt.paymentAmount;
        }
        return acc;
      },
      { totalAmount: 0, cancelledAmount: 0 },
    );

    setReceiptTotalAmount(totalAmount);
  }, [receipts]);

  const allReceived = receipts.every(
    (receipt) => receipt.status === "Received",
  );

  const hasPod = receipts.some((receipt) => receipt.status === "POD Pending");

  const shouldShowRequestForCancel =
    orderId &&
    ["Packing In Progress", "Packed", "Dispatched"].includes(
      generalInfo.status,
    ) &&
    generalInfo.status !== "Cancelled" &&
    generalInfo.reqType !== "Request For Cancel";

  const shouldShowCancelOrder =
    orderId &&
    ["Payment Pending", "Payment Under Verification"].includes(
      generalInfo.status,
    ) &&
    generalInfo.status !== "Cancelled" &&
    generalInfo.reqType !== "Request For Cancel";

  const hasDispatchedOrCompleted =
    allOrdersData?.voucher?.dispatchStatus === "Completed" ||
    allOrdersData?.voucher?.dispatchStatus === "Dispatched";

  useEffect(() => {
    onOrderData({
      loading,
      orderId,
      type: generalInfo.orderType,
      status: generalInfo.status,
      orderManagerName: generalInfo.orderManagerName,
      createdBy: generalInfo.createdBy,
      orderDate: generalInfo.orderDate,
    });
  }, [
    generalInfo.createdBy,
    generalInfo.orderDate,
    generalInfo.orderManagerName,
    generalInfo.orderType,
    generalInfo.status,
    loading,
    onOrderData,
    orderId,
  ]);

  const verifyEntries = () => {
    const warnings = [];
    if (
      itemDetails.every(
        (item) =>
          item.amount === "" &&
          item.price === "" &&
          item.unit === "" &&
          item.qty === "" &&
          item.itemNo === "",
      ) ||
      itemDetails.some((item) =>
        Object.values(item).every((value) => value === ""),
      )
    ) {
      warnings.push("Item Details are required");
    }
    if (warnings?.length === 0) {
      return true;
    } else {
      show(warnings.join(" "), "warning");
      return false;
    }
  };

  const totalShippingCharges = shippingInfo?.shippingCharge;

  useEffect(() => {
    setGeneralInfo((prev) => ({
      ...prev,
      shippingCharge: totalShippingCharges,
    }));
  }, [totalShippingCharges]);

  const isLiveEditingItems =
    flag === "create" || (flag === "edit" && isEditMode);
  const headerData = useMemo(() => {
    const base = [
      "S.No",
      "Item No",
      "Product",
      "Collection",
      "Quantity",
      "Unit",
      "Rate",
      "Amount",
    ];
    const action = !isLiveEditingItems && selectedVersion ? ["Action"] : [];
    return [...base, ...action];
  }, [isLiveEditingItems, selectedVersion]);

  const printSummarySlip = useReactToPrint({
    content: () => summarySlipRef.current,
  });

  const handlePrintSummary = async () => {
    await fetchOrder();
    setTimeout(() => {
      printSummarySlip();
    }, 300);
  };

  const openAdvancePaymentInfoModal = (data) => {
    handleOpenModal(<AdvanceAmountModalInfo mode={mode} data={data} totalAmount={generalInfo?.totalAmount}/>);
  };

  const displayedItems = useMemo(() => {
    if (isLiveEditingItems) return itemDetails;
    if (selectedVersion) {
      const entry = versionsData.find((v) => v.version === selectedVersion);
      return (entry?.items || []).map((change) => ({
        _uid: change.itemId + "-" + change.version,
        itemId: change.itemId,
        action: change.action,
        updatedBy: change.updatedBy,
        updateTime: change.updateTime,
        changes: change.changes || [],
        ...change.data,
      }));
    }
    return itemDetails;
  }, [isLiveEditingItems, selectedVersion, versionsData, itemDetails]);

  const hasVersionHistory = versionsData?.length > 0;

  // ────────────────────────────────────────────────────────────────────────

  return (
    <>
      <ModalWrapper isOpen={isModalOpen} onClose={handleCloseModal} noBtn>
        {modalContent}
      </ModalWrapper>

      <div className={styles.so_scroll_wrapper} ref={scroll_wrapper_ref}>
        <form className={styles.so_form}>
          <div className={styles.so_form_1}>
            {loading && (flag === "edit" || flag === "view") ? (
              <div>
                <Skeleton
                  lines={1}
                  thickness={4.5}
                  additionalStyles={{
                    marginBottom: "0px",
                    marginTop: "20px",
                  }}
                />
              </div>
            ) : (
              <div style={{ position: "relative" }}>
                <InputTag
                  ref={dealerInpRef}
                  labelText={"Company or Dealer's Name / ID"}
                  placeholderText={"Search Dealer"}
                  padding={"8px"}
                  fontSize={"12px"}
                  value={
                    useFallback && !searchDealer
                      ? generalInfo.storeName && generalInfo.dealerName
                        ? `${generalInfo.storeName} / ${generalInfo.dealerName}`
                        : generalInfo.storeName || generalInfo.dealerName || ""
                      : searchDealer
                  }
                  onChange={(e) => {
                    setSearchDealer(e.target.value);
                    setUseFallback(false);
                  }}
                  onFocus={() => {
                    if (flag === "create") {
                      setShowDealerSearch(true);
                    }
                  }}
                  onBlur={() => {
                    setShowDealerSearch(false);
                    if (searchDealer === "") {
                      setUseFallback(true);
                    }
                  }}
                  onKeyDown={(e) => handleDealerKeyDown(e)}
                  maxLength={100}
                  required
                  enterKeyHint={"enter"}
                  readOnly={flag === "view"}
                />

                {showDealerSearch && (
                  <SearchDealer
                    mode={mode}
                    results={dealerResults}
                    loading={dealerLoading}
                    currentIndex={currentIndex}
                    onDealerSelect={handleSelectDealer}
                    openAddDealerModal={openAddDealerModal}
                  />
                )}
              </div>
            )}

            {loading && (flag === "edit" || flag === "view") ? (
              <div>
                <Skeleton
                  lines={1}
                  thickness={4.5}
                  additionalStyles={{
                    marginBottom: "0px",
                    marginTop: "20px",
                  }}
                />
              </div>
            ) : (
              <div>
                <InputTag
                  labelText={"Shipping Address"}
                  placeholderText={"Enter Dealer Address"}
                  value={
                    [
                      shippingAddress.street,
                      shippingAddress.city,
                      shippingAddress.district,
                      shippingAddress.state,
                      shippingAddress.pincode,
                    ]
                      .filter(Boolean)
                      .join(" ") || ""
                  }
                  padding={"8px"}
                  fontSize={"12px"}
                  required
                />
              </div>
            )}
          </div>

          <div className={styles.so_form_1}>
            <div>
              {loading && (flag === "edit" || flag === "view") ? (
                <div style={{ width: "100%" }}>
                  <Skeleton
                    lines={1}
                    thickness={4.5}
                    additionalStyles={{
                      marginBottom: "0px",
                      marginTop: "20px",
                    }}
                  />
                </div>
              ) : (
                <div className={styles.warehouse_selectors}>
                  <div
                    style={{
                      width: "100%",
                      position: "relative",
                    }}
                  >
                    <div>
                      <InputTag
                        labelText={"Warehouse"}
                        placeholderText={"Warehouse"}
                        padding={"8px"}
                        fontSize={"12px"}
                        value={
                          generalInfo?.warehousename ||
                          dispatchWarehouse?.label ||
                          ""
                        }
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>

            {loading && (flag === "edit" || flag === "view") ? (
              <div>
                <Skeleton
                  lines={1}
                  thickness={4.5}
                  additionalStyles={{
                    marginBottom: "0px",
                    marginTop: "20px",
                  }}
                />
              </div>
            ) : (
              <div>
                <div style={{ width: "100%", position: "relative" }}>
                  <div className={styles.voucher_det}>
                    <p style={{ color: mode && "#FFFFFF" }}>
                      {shippingInfo?.courierName}
                    </p>
                  </div>

                  <div>
                    <InputTag
                      labelText={"Delivery Method"}
                      placeholderText={"Delivery Method"}
                      padding={"8px"}
                      fontSize={"12px"}
                      value={
                        shippingInfo?.methodName || shippingInfo?.partnerName
                      }
                    />
                  </div>

                  {isEditMode && (
                    <div className={styles.change_ship}>
                      <span
                        style={{ color: !mode && "#4164E3" }}
                        onClick={() => openShippingModal2("")}
                      >
                        Update
                      </span>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </form>

        {/* ------------------------- Version History -------------------------- */}

        {!isLiveEditingItems && hasVersionHistory && (
          <div
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "row",
              marginTop: "10px",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <span
                style={{ fontSize: 14, color: mode ? "#ffffff" : "#000000" }}
              >
                Version History
              </span>

              <SlidingFilter
                itemList={[
                  "Current",
                  ...[...versionsData]
                    .sort((a, b) => b.version - a.version)
                    .map((v) => `Version ${v.version}`),
                ]}
                activeFilter={
                  selectedVersion ? `Version ${selectedVersion}` : "Current"
                }
                setFilter={(label) =>
                  setSelectedVersion(
                    label === "Current"
                      ? null
                      : Number(label.replace("Version ", "")),
                  )
                }
              />
            </div>

            {selectedVersion &&
              (() => {
                const entry = versionsData.find(
                  (v) => v.version === selectedVersion,
                );
                if (!entry) return null;
                const { updatedBy, updateTime } = getVersionMeta(entry);
                return (
                  <div
                    style={{
                      fontSize: 12,
                      color: "#4164E3",
                      fontWeight: 600,
                    }}
                  >
                    {updatedBy}
                    {" • "}
                    {formatDateTime(updateTime)}
                  </div>
                );
              })()}
          </div>
        )}
        {/* ----------------------------------------------------------------------- */}

        <ul className={styles.p_table}>
          <div
            className={styles.p_table_header_con}
            style={{
              visibility: loading && "hidden",
            }}
          >
            <li
              className={`${styles.p_table_header} ${
                mode ? styles.p_table_header_dark : ""
              }`}
            >
              {headerData?.map((h, index) => (
                <div className={styles.entry_2} key={`${h}-${index}`}>
                  {h}
                </div>
              ))}
            </li>
            {(flag === "create" || isEditMode) && itemDetails?.length > 1 && (
              <div
                style={{
                  visibility: "hidden",
                  display: flag === "view" && "none",
                }}
              >
                <RemoveIcon />
              </div>
            )}
          </div>

          <div className={styles.p_table_list}>
            <>
              {displayedItems?.map((item, index) => (
                // ── Use _uid as key so removing an item never shifts
                //    React component instances or their local state ──────
                <React.Fragment key={item._uid ?? `${item.itemNo}-${index}`}>
                  {isLiveEditingItems ? (
                    <ProductionSaleNewItemList
                      mode={mode}
                      index={index}
                      item={item}
                      itemInpRefs={(el) => {
                        if (el) itemInpRefs.current[index] = el;
                      }}
                      quantityRefs={qtyInputRefs}
                      onItemChange={(field, value) =>
                        handleItemChange(index, field, value)
                      }
                      onRemove={() => removeItem(index)}
                      onAddNewItem={handleAddNewItem}
                      itemDetailsLength={itemDetails.length}
                      itemFocus={handleItemInputFocus}
                      itemBlur={handleItemInputBlur}
                      focusedItemIndex={focusedItemIndex}
                      showItemSearch={showItemSearch}
                      setShowItemSearch={setShowItemSearch}
                      onShowDesc={(value) => setShowDescriptionInput(value)}
                      onCompletion={() => {
                        // ── Single-warehouse model: open the shipping
                        //    modal once items exist AND a warehouse has
                        //    been picked for the voucher. ─────────────
                        const canOpen =
                          itemDetails.length > 0 && generalInfo?.warehouseId;

                        if (canOpen) {
                          openShippingModal2("normal");
                        }
                      }}
                      flag={flag}
                      allItems={displayedItems}
                      setDispatchWarehouse={setDispatchWarehouse}
                      setGeneralInfo={setGeneralInfo}
                      generalInfo={generalInfo}
                    />
                  ) : (
                    <>
                      {loading ? (
                        <div>
                          <Skeleton
                            lines={
                              displayedItems?.length === 1
                                ? 1
                                : displayedItems?.length / 2
                            }
                            thickness={5}
                            additionalStyles={{
                              marginBottom: "0px",
                              marginTop: "0px",
                            }}
                          />
                        </div>
                      ) : (
                        <DataItemListProAndSale
                          d={item}
                          index={index}
                          mode={mode}
                          voucherType={"Production & Sale"}
                          selectedVersion={selectedVersion}
                          isLiveEditingItems={isLiveEditingItems}
                        />
                      )}
                    </>
                  )}
                </React.Fragment>
              ))}
            </>
          </div>

          {(flag === "create" || isEditMode) && (
            <div
              className={styles.cricle_btn}
              onClick={() => {
                handleAddNewItem();
              }}
            >
              <TestTopAddDealerIcon color="#4164E3" />
            </div>
          )}

          {showDescriptionInput && (flag === "create" || flag === "edit") && (
            <div className={styles.so_instc}>
              <p>Press Enter to Add Item</p>
              <DividerIcon />
              <p>Double Enter for Next Option</p>
              <DividerIcon />
              <p>Ctrl + Backspace for Remove Item</p>
            </div>
          )}
        </ul>
      </div>

      {loading ? (
        <div
          style={{ padding: "0", boxShadow: "none" }}
          className={`${styles.so_footer} ${mode ? styles.so_footer_dark : ""}`}
        >
          <Skeleton
            lines={1}
            thickness={5}
            additionalStyles={{
              marginBottom: "0px",
              marginTop: "0px",
              borderRadius: "15px 15px 0 0",
            }}
          />
        </div>
      ) : (
        <div
          className={`${styles.so_footer} ${mode ? styles.so_footer_dark : ""}`}
        >
          {(flag === "edit" || flag === "view") && (
            <div className={styles.so_footer_left}>
              <div
                className={`${styles.so_receipt_data} ${
                  mode ? styles.so_receipt_data_dark : ""
                }`}
              >
                <div
                  className={`${styles.so_receipt_data_header} ${
                    mode ? styles.so_receipt_data_header_dark : ""
                  }`}
                  style={{ cursor: "auto" }}
                >
                  <div className="col">Receipt ID</div>
                  <div className="col">Method</div>
                  <div className="col">Amount</div>
                  <div className="col">Status</div>
                </div>
                <div
                  className={styles.scroll_con}
                  style={{ display: receipts?.length === 0 && "none" }}
                >
                  {receipts?.length !== 0 &&
                    receipts?.map((r, index) => (
                      <div
                        className={`${styles.so_receipt_data_entry} ${
                          mode ? styles.so_receipt_data_entry_dark : ""
                        }`}
                        key={index}
                        onClick={() => {
                          handleOpenModal(
                            <AddReceiptModal
                              handleCloseModal={handleCloseModal}
                              mode={mode}
                              totalAmount={generalInfo.totalAmount}
                              accounts={accounts}
                              receiptData={r}
                              updateReceiptData={async (updatedData) =>
                                updateReceiptData(
                                  updatedData,
                                  orderId,
                                  r.receiptId,
                                )
                              }
                              type={"create"}
                              flag={"notupdateamount"}
                              uniqueWarehouses={uniqueWarehouses}
                              dispatchWarehouse={dispatchWarehouse}
                              setReceiptData={setReceiptData}
                              isModalOpen={isModalOpen}
                              receiptTotalAmount={receiptTotalAmount}
                              isSelf={isSelf}
                              orderType="Production & Sale"
                            />,
                          );
                        }}
                      >
                        <div className="col" key={index + r.receiptId}>
                          {r.receiptId}
                        </div>
                        <div className="col" key={index + r.paymentMethod}>
                          {r.paymentMethod}
                        </div>
                        <div className="col" key={index + r.paymentAmount}>
                          {r.paymentAmount}
                        </div>
                        <div
                          className="col"
                          key={index + r.status}
                          style={{ color: getStatusColor(r.status) }}
                        >
                          {r.status}
                        </div>
                      </div>
                    ))}
                </div>
              </div>

              {(receiptTotalAmount < generalInfo.totalAmount ||
                hasPod ||
                !allReceived) && (
                <div
                  className={styles.add_receipt_btn}
                  onClick={() => {
                    orderSuccessKeyPress("addReceipt");
                  }}
                >
                  <TestTopAddDealerIcon />
                </div>
              )}

              {allOrdersData?.voucher?.paymentStatus && (
                <div>
                  <p
                    style={{
                      color:
                        allOrdersData?.voucher?.paymentStatus === "Received"
                          ? "#297038"
                          : "#f11717",
                    }}
                  >
                    {allOrdersData?.voucher?.paymentStatus}
                  </p>
                </div>
              )}
            </div>
          )}

          <div className={styles.so_footer_right}>
            <div className={styles.right_btns}>
              {(flag === "edit" || flag === "view") && (
                <MoreDropdown
                  mode={mode}
                  onSummaryClick={handlePrintSummary}
                  onSlipClick={() => {
                    show("Coming soon...");
                  }}
                />
              )}

              {shouldShowRequestForCancel && (
                <Button
                  buttonIcon={<CancelIcon2 />}
                  buttonText={"Request for Cancel"}
                  buttonBgColor={"#000000"}
                  buttonTextColor={"#ffffff"}
                  buttonBorder={"none"}
                  buttonClick={openRequestForCancelModal}
                />
              )}

              {shouldShowCancelOrder && (
                <Button
                  buttonIcon={<CancelIcon2 />}
                  buttonText={"Cancel Order"}
                  buttonBgColor={"#000000"}
                  buttonTextColor={"#ffffff"}
                  buttonBorder={"none"}
                  buttonClick={openCancelOrderModal}
                />
              )}

              {(flag === "edit" || flag === "view") && (
                <Button
                  buttonIcon={<NewEyeIcon />}
                  buttonText={"Invoice"}
                  buttonBgColor={"#000000"}
                  buttonTextColor={"#ffffff"}
                  buttonBorder={"none"}
                  buttonClick={() =>
                    navigate("/orders/saleinvoice?orderId=" + orderId)
                  }
                />
              )}

              {hasDispatchedOrCompleted && (
                <Button
                  buttonIcon={<NewEyeIcon />}
                  buttonText={"Dispatch Details"}
                  buttonBgColor={"#000000"}
                  buttonTextColor={"#ffffff"}
                  buttonBorder={"none"}
                  buttonClick={dispatchDetailsClick}
                />
              )}

              {(flag === "edit" || flag === "view") &&
                generalInfo.status !== "Cancelled" &&
                generalInfo.reqType !== "Request For Cancel" && (
                  <Button
                    buttonIcon={<ShareIcon />}
                    buttonText={"Share"}
                    buttonBgColor={"#4164E3"}
                    buttonTextColor={"#ffffff"}
                    buttonBorder={"none"}
                    buttonClick={() => orderSuccessKeyPress("shareLink")}
                  />
                )}
            </div>

            <div
              className={`${styles.so_amount_info} ${
                mode ? styles.so_amount_info_dark : ""
              }`}
            >
              <div>
                <p>Sub Total:</p>
                <p>₹ {generalInfo.subtotal}</p>
              </div>

              <div className={styles.so_shipping}>
                <p>Shipping Charges:</p>{" "}
                <div className={styles.info_btn_con}>
                  <span
                    className={styles.info_btn}
                    onClick={() => openShippingChargesInfoModal(shippingInfo)}
                  >
                    <InfoRounded color={mode ? "#FFFFFF" : "#1C274C"} />
                  </span>
                </div>
                <input
                  type="number"
                  value={
                    (shippingInfo?.methodName === "Self"
                      ? 0
                      : generalInfo.shippingCharge
                    )
                      ?.toString()
                      .replace(/^0+/, "") || 0
                  }
                  onChange={(e) => {
                    let value = Number(e.target.value);
                    if (value > 0) {
                      setGeneralInfo((prevState) => ({
                        ...prevState,
                        shippingCharge: value,
                      }));
                      setShippingInfo((prev) => ({
                        ...(prev || {}),
                        shippingCharge: value,
                      }));
                    } else {
                      setGeneralInfo((prevState) => ({
                        ...prevState,
                        shippingCharge: -1 * value,
                      }));
                      setShippingInfo((prev) => ({
                        ...(prev || {}),
                        shippingCharge: -1 * value,
                      }));
                    }
                  }}
                  readOnly={!isNoCase || flag === "view"}
                  maxLength="10"
                  onInput={(e) =>
                    (e.target.value = e.target.value.slice(0, 10))
                  }
                  style={mode ? { color: "#fff" } : {}}
                  ref={shippingRef}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      checkboxRef.current?.focus();
                    }
                  }}
                />
                <div className={styles.so_check}>
                  <p>To Pay</p>
                  <input
                    type="checkbox"
                    checked={generalInfo.toPay}
                    onChange={(e) => {
                      const isChecked = e.target.checked;

                      if (
                        isChecked &&
                        isNoCase &&
                        generalInfo.shippingCharge === 0
                      ) {
                        e.preventDefault();
                        show(
                          "Update shipping charges to check To Pay!",
                          "warning",
                        );
                        return;
                      }

                      setGeneralInfo((prevState) => ({
                        ...prevState,
                        toPay: isChecked,
                      }));
                    }}
                    ref={checkboxRef}
                    disabled={
                      flag === "view" || (flag === "edit" && !isEditMode)
                    }
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSubmit();
                      }
                    }}
                  />
                </div>
                <p>
                  {loadingBtn ? (
                    <Spinner
                      borderWidth={"1px"}
                      height={10}
                      width={10}
                      color={mode ? "#000000" : "#4164E3"}
                    />
                  ) : (
                    <>
                      ₹{" "}
                      {shippingInfo?.methodName === "Self"
                        ? 0
                        : generalInfo.shippingCharge}
                    </>
                  )}
                </p>
              </div>

              <div>
                <p>
                  Total Amount(INR):{" "}
                  {receipts?.length > 0 && (
                    <span
                      className={styles.info_btn}
                      onClick={() => openAdvancePaymentInfoModal(receipts)}
                    >
                      <InfoRounded color={mode ? "#FFFFFF" : "#1C274C"} />
                    </span>
                  )}
                </p>

                <p>
                  {loadingBtn ? (
                    <Spinner
                      borderWidth={"1px"}
                      height={10}
                      width={10}
                      color={mode ? "#000000" : "#4164E3"}
                    />
                  ) : (
                    <>₹ {Number(generalInfo.totalAmount) || 0}</>
                  )}
                </p>
              </div>
            </div>

            {flag === "edit" && (
              <div>
                {isEditMode ? (
                  <>
                    {showSave ? (
                      <Button
                        buttonIcon={<SaveIcon />}
                        buttonText={"Save"}
                        buttonBgColor={"#4164E3"}
                        buttonTextColor={"#FFFFFF"}
                        buttonBorder={"none"}
                        buttonClick={() => {
                          if (verifyEntries()) {
                            handleSubmit();
                          }
                        }}
                      />
                    ) : (
                      <div className={styles.flex}>
                        <Button
                          buttonIcon={<CancelIcon2 />}
                          buttonText={"Cancel"}
                          buttonBgColor={"#000000"}
                          buttonTextColor={"#ffffff"}
                          buttonBorder={"none"}
                          buttonClick={() => setIsEditMode(false)}
                          loading={loadingBtn}
                        />
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    {!selectedVersion && generalInfo.orderType !== "online" && (
                      <Button
                        buttonIcon={<EditManagerIcon />}
                        buttonText={"Edit"}
                        buttonBgColor={"#4164E3"}
                        buttonTextColor={"#FFFFFF"}
                        buttonBorder={"none"}
                        buttonClick={editBtnClick}
                      />
                    )}
                  </>
                )}
              </div>
            )}

            {flag === "create" && (
              <div>
                {showSave && (
                  <Button
                    buttonIcon={<SaveIcon />}
                    buttonText={"Save"}
                    buttonBgColor={"#4164E3"}
                    buttonTextColor={"#FFFFFF"}
                    buttonBorder={"none"}
                    buttonClick={() => {
                      if (verifyEntries()) {
                        handleSubmit();
                      }
                    }}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      )}

      {/* ------------ Summary Slip ------------------- */}
      <div style={{ display: "none" }}>
        <NewSummarySlip
          ref={summarySlipRef}
          summarySlipData={itemDetails}
          generalInfo={allOrdersData?.voucher}
        />
      </div>
    </>
  );
};

export default ProductionSale;
